import React, { useEffect, useRef, useState } from "react";
import Accordion from "react-bootstrap/Accordion";
import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";
// import loader from '../../assets/images/common/loader.gif';
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  EDIT_OBJECT,
  GLOBAL_SEARCH,
  LIST_CATEGORY,
  LIST_LOCATION,
  LIST_MATERIAL,
  lIST_NOTIFICATION,
  LIST_OBJECT,
  OBJECT_PIN,
  QR_LOCATION_MANAGMENT,
} from "../../constants/routers";
import { useFormik } from "formik";
import {
  addPinObject,
  assignUser,
  cancelSession,
  createObject,
  createSession,
  deletePinObject,
  getSingleObject,
  listObjectDropdown,
  nextAndPreviousHandler,
} from "../../api/actions/object";
import toast from "react-hot-toast";
import { GoArrowLeft } from "react-icons/go";
import upload from "../../assets/images/common/add-image.png";
import replace from "../../assets/images/category/replace.png";
import AsyncSelect from "react-select/async";
import Chip from "@mui/material/Chip";
import Tooltip from "@mui/material/Tooltip";
import { IoMdClose } from "react-icons/io";
import { listMaterialDropdown } from "../../api/actions/material";
import {
  getSingleCategory,
  listCategoryDropdown,
  listSubCategoryDropdown,
} from "../../api/actions/category";
import * as Yup from "yup";
import { RiCloseFill, RiVipCrownFill } from "react-icons/ri";
import { listBuildingDropdown } from "../../api/actions/building";
import { storageUnitDropdown } from "../../api/actions/rack";
import notFound from "../../assets/images/common/image-not-found.png";
import { CiCircleMinus } from "react-icons/ci";
import { listFloorDropdown } from "../../api/actions/floor";
import { listRoomDropdown } from "../../api/actions/room";
import { listshelfDropdown } from "../../api/actions/shelf";
import Loader from "../../components/common/Common/Loader";
import Select from "react-select";
import "./object.scss";
import Commentdrawer from "./commentdrawer";
import { RiHistoryLine } from "react-icons/ri";
import { TbMessageCircleCheck } from "react-icons/tb";
import {
  addItemToDB,
  clearPendingRequests,
  getPendingRequests,
} from "../../indexdb/indexdb";
import SimpleBackdrop from "../../components/common/Common/Buttonloader";
import Objecthistorydrawer from "./Objecthistorydrawer";
import { FaSleigh, FaTrashAlt } from "react-icons/fa";
import { RiInformation2Fill } from "react-icons/ri";
import start from "../../assets/images/category/star.png";
import { listUserDropdown, usedLastScreen } from "../../api/actions/user";
import {
  autoSaveToIndexedDB,
  clearAutoSavedFromIndexedDB,
} from "../../indexdb/autosaveIndex";
import { HiOutlinePlus } from "react-icons/hi";
import ImageEnlarge from "../../components/common/Common/imageEnlarge";
import "../../pages/objectPhotography/Objectphotography.scss";
import { AsyncPaginate } from "react-select-async-paginate";
import { createPortal } from "react-dom";
import axiosInstance from "../../api/axiosInstance";
import { reactLocalStorage } from "reactjs-localstorage";
import OverRideAlert from "../../components/common/sweetAlert/overRideAlert";
import { LuPin, LuPinOff } from "react-icons/lu";
import {
  GrFormNextLink,
  GrLinkNext,
  GrLinkPrevious,
  GrNext,
} from "react-icons/gr";
import { ObjectEditsaving } from "../../store/objectEditdataContext";
import UsedObject from "../category/usedObject";
import { subcategoryLoadOptionHandler } from "../../components/common/Common/loadOptionHandlers";
import ReactImageMagnify from "react-image-magnify";
import "../../components/common/Common/imageEnlarge.scss";
import { checkPermission } from "../../helpers/permissions";
import "./objectadd.scss";

const ObjectAdd = ({
  isAutoObjectList,
  onCloseObject,
  fromList = false,
  objectId = "",
}) => {
  const [material, setMaterial] = useState([]);
  const [defaultMaterial, setDefaultMaterial] = useState([]);
  const [draftLoad, setDraftLoad] = useState(false);
  const [category, setCatgory] = useState([]);
  const [savedFormikData, setSavedFormikData] = useState(null);
  const [defaultcategory, setdefaultCateory] = useState([]);
  const [defaultSubcategory, setdefaulSubtCateory] = useState([]);
  const [update, setUpdate] = useState(false);
  const [subCategory, setSubcategory] = useState([]);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [inputValueObject, setInputValueObject] = useState("");
  const [descriptorsData, setDescriptorsdata] = useState([]);
  const [newValue, setNewValue] = useState();
  const locationState = useLocation();
  const [enteredValue, setEnteredValue] = useState("");
  const [isOverRide, setIsOverRide] = useState(false);
  const [savedDataOverRide, setSavedDataOverRide] = useState();
  const [enteredFunction, setEnteredFunction] = useState("");
  const [showReference, setShowReference] = useState(false);
  const [isSameLocation, setIsSameLocation] = useState(false);
  const [isAutosave, setIsAutoSave] = useState(false);
  const [nextId, setNextId] = useState();
  const [oveRideFromNext, setOverRideFromNext] = useState(false);
  const [isDetailsOver, setdSetailsOver] = useState(false);
  const [oveRideFromPrevious, setOverRideFromPrevious] = useState(false);
  const [previousId, setPreviousId] = useState();
  const [showLocationLabel, setShowLocationLabel] = useState(false);
  const [hasLetter, sethasletter] = useState({
    numberOfParts: false,
    numberOfMissing: false,
    pageNumber: false,
  });
  const [showImageEnlarge, setShowEnlargeImage] = useState({
    parentIndex: "",
    childIndex: "",
    imageIndex: "",
    imageIdTitle: "",
    image: "",
    show: false,
    title: "",
    isEdit: false,
  });
  const [user, setUser] = useState([]);
  const [defaultUser, setDefaultUser] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const [selectedAttribute, setSelectedAttribute] = useState([]);
  const [fromNotification] = useState(
    locationState.state?.fromNotification || false
  );
  const params = new URLSearchParams(window.location.search);
  const encodedState = params.get("state");
  const stateObj = encodedState ? JSON.parse(atob(encodedState)) : null;
  const objectListFormik = locationState?.state?.objectListFormik
    ? locationState?.state?.objectListFormik
    : stateObj
    ? stateObj
    : "";

  const fromUsedObject = locationState?.state?.fromUsedObject;
  const fromLocation = locationState?.state?.fromLocation;
  const floorPlanObjectId = locationState?.state?.floorPlanObjectId;
  const locationType = locationState?.state?.locationType;

  const fromCategory = locationState?.state?.fromCategory;
  const fromMaterial = locationState?.state?.fromMaterial;
  const fromGlobalOpen = params.get("fromGlobalOpen");
  const fromGlobal = locationState?.state?.fromGlobal
    ? locationState?.state?.fromGlobal
    : fromGlobalOpen
    ? fromGlobalOpen
    : "";

  const [showStorageOriginal, setShowStorageOriginal] = useState({
    sytemType: false,
    unitType: false,
  });
  const [showStorageTransit, setShowStorageTransit] = useState({
    sytemType: false,
    unitType: false,
  });
  const [locationOriginalValue, setLocationOriginalValue] = useState({
    building: null,
    floor: null,
    room: null,
    systemtype: null,
    unitType: null,
  });
  const [locationTransitValue, setLocationTransitValue] = useState({
    building: null,
    floor: null,
    room: null,
    systemtype: null,
    unitType: null,
  });
  const [locationTransit, setLocationTransit] = useState({
    building: [],
    floor: [],
    defaultfloor: [],
    room: [],
    systemtype: [],
    unitType: [],
  });
  const [location, setLocation] = useState({
    building: [],
    floor: [],
    defaultfloor: [],
    room: [],
    systemtype: [],
    unitType: [],
  });
  const [locationTransitId, setLocationTransitId] = useState({
    building: "",
    floor: "",
    room: "",
    systemtype: "",
    unitType: "",
  });
  const [locationId, setLocationId] = useState({
    building: "",
    floor: "",
    room: "",
    systemtype: "",
    unitType: "",
  });
  const [draft, setDraft] = useState(false);
  const [loading, setLoading] = useState();
  const [nextAndPreviousLoad, setNextAndPreviousLoad] = useState({
    next: false,
    previous: false,
  });
  const navigate = useNavigate();
  const [locationLabel, setLocationLabel] = useState("");
  const [orginlabel, setOrginlabel] = useState();
  const [submitLoader, setsubmitLoader] = useState(false);
  const [transitLoca, setTransitLoc] = useState("");
  const [progressCount, setProgressCount] = useState(0);
  const [buttonloader, setButtonloader] = useState(false);
  const [isOverideLoad, setIsOverRideLoad] = useState(false);
  const [removedLocation, setRemovedLocation] = useState([]);
  const [currentTransit, setCurrentTransit] = useState();
  const [categoryDetails, setCategoryDetails] = useState([]);
  const [currentOriginal, setCurrentOriginal] = useState();
  const [fetchCode, setFetchCode] = useState({
    building: "",
    floor: "",
    room: "",
    storageSystem: "",
    storageUnit: "",
  });
  const [fetchOriginalCode, setFetchOriginalCode] = useState({
    building: "",
    floor: "",
    room: "",
    storageSystem: "",
    storageUnit: "",
  });

  const [era, setEra] = useState({ value: "CE", label: "CE" });
  const [object, setObject] = useState([]);
  const { setObjectEditData } = ObjectEditsaving();
  const [defaultObject, setDefaultObject] = useState([]);
  const [sessionId, setSessionId] = useState();
  const maxLength = 2000;
  const maxlengthInscript = 2000;
  const routeParams = useParams();
  const id = fromList ? objectId : routeParams.id;
  const userData = JSON.parse(localStorage.getItem("user_info"));
  const online = navigator.onLine;
  const titleRowRef = useRef();
  const containerRef = useRef();
  const sessionRef = useRef(false);
  const sessionIdRef = useRef("");
  const isDetaillRef = useRef(false);
  const isChangedRef = useRef(false);
  const iSubmittedRef = useRef(false);
  const isAutosaveRef = useRef(false);
  const fromPinOpen = params.get("fromPinOpen");
  const fromPin = locationState?.state?.fromPin
    ? locationState?.state?.fromPin
    : fromPinOpen
    ? fromPinOpen
    : "";
  const userUsedLastScreen = userData?.last_used_screen;

  const relatedObjectHandler = (objectValue) => {
    const isNoname = objectValue?.map((noName) => {
      return {
        ...noName,
        label: noName.label ? noName?.label : noName?.accession_number,
      };
    });

    setIsAutoSave(true);

    const realatedvalue = objectValue?.map((li) => li?.value);
    formik.setValues({
      ...formik.values,
      related_museum_object: realatedvalue,
      selctedObject: isNoname,
    });
  };
  const endDateHandler = (e) => {
    setIsAutoSave(true);

    formik?.setValues({
      ...formik?.values,
      period_end_date: e?.target?.value,
    });
  };
  const startDateHandler = (e) => {
    setIsAutoSave(true);

    formik?.setValues({
      ...formik?.values,
      period_start_date: e?.target?.value,
    });
  };

  const eraHandler = (eraValue) => {
    setIsAutoSave(true);

    formik?.setValues({
      ...formik?.values,
      period: eraValue?.value,
    });

    setEra(eraValue);
  };

  const addDimensionValueChangeHandler = (dimenIndex, dimenValue) => {
    setIsAutoSave(true);

    const dimensionListValue = [...formik.values.dimensions];
    dimensionListValue[dimenIndex].dimension_value = dimenValue;
    formik.setValues({
      ...formik.values,
      dimensions: dimensionListValue,
    });
  };

  const onAddDimensionNameChangeHandler = (dimenIndex, dimenName) => {
    setIsAutoSave(true);

    const dimensionListName = [...formik.values.dimensions];
    dimensionListName[dimenIndex].dimension_name = dimenName;
    formik.setValues({
      ...formik.values,
      dimensions: dimensionListName,
    });
  };
  const removeDimension = (dimenIndex) => {
    setIsAutoSave(true);

    const dimensionList = [...formik.values.dimensions];
    dimensionList.splice(dimenIndex, 1);
    formik.setValues({
      ...formik.values,
      dimensions: dimensionList,
    });
  };

  const addDimensions = () => {
    const dimensionList = [...formik.values.dimensions];
    dimensionList.unshift({
      dimension_name: "",
      dimension_value: "",
    });

    formik.setValues({
      ...formik.values,
      dimensions: dimensionList,
    });
  };
  const draftHandler = async () => {
    iSubmittedRef.current = true;
    setIsAutoSave(false);
    await clearAutoSavedFromIndexedDB("collection");

    if (formik?.values?.object_name === "") {
      formik.setErrors({
        object_name: "Required",
      });

      formik.setTouched({
        object_name: true,
      });

      return;
    }

    if (formik?.values?.category && !formik?.values?.sub_category) {
      formik.setErrors({
        ...formik.errors,
        sub_category: "Required",
      });

      formik.setTouched({
        ...formik.touched,
        sub_category: true,
      });

      return;
    }

    setDraftLoad(true);
    setButtonloader(true);
    formik?.validateField("object_name");
    const updatedValues = { ...formik.values };
    updatedValues.prime_category = updatedValues.category;
    updatedValues.category = updatedValues.sub_category;
    if (id) {
      updatedValues.id = id;
    }
    updatedValues.collection_is_draft = true;

    if (updatedValues?.category === "") {
      delete updatedValues?.category;
    }
    if (updatedValues?.conservation_grade === "") {
      delete updatedValues?.conservation_grade;
    }
    if (!updatedValues?.acquisition_method) {
      delete updatedValues.acquisition_method;
    }

    if (locationTransitId?.unitType) {
      updatedValues.transit_location_storage_unit = locationTransitId.unitType;
    } else if (locationTransitId?.systemtype) {
      updatedValues.transit_location_storage_system =
        locationTransitId.systemtype;
    } else if (locationTransitId?.room) {
      updatedValues.transit_location_room = locationTransitId.room;
    }

    if (locationId?.unitType) {
      updatedValues.original_location_storage_unit = locationId?.unitType;
    } else if (locationId?.systemtype) {
      updatedValues.original_location_storage_system = locationId?.systemtype;
    } else if (locationId?.room) {
      updatedValues.original_location_room = locationId?.room;
    }

    if (updatedValues?.attribute === null) {
      delete updatedValues?.attribute;
    }
    const newEntryImage = updatedValues?.ledger_entry_images?.filter(
      (liImage) => liImage?.entry_image
    );
    const newDimension = updatedValues?.dimensions?.filter(
      (liDimens) => liDimens?.dimension_name || liDimens?.dimension_value
    );

    updatedValues.ledger_entry_images = newEntryImage;
    updatedValues.dimensions = newDimension;
    updatedValues.session = sessionIdRef?.current;
    if (!updatedValues.period_start_date || !updatedValues.period_end_date) {
      delete updatedValues.period;
    }

    const payload = {
      ...updatedValues,
      dimensions: newDimension,
      ledger_entry_images: [...newEntryImage].reverse(), // reversed only here
    };

    setSavedDataOverRide(payload);
    if (online) {
      createObject(payload)((response) => {
        if (response?.status) {
          sendSessionClose();
          setButtonloader(false);
          setDraftLoad(false);
          toast.success(
            id ? "Object updated successfully!" : "Object created successfully!"
          );
          if (fromList) {
            onCloseObject();
          } else if (fromNotification) {
            navigate(
              `/${
                userData.museum_name
                  ? userData?.museum_name?.split(" ").join("_")
                  : "Nefos"
              }/${lIST_NOTIFICATION}`
            );
          } else if (fromGlobal) {
            navigate(
              `/${
                userData.museum_name
                  ? userData?.museum_name?.split(" ").join("_")
                  : "Nefos"
              }/${GLOBAL_SEARCH}`
            );
          } else if (fromLocation) {
            if (locationType) {
              navigate(
                `/${
                  userData.museum_name
                    ? userData?.museum_name?.split(" ").join("_")
                    : "Nefos"
                }/${QR_LOCATION_MANAGMENT}/${floorPlanObjectId}?type=${locationType}`
              );
            } else {
              navigate(
                `/${
                  userData.museum_name
                    ? userData?.museum_name?.split(" ").join("_")
                    : "Nefos"
                }/${QR_LOCATION_MANAGMENT}/${floorPlanObjectId}`
              );
            }
          } else if (fromPin) {
            navigate(
              `/${
                userData.museum_name
                  ? userData?.museum_name?.split(" ").join("_")
                  : "Nefos"
              }/${OBJECT_PIN}`
            );
          } else {
            navigate(
              `/${
                userData.museum_name
                  ? userData?.museum_name?.split(" ").join("_")
                  : "Nefos"
              }/${LIST_OBJECT}`
            );
          }

          const assignValue = formik?.values?.assignValue;

          if (assignValue) {
            const newAssignValue = assignValue.id
              ? assignValue
              : { ...assignValue, id: response?.data?.id };

            assignUser(newAssignValue)((response) => {
              if (response?.status) {
              }
            });
          }
        } else {
          if (response?.status_code === 400 && response?.conflict) {
            setIsOverRide(true);
          }
          iSubmittedRef.current = false;
          setButtonloader(false);
          setDraftLoad(false);
        }
      });
    } else {
      addItemToDB(payload, "collection")
        .then(() => {
          setButtonloader(false);
          setDraftLoad(false);
          toast.success(
            id ? "Object updated successfully!" : "Object created successfully!"
          );
          formik.resetForm();
          fromGlobal
            ? navigate(
                `/${
                  userData.museum_name
                    ? userData?.museum_name?.split(" ").join("_")
                    : "Nefos"
                }/${GLOBAL_SEARCH}`
              )
            : navigate(
                `/${
                  userData.museum_name
                    ? userData?.museum_name?.split(" ").join("_")
                    : "Nefos"
                }/${LIST_OBJECT}`
              );
        })
        .catch((error) => {
          console.error("Failed to add item to IndexedDB:", error);
          toast.error("Failed to save data locally.");
        });
    }
  };

  const customComponents = {
    Option: (props) => (
      <div
        {...props.innerRef}
        {...props.innerProps}
        style={{
          backgroundColor: props.isFocused ? "#eee" : "transparent",
          padding: 10,
          cursor: "pointer",
        }}
      >
        {props.data.label}
        {props?.data?.key_category && (
          <img
            src={start}
            style={{
              paddingLeft: "20px",
              height: "18px",
              width: "36px",
              paddingBottom: "5px",
            }}
            alt="star"
          />
        )}
      </div>
    ),
  };

  const userChangeHandler = (value) => {
    setUser(defaultUser);
    setIsAutoSave(true);
    setSelectedUser(value);
    formik?.setValues({
      ...formik.values,
      assignValue: {
        id: id,
        object_assigned: value?.value,
      },
    });
  };

  const pinChangeHandler = (e) => {
    formik?.setValues({
      ...formik?.values,
      is_pinned: formik?.values?.is_pinned ? false : true,
    });

    if (!formik?.values?.is_pinned) {
      addPinObject({ museum: userData?.museum, museum_object: id })(
        (pinnedResponse) => {
          if (pinnedResponse?.status) {
          }
        }
      );
    } else {
      deletePinObject({ id: [id] })((response) => {
        if (response?.status) {
        }
      });
    }
  };

  const materialChangeHandler = (materialValue) => {
    setIsAutoSave(true);
    setMaterial(defaultMaterial);
    const materialValuesList = materialValue.map((li) => li.value);
    formik.setValues({
      ...formik.values,
      material: materialValuesList ? materialValuesList : "",
      selectedMaterial: materialValue,
      sort_by: "material_name",
    });
  };

  const subcategoryChangeHandler = (subactegoryValue) => {
    setIsAutoSave(true);
    setSubcategory(defaultSubcategory);
    setCategoryDetails([]);
    setObjectEditData((prev) => ({
      ...prev,
      objectId: id,
      subCategory: subactegoryValue?.label,
    }));
    formik.setValues({
      ...formik.values,
      attribute: null,
      sub_category: subactegoryValue.value,
      selectedSubcategory: subactegoryValue,
      sort_by: "category_name",
    });
    getSingleCategory({ id: subactegoryValue?.value })((response) => {
      setSelectedAttribute([]);
      if (response?.status) {
        if (response?.data?.attribute?.length > 0) {
          setCategoryDetails(response?.data?.attribute);
          const descriptorOptions = response?.data?.attribute?.map(
            (li) => li?.options
          );
          response?.data?.attribute?.length > 0 &&
            setDescriptorsdata(descriptorOptions);
          const newCreateAttribute = response?.data?.attribute?.map((li) => {
            // li?.type==="Multiple dropdown"&&setSelectedAttribute(li?.options?.map((li)=>({
            //     value:li?.id,
            //     label:li?.option
            // })))
            return {
              category_attributes: li?.id,
              attribute_name: li?.attribute,
              attribute_type: li?.type,
              options: li?.options,
            };
          });
          formik?.setValues({
            ...formik?.values,
            attribute: newCreateAttribute,
            sub_category: subactegoryValue.value,
            selectedSubcategory: subactegoryValue,
            sort_by: "category_name",
          });
        }
      }
    });
  };

  const categoryChangeHandler = (categoryValue) => {
    setCatgory(defaultcategory);
    setIsAutoSave(true);
    setCategoryDetails([]);

    setObjectEditData((prev) => ({
      ...prev,
      objectId: id,
      category: categoryValue?.label,
    }));

    formik.setValues({
      ...formik.values,
      attribute: null,
      selectedSubcategory: "",
      sub_category: "",
      category: categoryValue.value,
      selectedCategory: categoryValue,
      sort_by: "category_name",
    });
    getSingleCategory({ id: categoryValue?.value })((response) => {
      setSelectedAttribute([]);
      if (response?.status) {
        if (response?.data?.attribute?.length > 0) {
          setCategoryDetails(response?.data?.attribute);
          const descriptorOptions = response?.data?.attribute?.map(
            (li) => li?.options
          );
          response?.data?.attribute?.length > 0 &&
            setDescriptorsdata(descriptorOptions);
          const newCreateAttribute = response?.data?.attribute?.map((li) => {
            // li?.type==="Multiple dropdown"&&setSelectedAttribute(li?.options?.map((li)=>({
            //     value:li?.id,
            //     label:li?.option
            // })))
            return {
              category_attributes: li?.id,
              attribute_name: li?.attribute,
              attribute_type: li?.type,
              options: li?.options,
            };
          });
          formik?.setValues({
            ...formik?.values,
            attribute: newCreateAttribute,
            category: categoryValue.value,
            selectedCategory: categoryValue,
            selectedSubcategory: "",
            sub_category: "",
            sort_by: "category_name",
          });
        }
      }
    });
  };

  const convertBase64 = (resume) => {
    return new Promise((resolve, reject) => {
      if (!(resume instanceof Blob)) {
        reject(new Error("Invalid parameter: Expected a Blob."));
        return;
      }
      const fileReader = new FileReader();
      fileReader.onload = () => {
        resolve(fileReader.result);
      };
      fileReader.onerror = (error) => {
        reject(error);
      };
      fileReader.readAsDataURL(resume);
    });
  };

  const handleImageChangeHandler = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    if (!file.type.startsWith("image/")) {
      toast.error("Only image files are allowed!");
      e.target.value = ""; // Reset invalid selection
      return;
    }
    setIsAutoSave(true);

    convertBase64(e.target.files[0])
      .then((resp) => {
        setObjectEditData((prev) => ({
          ...prev,
          objectId: id,
          objectImage: resp,
        }));
        formik.setValues({
          ...formik.values,
          reference_image: resp,
          preview_image: resp,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleIconicHandler = (e) => {
    setIsAutoSave(true);

    formik.setValues({
      ...formik.values,
      iconic_object: e.target.checked,
    });
  };

  const acquistionHandler = (value) => {
    setIsAutoSave(true);

    formik.setValues({
      ...formik.values,
      acquisition_method: value.label === "Donation" ? "Donation" : value.label,
      selectedAcquistion: value,
    });
  };

  const handleTagchangeHandler = (e) => {
    if (e.target.value.length === 100) {
      toast.error("Maximum 100 characters allowed!");
    }
    setEnteredValue(e.target.value);
  };
  const handleKeydown = (e) => {
    setIsAutoSave(true);

    if (e.key === "Enter") {
      const capitalizedValue =
        e.target.value.charAt(0).toUpperCase() + e.target.value.slice(1);

      const addTags = [...formik.values.tags];
      addTags.push({
        tag_name: capitalizedValue,
      });

      formik.setValues({
        ...formik.values,
        tags: addTags,
      });
      setEnteredValue("");
      e.preventDefault();
    }
  };

  const handleFunctionChange = (e) => {
    if (e.target.value.length === 100) {
      toast.error("Maximum 100 characters allowed!");
    }
    setEnteredFunction(e.target.value);
  };
  const handleFunctionKeyDownHandler = (e) => {
    setIsAutoSave(true);

    if (e.key === "Enter") {
      const addFunction = [...formik.values.function_or_usages];
      const capitalizedValue =
        e.target.value.charAt(0).toUpperCase() + e.target.value.slice(1);

      addFunction.push({
        function_or_usage: capitalizedValue,
      });

      formik.setValues({
        ...formik.values,
        function_or_usages: addFunction,
      });
      setEnteredFunction("");
      e.preventDefault();
    }
  };

  const functionDeleteHandler = (funIndex) => {
    setIsAutoSave(true);

    const removeData = [...formik.values.function_or_usages];
    removeData.splice(funIndex, 1);

    formik.setValues({
      ...formik.values,
      function_or_usages: removeData,
    });
  };

  const handleClick = () => {
    document.querySelector(".reference-image").click();
  };

  const sendSessionClose = (isClosing) => {
    if (sessionStorage.getItem("justRefreshed") === "true") {
      sessionStorage.setItem("justRefreshed", "false");
      return;
    }
    const sessionOpenValues = {
      id: sessionIdRef.current,
      museum: userData?.museum,
      museum_object: id,
      screen: "collection",
      status: "closed",
      is_changes_made: isChangedRef.current,
    };

    try {
      const token = reactLocalStorage.get("token"); // 👈 same as your axiosInstance
      const userData = JSON.parse(localStorage.getItem("user_info"));

      fetch(
        `${axiosInstance.defaults.baseURL}museumobject/object-session/create-object-session`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            ...(token ? { Authorization: `Bearer ${token}` } : {}),
            ...(userData?.is_superuser === false
              ? { Museum: userData?.museum }
              : {}),
          },
          body: JSON.stringify(sessionOpenValues),
          keepalive: true, // 👈 ensures it works during unload
        }
      )
        .then((response) => response?.json())
        .then((data) => {
          if (data?.status === true) {
            sessionRef.current = false;
          }
        });
    } catch (err) {
      console.error("Fetch send failed:", err);
    }
  };

  const formik = useFormik({
    validationSchema: Yup.object().shape({
      object_name: Yup.string().trim().required("Required"),
      height: Yup.string()
        .trim()
        .matches(/^\d*\.?\d*$/, "Height must be a number")
        .required("Required"),
      depth: Yup.string()
        .trim()
        .matches(/^\d*\.?\d*$/, "depth must be a number")
        .required("Required"),
      width: Yup.string()
        .trim()
        .matches(/^\d*\.?\d*$/, "width must be a number")
        .required("Required"),
      preview_image: Yup.string().required("Required"),
      originalBuilding: Yup.string().required("Required"),
      originalFloor: Yup.string().required("Required"),
      originalRoom: Yup.string().required("Required"),
      number_of_missing_pieces: Yup.string().matches(
        /^\d*$/,
        "Only numbers are allowed"
      ),
      number_of_parts: Yup.string().matches(
        /^\d*$/,
        "Only numbers are allowed"
      ),
      page_number: Yup.string().matches(/^\d*$/, "Only numbers are allowed"),
      // transitlBuilding: Yup.string().required("Required"),
      // transitlFloor: Yup.string().required("Required"),
      // transitlRoom: Yup.string().required("Required"),
    }),
    initialValues: {
      is_location_same: false,
      transitLocationTotaldata: {},
      originalLocationTotaldata: {},
      // original_location_room:"",
      // original_location_storage_system:"",
      // original_location_storage_unit:"",
      originalBuilding: "",
      object_label: "",
      originalFloor: "",
      originalRoom: "",
      originalsystemtype: "",
      originalunitType: "",
      transitlBuilding: "",
      transitlFloor: "",
      transitlRoom: "",
      transitlsystemtype: "",
      transitlunitType: "",
      attribute: [],
      related_museum_object: [],
      references: "",
      cultural_significance: "",
      technique: "",
      historical_description: "",
      collection_is_draft: false,
      museum: userData.museum,
      object_name: "",
      original_location: "",
      iconic_object: false,
      reference_image: "",
      material: [],
      provenance: "",
      dateable_time_period: "",
      category: "",
      sub_category: "",
      selectedSubcategory: "",
      height: "",
      depth: "",
      width: "",
      dimensions: [],
      description: "",
      preliminary_condition_assessment: "",
      inscription_or_markers: "",
      function_or_usages: [],
      acquisition_method: "",
      tags: [],
      additional_notes: "",
      transit_location: "",
      selectedCategory: "",
      selectedMaterial: [],
      selectedTransit: "",
      selectedAcquistion: "",
      selectedOriginalLocation: "",
      selctedObject: "",
      preview_image: "",
      period: "CE",
      period_end_date: "",
      period_start_date: "",
      accession_number: "",
      number_of_parts: "",
      number_of_missing_pieces: "",
      assignValue: null,
      ledger_number: "",
      page_number: "",
      ledger_description: "",
      ledger_translation: "",
      ledger_notes: "",
      ledger_image: "",
      page_image: "",
      ledger_entry_images: [],
      old_accession_number: "",
      museum: userData?.museum,
      museum_object: id,
      screen: "collection",
      sessionStatus: "open",
      is_changes_made: false,
      sessionId: "",
      is_pinned: false,
    },
    validate: (values) => {
      const errors = {};

      if (values.category) {
        if (!values.sub_category) {
          errors.sub_category = "Required";
        }
      }
      console.log(showStorageOriginal, "showRequired");
      console.log(values.originalsystemtype, "showrequired");
      console.log(values.originalunitType, "showrequired");

      if (!values?.originalsystemtype && showStorageOriginal?.sytemType) {
        errors.originalsystemtype = "Required";
      }
      if (!values?.originalunitType && showStorageOriginal?.unitType) {
        errors.originalunitType = "Required";
      }

      // if (!values?.transitlsystemtype && showStorageTransit?.sytemType) {
      //     errors.transitlsystemtype = "Required"
      // }
      // if (!values?.transitlunitType && showStorageTransit?.unitType) {
      //     errors.transitlunitType = "Required"
      // }

      if (values?.material?.length === 0) {
        errors.material = "Required";
      }
      return errors;
    },
    onSubmit: async (values) => {
      iSubmittedRef.current = true;
      values.prime_category = values.category;
      values.category = values.sub_category;
      setIsAutoSave(false);
      await clearAutoSavedFromIndexedDB("collection");
      setButtonloader(true);
      setsubmitLoader(true);
      if (id) {
        values.id = id;
      }
      if (!values.acquisition_method) {
        delete values.acquisition_method;
      }
      values.collection_is_draft = false;

      if (locationTransitId?.unitType) {
        values.transit_location_storage_unit = locationTransitId.unitType;
      } else if (locationTransitId?.systemtype) {
        values.transit_location_storage_system = locationTransitId.systemtype;
      } else if (locationTransitId?.room) {
        values.transit_location_room = locationTransitId.room;
      }

      if (locationId?.unitType) {
        values.original_location_storage_unit = locationId?.unitType;
      } else if (locationId?.systemtype) {
        values.original_location_storage_system = locationId?.systemtype;
      } else if (locationId?.room) {
        values.original_location_room = locationId?.room;
      }

      if (values?.attribute === null) {
        delete values?.attribute;
      }

      const newEntryImage = values?.ledger_entry_images?.filter(
        (liImage) => liImage?.entry_image
      );
      const newDimension = values?.dimensions?.filter(
        (liDimens) => liDimens?.dimension_name || liDimens?.dimension_value
      );

      values.dimensions = newDimension;
      values.ledger_entry_images = newEntryImage;
      if (!values.period_start_date || !values.period_end_date) {
        delete values.period;
      }
      values.session = sessionIdRef?.current;
      const payload = {
        ...values,
        dimensions: newDimension,
        ledger_entry_images: [...newEntryImage].reverse(), // reversed only here
      };
      setSavedDataOverRide(payload);
      if (online) {
        createObject(payload)((response) => {
          if (response?.status) {
            iSubmittedRef.current = true;
            sendSessionClose();

            toast.success(
              id
                ? "Object updated successfully!"
                : "Object created successfully!"
            );
            if (fromList) {
              onCloseObject();
            } else if (fromNotification) {
              navigate(
                `/${
                  userData.museum_name
                    ? userData?.museum_name?.split(" ").join("_")
                    : "Nefos"
                }/${lIST_NOTIFICATION}`
              );
            } else if (fromLocation) {
              if (locationType) {
                navigate(
                  `/${
                    userData.museum_name
                      ? userData?.museum_name?.split(" ").join("_")
                      : "Nefos"
                  }/${QR_LOCATION_MANAGMENT}/${floorPlanObjectId}?type=${locationType}`
                );
              } else {
                navigate(
                  `/${
                    userData.museum_name
                      ? userData?.museum_name?.split(" ").join("_")
                      : "Nefos"
                  }/${QR_LOCATION_MANAGMENT}/${floorPlanObjectId}`
                );
              }
            } else if (fromGlobal) {
              navigate(
                `/${
                  userData.museum_name
                    ? userData?.museum_name?.split(" ").join("_")
                    : "Nefos"
                }/${GLOBAL_SEARCH}`
              );
            } else if (fromPin) {
              navigate(
                `/${
                  userData.museum_name
                    ? userData?.museum_name?.split(" ").join("_")
                    : "Nefos"
                }/${OBJECT_PIN}`
              );
            } else {
              navigate(
                `/${
                  userData.museum_name
                    ? userData?.museum_name?.split(" ").join("_")
                    : "Nefos"
                }/${LIST_OBJECT}`
              );
            }
            setButtonloader(false);
            setsubmitLoader(false);
            const assignValue = formik?.values?.assignValue;

            if (assignValue) {
              const newAssignValue = assignValue.id
                ? assignValue
                : { ...assignValue, id: response?.data?.id };

              assignUser(newAssignValue)((response) => {
                if (response?.status) {
                }
              });
            }
          } else {
            if (response?.status_code === 400 && response?.conflict) {
              setIsOverRide(true);
            }
            iSubmittedRef.current = false;
            setButtonloader(false);
            setsubmitLoader(false);
          }
        });
      } else {
        addItemToDB(values, "collection")
          .then(() => {
            setButtonloader(false);
            setsubmitLoader(false);

            toast.success(
              id
                ? "Object updated successfully!"
                : "Object created successfully!"
            );
            formik.resetForm();
            fromGlobal
              ? navigate(
                  `/${
                    userData.museum_name
                      ? userData?.museum_name?.split(" ").join("_")
                      : "Nefos"
                  }/${GLOBAL_SEARCH}`
                )
              : navigate(
                  `/${
                    userData.museum_name
                      ? userData?.museum_name?.split(" ").join("_")
                      : "Nefos"
                  }/${LIST_OBJECT}`
                );
          })
          .catch((error) => {
            setButtonloader(false);
            setsubmitLoader(false);
            console.error("Failed to add item to IndexedDB:", error);
            toast.error("Failed to save data locally!");
          });
      }
    },
  });

  const handelete = (tagIndex) => {
    setIsAutoSave(true);

    const removeTag = [...formik.values.tags];
    removeTag.splice(tagIndex, 1);
    formik.setValues({
      ...formik.values,
      tags: removeTag,
    });
  };

  console.log(locationId, "locationId");

  function deepEqual(a, b) {
    if (a === b) return true;

    if (
      typeof a !== "object" ||
      typeof b !== "object" ||
      a === null ||
      b === null
    )
      return false;

    // Ignore undefined keys
    const keysA = Object.keys(a).filter((k) => a[k] !== undefined);
    const keysB = Object.keys(b).filter((k) => b[k] !== undefined);

    if (keysA.length !== keysB.length) return false;

    for (let key of keysA) {
      if (!keysB.includes(key)) return false;

      const valA = a[key];
      const valB = b[key];

      // Handle arrays directly
      if (Array.isArray(valA) && Array.isArray(valB)) {
        if (JSON.stringify(valA) !== JSON.stringify(valB)) return false;
        continue;
      }

      // Recurse
      if (!deepEqual(valA, valB)) return false;
    }

    return true;
  }

  const objectListFormikstate = fromGlobal
    ? {
        objectListFormik: objectListFormik,
        fromGlobal: true,
      }
    : fromPin
    ? {
        objectListFormik: objectListFormik,
        fromPin: true,
      }
    : fromCategory
    ? {
        objectListFormik: objectListFormik,
        fromUsedObject: true,
        fromCategory: true,
      }
    : fromMaterial
    ? {
        objectListFormik: objectListFormik,
        fromUsedObject: true,
        fromMaterial: true,
      }
    : fromLocation
    ? {
        objectListFormik: objectListFormik,
        fromLocation: true,
      }
    : {
        objectListFormik: objectListFormik,
      };

  const nextObjectHandler = async () => {
    setLoading(true);
    setNextAndPreviousLoad({
      next: true,
    });
    iSubmittedRef.current = true;

    setIsAutoSave(false);
    await clearAutoSavedFromIndexedDB("collection");

    const hasChanged = !deepEqual(formik.values, savedFormikData);

    if (hasChanged) {
      const updatedValues = { ...formik.values };

      updatedValues.prime_category = updatedValues.category;
      updatedValues.category = updatedValues.sub_category;
      if (id) {
        updatedValues.id = id;
      }
      if (!updatedValues.acquisition_method) {
        delete updatedValues.acquisition_method;
      }
      updatedValues.collection_is_draft = false;

      if (locationTransitId?.unitType) {
        updatedValues.transit_location_storage_unit =
          locationTransitId.unitType;
      } else if (locationTransitId?.systemtype) {
        updatedValues.transit_location_storage_system =
          locationTransitId.systemtype;
      } else if (locationTransitId?.room) {
        updatedValues.transit_location_room = locationTransitId.room;
      }

      if (locationId?.unitType) {
        updatedValues.original_location_storage_unit = locationId?.unitType;
      } else if (locationId?.systemtype) {
        updatedValues.original_location_storage_system = locationId?.systemtype;
      } else if (locationId?.room) {
        updatedValues.original_location_room = locationId?.room;
      }

      if (updatedValues?.attribute === null) {
        delete updatedValues?.attribute;
      }

      const newEntryImage = updatedValues?.ledger_entry_images?.filter(
        (liImage) => liImage?.entry_image
      );
      const newDimension = updatedValues?.dimensions?.filter(
        (liDimens) => liDimens?.dimension_name || liDimens?.dimension_value
      );

      updatedValues.dimensions = newDimension;
      updatedValues.ledger_entry_images = newEntryImage;
      if (
        updatedValues?.original_location_room &&
        updatedValues?.height &&
        updatedValues?.width &&
        updatedValues?.depth &&
        updatedValues?.reference_image &&
        updatedValues?.material?.length > 0 &&
        updatedValues?.object_name
      ) {
        updatedValues.collection_is_draft = false;
      } else {
        updatedValues.collection_is_draft = true;
      }
      updatedValues.session = sessionIdRef.current;
      const payload = {
        ...updatedValues,
        dimensions: newDimension,
        ledger_entry_images: [...newEntryImage].reverse(), // reversed only here
      };

      setSavedDataOverRide(payload);

      createObject(updatedValues)((response) => {
        const assignValue = formik?.values?.assignValue;
        if (response?.status) {
          setSavedDataOverRide();
          setOverRideFromNext(false);
          setOverRideFromPrevious(false);
          sendSessionClose();
          if (assignValue) {
            const newAssignValue = assignValue.id
              ? assignValue
              : { ...assignValue, id: response?.data?.id };

            assignUser(newAssignValue)((response) => {
              if (response?.status) {
                setNextAndPreviousLoad({
                  next: false,
                });
                navigate(
                  `/${
                    userData.museum_name
                      ? userData?.museum_name?.split(" ").join("_")
                      : "Nefos"
                  }/${EDIT_OBJECT}/${nextId}`,
                  {
                    state: objectListFormikstate,
                  }
                );
              } else {
                setNextAndPreviousLoad({
                  next: false,
                });
              }
            });
          } else {
            setNextAndPreviousLoad({
              next: false,
            });
            navigate(
              `/${
                userData.museum_name
                  ? userData?.museum_name?.split(" ").join("_")
                  : "Nefos"
              }/${EDIT_OBJECT}/${nextId}`,
              {
                state: objectListFormikstate,
              }
            );
          }
        } else {
          if (response?.status_code === 400 && response?.conflict) {
            setLoading(false);
            setIsOverRide(true);
            setOverRideFromNext(true);
          }
          iSubmittedRef.current = false;
          setNextAndPreviousLoad({
            next: false,
          });
        }
      });
    } else {
      sendSessionClose();
      setNextAndPreviousLoad({
        next: false,
      });

      navigate(
        `/${
          userData.museum_name
            ? userData?.museum_name?.split(" ").join("_")
            : "Nefos"
        }/${EDIT_OBJECT}/${nextId}`,
        {
          state: objectListFormikstate,
        }
      );
    }
  };

  const previousObjectHandler = async () => {
    iSubmittedRef.current = true;
    setNextAndPreviousLoad({
      previous: true,
    });
    setIsAutoSave(false);
    await clearAutoSavedFromIndexedDB("collection");

    const hasChanged = !deepEqual(formik.values, savedFormikData);
    if (hasChanged) {
      const updatedValues = { ...formik.values };

      updatedValues.prime_category = updatedValues.category;
      updatedValues.category = updatedValues.sub_category;

      if (id) {
        updatedValues.id = id;
      }

      if (!updatedValues.acquisition_method) {
        delete updatedValues.acquisition_method;
      }

      updatedValues.collection_is_draft = false;

      if (locationTransitId?.unitType) {
        updatedValues.transit_location_storage_unit =
          locationTransitId.unitType;
      } else if (locationTransitId?.systemtype) {
        updatedValues.transit_location_storage_system =
          locationTransitId.systemtype;
      } else if (locationTransitId?.room) {
        updatedValues.transit_location_room = locationTransitId.room;
      }

      if (locationId?.unitType) {
        updatedValues.original_location_storage_unit = locationId?.unitType;
      } else if (locationId?.systemtype) {
        updatedValues.original_location_storage_system = locationId?.systemtype;
      } else if (locationId?.room) {
        updatedValues.original_location_room = locationId?.room;
      }

      if (updatedValues?.attribute === null) {
        delete updatedValues?.attribute;
      }

      const newEntryImage = updatedValues?.ledger_entry_images?.filter(
        (liImage) => liImage?.entry_image
      );
      const newDimension = updatedValues?.dimensions?.filter(
        (liDimens) => liDimens?.dimension_name || liDimens?.dimension_value
      );

      updatedValues.dimensions = newDimension;
      updatedValues.ledger_entry_images = newEntryImage;
      if (
        updatedValues?.original_location_room &&
        updatedValues?.height &&
        updatedValues?.width &&
        updatedValues?.depth &&
        updatedValues?.reference_image &&
        updatedValues?.material &&
        updatedValues?.object_name
      ) {
        updatedValues.collection_is_draft = false;
      } else {
        updatedValues.collection_is_draft = true;
      }
      updatedValues.session = sessionIdRef.current;
      const payload = {
        ...updatedValues,
        dimensions: newDimension,
        ledger_entry_images: [...newEntryImage].reverse(), // reversed only here
      };
      setSavedDataOverRide(payload);
      createObject(updatedValues)((response) => {
        const assignValue = formik?.values?.assignValue;

        if (response?.status) {
          sendSessionClose();
          setSavedDataOverRide();
          setOverRideFromNext(false);
          setOverRideFromPrevious(false);
          if (assignValue) {
            const newAssignValue = assignValue.id
              ? assignValue
              : { ...assignValue, id: response?.data?.id };

            assignUser(newAssignValue)((response) => {
              if (response?.status) {
                setNextAndPreviousLoad({
                  previous: false,
                });
                navigate(
                  `/${
                    userData.museum_name
                      ? userData?.museum_name?.split(" ").join("_")
                      : "Nefos"
                  }/${EDIT_OBJECT}/${previousId}`,
                  {
                    state: objectListFormikstate,
                  }
                );
              } else {
                setNextAndPreviousLoad({
                  previous: false,
                });
              }
            });
          } else {
            setNextAndPreviousLoad({
              previous: false,
            });
            navigate(
              `/${
                userData.museum_name
                  ? userData?.museum_name?.split(" ").join("_")
                  : "Nefos"
              }/${EDIT_OBJECT}/${previousId}`,
              {
                state: objectListFormikstate,
              }
            );
          }
        } else {
          if (response?.status_code === 400 && response?.conflict) {
            setIsOverRide(true);
            setOverRideFromPrevious(true);
          }
          iSubmittedRef.current = false;
          setNextAndPreviousLoad({
            previous: false,
          });
        }
      });
    } else {
      sendSessionClose();
      setNextAndPreviousLoad({
        previous: false,
      });
      navigate(
        `/${
          userData.museum_name
            ? userData?.museum_name?.split(" ").join("_")
            : "Nefos"
        }/${EDIT_OBJECT}/${previousId}`,
        {
          state: objectListFormikstate,
        }
      );
      // formik?.resetForm();
    }
  };

  // const autoSaveAndNavigate =  (to) => {
  //     const savedDraft = localStorage.getItem("autoSaveDraft");

  //     if (savedDraft) {
  //         const savedFormik=JSON.parse(savedDraft)
  //         savedFormik.collection_is_draft = true
  //         if (savedFormik?.attribute === null) {
  //             delete savedFormik?.attribute
  //         }
  //         if (savedFormik?.category === "") {
  //             delete savedFormik?.category
  //         }
  //         if (savedFormik?.conservation_grade === "") {
  //             delete savedFormik?.conservation_grade
  //         }
  //         if (!savedFormik?.acquisition_method) {
  //             delete savedFormik.acquisition_method;
  //         }

  //         if(id){
  //             savedFormik.id=id
  //         }

  //         createObject(savedFormik)((response)=>{
  //             if(response?.status){
  //                 console.log(response);

  //             }
  //         })
  //     }

  //     // Proceed with navigation
  //     navigate(to);
  // };

  const ledgerImageHandler = (e, title) => {
    const file = e.target.files[0];
    if (!file) return;
    if (!file.type.startsWith("image/")) {
      toast.error("Only image files are allowed!");
      e.target.value = ""; // Reset invalid selection
      return;
    }
    setIsAutoSave(true);

    convertBase64(e.target.files[0])
      .then((resp) => {
        setShowEnlargeImage({
          ...showImageEnlarge,
          image: resp,
        });
        title === "ledger"
          ? formik.setValues({
              ...formik.values,
              ledger_image: resp,
            })
          : formik.setValues({
              ...formik.values,
              page_image: resp,
            });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const addEntryImageHandler = () => {
    const entryImageList = [...formik?.values?.ledger_entry_images];
    entryImageList?.unshift({
      entry_image: "",
    });

    formik?.setValues({
      ...formik?.values,
      ledger_entry_images: entryImageList,
    });
  };

  const entryImageChangehandler = (e, indexOfentry) => {
    const file = e.target.files[0];
    if (!file) return;

    if (!file.type.startsWith("image/")) {
      toast.error("Only image files are allowed!");
      e.target.value = ""; // Reset invalid selection
      return;
    }
    setIsAutoSave(true);

    const entryImageList = [...formik?.values?.ledger_entry_images];
    convertBase64(e.target.files[0])
      .then((resp) => {
        setShowEnlargeImage({
          ...showImageEnlarge,
          image: resp,
        });
        entryImageList[indexOfentry].entry_image = resp;
        formik?.setValues({
          ...formik?.values,
          ledger_entry_images: entryImageList,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const removeEntryImageHandler = (indexOfEntry) => {
    setIsAutoSave(true);
    const entryImageList = [...formik?.values?.ledger_entry_images];
    entryImageList?.splice(indexOfEntry, 1);
    formik?.setValues({
      ...formik?.values,
      ledger_entry_images: entryImageList,
    });
  };

  const handleBack = async (type) => {
    if (type === "discard") {
      await clearAutoSavedFromIndexedDB("collection");
    }
    setIsAutoSave(false);
    if (fromList) {
      onCloseObject();
    } else if (fromNotification) {
      navigate(
        `/${
          userData.museum_name
            ? userData?.museum_name?.split(" ").join("_")
            : "Nefos"
        }/${lIST_NOTIFICATION}`
      );
    } else if (fromLocation) {
      if (locationType) {
        navigate(
          `/${
            userData.museum_name
              ? userData?.museum_name?.split(" ").join("_")
              : "Nefos"
          }/${QR_LOCATION_MANAGMENT}/${floorPlanObjectId}?type=${locationType}`
        );
      } else {
        navigate(
          `/${
            userData.museum_name
              ? userData?.museum_name?.split(" ").join("_")
              : "Nefos"
          }/${QR_LOCATION_MANAGMENT}/${floorPlanObjectId}`
        );
      }
    } else if (fromCategory) {
      navigate(
        `/${
          userData.museum_name
            ? userData?.museum_name?.split(" ").join("_")
            : "Nefos"
        }/${LIST_CATEGORY}`
      );
    } else if (fromMaterial) {
      navigate(
        `/${
          userData.museum_name
            ? userData?.museum_name?.split(" ").join("_")
            : "Nefos"
        }/${LIST_MATERIAL}`
      );
    } else if (fromGlobal) {
      navigate(
        `/${
          userData.museum_name
            ? userData?.museum_name?.split(" ").join("_")
            : "Nefos"
        }/${GLOBAL_SEARCH}`
      );
    } else if (fromPin) {
      navigate(
        `/${
          userData.museum_name
            ? userData?.museum_name?.split(" ").join("_")
            : "Nefos"
        }/${OBJECT_PIN}`
      );
    } else {
      navigate(
        `/${
          userData.museum_name
            ? userData?.museum_name?.split(" ").join("_")
            : "Nefos"
        }/${LIST_OBJECT}`
      );
    }
  };

  let typingTimerMaterial;

  const materialLoadOptionHandler = (inputValue) => {
    return new Promise((resolve, reject) => {
      clearTimeout(typingTimerMaterial);
      typingTimerMaterial = setTimeout(() => {
        if (inputValue.length >= 1) {
          listMaterialDropdown({
            page: 1,
            search: inputValue,
            museum_id: userData?.museum,
          })((response) => {
            if (response?.status) {
              setMaterial(response?.data);
              resolve(response?.data);
            }
          });
        } else {
          resolve([]);
        }
      }, 300);
    });
  };

  const categoryLoadOptionHandler = (inputValue) => {
    return new Promise((resolve, reject) => {
      clearTimeout(typingTimerMaterial);

      typingTimerMaterial = setTimeout(() => {
        if (inputValue.length >= 1) {
          listCategoryDropdown({
            page: 1,
            search: inputValue,
            museum_id: userData?.museum,
            is_primary: true,
          })((response) => {
            if (response?.status) {
              setCatgory(response?.data);
              resolve(response?.data);
            }
          });
        } else {
          resolve([]);
        }
      }, 300);
    });
  };

  const objectLoadOptionHandler = (
    input,
    loadedOptions,
    { page: currentPage }
  ) => {
    return new Promise((resolve) => {
      clearTimeout(typingTimerMaterial);
      typingTimerMaterial = setTimeout(() => {
        listObjectDropdown({
          page: currentPage,
          limit: 25,
          museum_id: userData.museum,
          sort_by: "object_name",
          is_information_pending: false,
          search: input || "",
        })((response) => {
          if (response?.status) {
            const results = response.data?.results || [];
            const hasMoreData = response.data?.next !== null;

            const filteredResults = results.filter(
              (item) => String(item.value) !== String(id)
            );

            resolve({
              options: filteredResults,
              hasMore: hasMoreData,
              additional: {
                page: currentPage + 1,
              },
            });
          } else {
            resolve({
              options: [],
              hasMore: false,
            });
          }
        });
      }, 300);
    });
  };

  useEffect(() => {
    listMaterialDropdown({
      page: 1,
      limit: 10,
      museum_id: userData?.museum,
      sort_by: "material_name",
    })((response) => {
      if (response?.status) {
        setMaterial(response?.data);
        setDefaultMaterial(response?.data);
      }
    });
  }, []);

  useEffect(() => {
    listCategoryDropdown({
      page: 1,
      limit: 10,
      sort_by: "category_name",
      museum_id: userData?.museum,
      is_primary: true,
    })((response) => {
      if (response?.status) {
        setCatgory(response?.data.sort());
        setdefaultCateory(response?.data);
      }
    });
  }, []);

  useEffect(() => {
    if (formik?.values?.category) {
      listSubCategoryDropdown({
        page: 1,
        limit: 10,
        sort_by: "category_name",
        museum_id: userData?.museum,
        is_primary: false,
        primary_category: formik?.values?.category,
      })((response) => {
        if (response?.status) {
          setSubcategory(response?.data.sort());
          setdefaulSubtCateory(response?.data);
        }
      });
    }
  }, [formik?.values?.category]);

  useEffect(() => {
    if (online) {
      const syncDataWithServer = async () => {
        const pendingRequests = await getPendingRequests("collection");

        if (pendingRequests) {
          pendingRequests?.map((li) =>
            createObject(li)((response) => {
              if (response?.status) {
                sendSessionClose();
                toast.success("Object succesfully uploaded!");
                const assignValue = formik?.values?.assignValue;

                if (assignValue) {
                  const newAssignValue = assignValue.id
                    ? assignValue
                    : { ...assignValue, id: response?.data?.id };

                  assignUser(newAssignValue)((response) => {
                    if (response?.status) {
                    }
                  });
                }
              } else {
                if (response?.status_code === 400 && response?.conflict) {
                  setIsOverRide(true);
                }
              }
            })
          );
        }

        await clearPendingRequests("collection");
      };

      syncDataWithServer();
    }
  }, []);

  const [isOpen, setIsOpen] = React.useState(false);
  const toggleDrawer = () => {
    setIsOpen((prevState) => !prevState);
  };

  const [isOpenhistory, setIsOpenhistory] = React.useState(false);
  const toggleDrawerhistory = () => {
    setIsOpenhistory((prevState) => !prevState);
  };

  const closehandler = () => {
    setIsOpenhistory(false);
    setIsOpen(false);
  };

  useEffect(() => {
    const handleMouseMove = (event) => {
      const mouseX = event.clientX;
      const inRightSide = mouseX >= window.innerWidth * 0.8;

      setIsVisible(inRightSide);
    };

    document.addEventListener("mousemove", handleMouseMove);

    return () => {
      document.removeEventListener("mousemove", handleMouseMove);
    };
  }, []);

  useEffect(() => {
    listObjectDropdown({
      page: 1,
      limit: 25,
      museum_id: userData.museum,
      sort_by: "object_name",
      is_information_pending: false,
    })((response) => {
      if (response?.status) {
        const results = response?.data?.results;
        const filteredResults = results.filter((item) => item.value !== id);
        setObject(filteredResults);
        setDefaultObject(filteredResults);
      }
    });
  }, []);

  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleMouseMove = (event) => {
      const mouseX = event.clientX;
      const inRightSide = mouseX >= window.innerWidth * 0.8;

      setIsVisible(inRightSide);
    };

    document.addEventListener("mousemove", handleMouseMove);

    return () => {
      document.removeEventListener("mousemove", handleMouseMove);
    };
  }, []);

  useEffect(() => {
    if (id) {
      setLoading(true);

      getSingleObject({ id })((response) => {
        const dataValue = response?.data;
        console.log(
          dataValue?.original_location_room?.storage_system_id ||
            dataValue?.original_location_storage_system?.storage_system_id ||
            dataValue?.original_location_storage_unit?.storage_system_id,
          "dataValue"
        );

        setEra({
          value: dataValue?.period ? dataValue?.period : "CE",
          label: dataValue?.period ? dataValue?.period : "CE",
        });
        dataValue?.collection_is_draft ? setDraft(true) : setDraft(false);
        if (dataValue?.transit_location_room) {
          setLocationLabel("room");
        }
        if (dataValue?.transit_location_storage_system) {
          setLocationLabel("storage system");
        }
        if (dataValue?.transit_location_storage_unit) {
          setLocationLabel("storage unit");
        }
        let newAttribute = [];

        if (response?.status) {
          iSubmittedRef.current = false;
          isDetaillRef.current = true;
          setSelectedUser({
            value: dataValue?.object_assigned,
            label: dataValue?.object_assigned_name,
          });

          const sessionOpenValues = {
            museum: userData?.museum,
            museum_object: id,
            screen: "collection",
            status: "open",
            is_changes_made: false,
          };

          createSession(sessionOpenValues)((response) => {
            if (response?.status_code === 200) {
              sessionIdRef.current = response?.data?.id;
              localStorage.setItem("objectSession", sessionIdRef.current);
              sessionRef.current = true;
            }
          });

          setIsSameLocation(dataValue?.is_location_same);

          setLocationTransitValue({
            building: {
              value:
                dataValue?.transit_location_room?.building ||
                dataValue?.transit_location_storage_system?.building ||
                dataValue?.transit_location_storage_unit?.building,
              label:
                dataValue?.transit_location_room?.building_name ||
                dataValue?.transit_location_storage_system?.building_name ||
                dataValue?.transit_location_storage_unit?.building_name,
              code:
                dataValue?.transit_location_room?.code ||
                dataValue?.transit_location_storage_system?.code ||
                dataValue?.transit_location_storage_unit?.code,
            },
            floor: {
              value:
                dataValue?.transit_location_room?.floor ||
                dataValue?.transit_location_storage_system?.floor ||
                dataValue?.transit_location_storage_unit?.floor,
              label:
                dataValue?.transit_location_room?.floor_name ||
                dataValue?.transit_location_storage_system?.floor_name ||
                dataValue?.transit_location_storage_unit?.floor_name,
              code:
                dataValue?.transit_location_room?.floor_code ||
                dataValue?.transit_location_storage_system?.floor_code ||
                dataValue?.transit_location_storage_unit?.floor_code,
            },
            room: {
              value:
                dataValue?.transit_location_room?.room ||
                dataValue?.transit_location_storage_system?.room ||
                dataValue?.transit_location_storage_unit?.room,
              label:
                dataValue?.transit_location_room?.room_number ||
                dataValue?.transit_location_storage_system?.room_number ||
                dataValue?.transit_location_storage_unit?.room_number,
              code:
                dataValue?.transit_location_room?.code ||
                dataValue?.transit_location_storage_system?.code ||
                dataValue?.transit_location_storage_unit?.code,
            },
            systemtype: {
              value:
                dataValue?.transit_location_room?.storage_system_id ||
                dataValue?.transit_location_storage_system?.storage_system_id ||
                dataValue?.transit_location_storage_unit?.storage_system_id,
              label:
                dataValue?.transit_location_room?.storage_system_name ||
                dataValue?.transit_location_storage_system
                  ?.storage_system_name ||
                dataValue?.transit_location_storage_unit?.storage_system_name,
              code:
                dataValue?.transit_location_room?.storage_system_code ||
                dataValue?.transit_location_storage_system
                  ?.storage_system_code ||
                dataValue?.transit_location_storage_unit?.storage_system_code,
            },
            unitType: {
              value:
                dataValue?.transit_location_room?.storage_unit_id ||
                dataValue?.transit_location_storage_system?.storage_unit_id ||
                dataValue?.transit_location_storage_unit?.storage_unit_id,
              label:
                dataValue?.transit_location_room?.storage_unit ||
                dataValue?.transit_location_storage_system?.storage_unit ||
                dataValue?.transit_location_storage_unit?.storage_unit,
              code:
                dataValue?.transit_location_room?.storage_unit_code ||
                dataValue?.transit_location_storage_system?.storage_unit_code ||
                dataValue?.transit_location_storage_unit?.storage_unit_code,
            },
          });

          setLocationTransitId({
            building:
              dataValue?.transit_location_room?.building ||
              dataValue?.transit_location_storage_system?.building ||
              dataValue?.transit_location_storage_unit?.building,
            floor:
              dataValue?.transit_location_room?.floor ||
              dataValue?.transit_location_storage_system?.floor ||
              dataValue?.transit_location_storage_unit?.floor,
            room:
              dataValue?.transit_location_room?.room ||
              dataValue?.transit_location_storage_system?.room ||
              dataValue?.transit_location_storage_unit?.room,
            systemtype:
              dataValue?.transit_location_room?.storage_system_id ||
              dataValue?.transit_location_storage_system?.storage_system_id ||
              dataValue?.transit_location_storage_unit?.storage_system_id,
            unitType:
              dataValue?.transit_location_room?.storage_unit_id ||
              dataValue?.transit_location_storage_system?.storage_unit_id ||
              dataValue?.transit_location_storage_unit?.storage_unit_id,
          });
          setShowStorageTransit({
            sytemType:
              dataValue?.transit_location_room?.storage_system_id ||
              dataValue?.transit_location_storage_system?.storage_system_id ||
              dataValue?.transit_location_storage_unit?.storage_system_id
                ? true
                : false,
            unitType:
              dataValue?.transit_location_room?.storage_unit_id ||
              dataValue?.transit_location_storage_system?.storage_unit_id ||
              dataValue?.transit_location_storage_unit?.storage_unit_id
                ? true
                : false,
          });

          setLocationOriginalValue({
            building: {
              value:
                dataValue?.original_location_room?.building ||
                dataValue?.original_location_storage_system?.building ||
                dataValue?.original_location_storage_unit?.building,
              label:
                dataValue?.original_location_room?.building_name ||
                dataValue?.original_location_storage_system?.building_name ||
                dataValue?.original_location_storage_unit?.building_name,
              code:
                dataValue?.original_location_room?.code ||
                dataValue?.original_location_storage_system?.code ||
                dataValue?.original_location_storage_unit?.code,
            },
            floor: {
              value:
                dataValue?.original_location_room?.floor ||
                dataValue?.original_location_storage_system?.floor ||
                dataValue?.original_location_storage_unit?.floor,
              label:
                dataValue?.original_location_room?.floor_name ||
                dataValue?.original_location_storage_system?.floor_name ||
                dataValue?.original_location_storage_unit?.floor_name,
              code:
                dataValue?.original_location_room?.floor_code ||
                dataValue?.original_location_storage_system?.floor_code ||
                dataValue?.original_location_storage_unit?.floor_code,
            },
            room: {
              value:
                dataValue?.original_location_room?.room ||
                dataValue?.original_location_storage_system?.room ||
                dataValue?.original_location_storage_unit?.room,
              label:
                dataValue?.original_location_room?.room_number ||
                dataValue?.original_location_storage_system?.room_number ||
                dataValue?.original_location_storage_unit?.room_number,
              code:
                dataValue?.original_location_room?.room_code ||
                dataValue?.original_location_storage_system?.room_code ||
                dataValue?.original_location_storage_unit?.room_code,
            },
            systemtype: {
              value:
                dataValue?.original_location_room?.storage_system_id ||
                dataValue?.original_location_storage_system
                  ?.storage_system_id ||
                dataValue?.original_location_storage_unit?.storage_system_id,
              label:
                dataValue?.original_location_room?.storage_system_name ||
                dataValue?.original_location_storage_system
                  ?.storage_system_name ||
                dataValue?.original_location_storage_unit?.storage_system_name,
              code:
                dataValue?.original_location_room?.storage_system_code ||
                dataValue?.original_location_storage_system
                  ?.storage_system_code ||
                dataValue?.original_location_storage_unit?.storage_system_code,
            },
            unitType: {
              value:
                dataValue?.original_location_room?.storage_unit_id ||
                dataValue?.original_location_storage_system?.storage_unit_id ||
                dataValue?.original_location_storage_unit?.storage_unit_id,
              label:
                dataValue?.original_location_room?.storage_unit ||
                dataValue?.original_location_storage_system?.storage_unit ||
                dataValue?.original_location_storage_unit?.storage_unit,
              code:
                dataValue?.original_location_room?.storage_unit_code ||
                dataValue?.original_location_storage_system
                  ?.storage_unit_code ||
                dataValue?.original_location_storage_unit?.storage_unit_code,
            },
          });

          setLocationId({
            building:
              dataValue?.original_location_room?.building ||
              dataValue?.original_location_storage_system?.building ||
              dataValue?.original_location_storage_unit?.building,
            floor:
              dataValue?.original_location_room?.floor ||
              dataValue?.original_location_storage_system?.floor ||
              dataValue?.original_location_storage_unit?.floor,
            room:
              dataValue?.original_location_room?.room ||
              dataValue?.original_location_storage_system?.room ||
              dataValue?.original_location_storage_unit?.room,
            systemtype:
              dataValue?.original_location_room?.storage_system_id ||
              dataValue?.original_location_storage_system?.storage_system_id ||
              dataValue?.original_location_storage_unit?.storage_system_id,
            unitType:
              dataValue?.original_location_room?.storage_unit_id ||
              dataValue?.original_location_storage_system?.storage_unit_id ||
              dataValue?.original_location_storage_unit?.storage_unit_id,
          });

          setShowStorageOriginal({
            sytemType:
              dataValue?.original_location_room?.storage_system_id ||
              dataValue?.original_location_storage_system?.storage_system_id ||
              dataValue?.original_location_storage_unit?.storage_system_id
                ? true
                : false,
            unitType:
              dataValue?.original_location_room?.storage_unit_id ||
              dataValue?.original_location_storage_system?.storage_unit_id ||
              dataValue?.original_location_storage_unit?.storage_unit_id
                ? true
                : false,
          });

          setCurrentOriginal({
            value:
              dataValue?.original_location_room?.id ||
              dataValue?.original_location_storage_system?.id ||
              dataValue?.original_location_storage_unit?.id,
            label:
              dataValue?.original_location_room?.room_number ||
              dataValue?.original_location_storage_unit?.storage_unit ||
              dataValue.original_location_storage_system?.storage_system,
            code:
              dataValue?.original_location_room?.code ||
              dataValue?.original_location_storage_system?.code ||
              dataValue?.original_location_storage_unit?.code,
          });

          setCurrentTransit({
            value:
              dataValue?.transit_location_room?.id ||
              dataValue?.transit_location_storage_system?.id ||
              dataValue?.transit_location_storage_unit?.id,
            label:
              dataValue?.transit_location_room?.room_number ||
              dataValue?.transit_location_storage_unit?.storage_unit ||
              dataValue.transit_location_storage_system?.storage_system,
            code:
              dataValue?.transit_location_room?.code ||
              dataValue?.transit_location_storage_system?.code ||
              dataValue?.transit_location_storage_unit?.code,
          });

          setFetchOriginalCode({
            building: {
              value:
                dataValue?.original_location_storage_unit?.building ||
                dataValue?.original_location_storage_system?.building ||
                dataValue?.original_location_room?.building,
              label:
                dataValue?.original_location_storage_unit?.building_name ||
                dataValue?.original_location_storage_system?.building_name ||
                dataValue?.original_location_room?.building_name,
              code:
                dataValue?.original_location_storage_unit?.building_code ||
                dataValue?.original_location_storage_system?.building_code ||
                dataValue?.original_location_room?.building_code,
            },
            floor: {
              value:
                dataValue?.original_location_storage_unit?.floor ||
                dataValue?.original_location_storage_system?.floor ||
                dataValue?.original_location_room?.floor,
              label:
                dataValue?.original_location_storage_unit?.floor_name ||
                dataValue?.original_location_storage_system?.floor_name ||
                dataValue?.original_location_room?.floor_name,
              code:
                dataValue?.original_location_storage_unit?.floor_code ||
                dataValue?.original_location_storage_system?.floor_code ||
                dataValue?.original_location_room?.floor_code,
            },
            room: {
              value:
                dataValue?.original_location_storage_unit?.room ||
                dataValue?.original_location_storage_system?.room,
              label:
                dataValue?.original_location_storage_unit?.room_number ||
                dataValue?.original_location_storage_system?.room_number,
              code:
                dataValue?.original_location_storage_unit?.room_code ||
                dataValue?.original_location_storage_system?.room_code,
            },
            storageSystem: {
              value: dataValue?.original_location_storage_unit?.storage_system,
              label:
                dataValue?.original_location_storage_unit?.storage_system_name,
              code: dataValue?.original_location_storage_unit
                ?.storgae_system_code,
            },
          });

          setFetchCode({
            building: {
              value:
                dataValue?.transit_location_storage_unit?.building ||
                dataValue?.transit_location_storage_system?.building ||
                dataValue?.transit_location_room?.building,
              label:
                dataValue?.transit_location_storage_unit?.building_name ||
                dataValue?.transit_location_storage_system?.building_name ||
                dataValue?.transit_location_room?.building_name,
              code:
                dataValue?.transit_location_storage_unit?.building_code ||
                dataValue?.transit_location_storage_system?.building_code ||
                dataValue?.transit_location_room?.building_code,
            },
            floor: {
              value:
                dataValue?.transit_location_storage_unit?.floor ||
                dataValue?.transit_location_storage_system?.floor ||
                dataValue?.transit_location_room?.floor,
              label:
                dataValue?.transit_location_storage_unit?.floor_name ||
                dataValue?.transit_location_storage_system?.floor_name ||
                dataValue?.transit_location_room?.floor_name,
              code:
                dataValue?.transit_location_storage_unit?.floor_code ||
                dataValue?.transit_location_storage_system?.floor_code ||
                dataValue?.transit_location_room?.floor_code,
            },

            room: {
              value:
                dataValue?.transit_location_storage_unit?.room ||
                dataValue?.transit_location_storage_system?.room,
              label:
                dataValue?.transit_location_storage_unit?.room_number ||
                dataValue?.transit_location_storage_system?.room_number,
              code:
                dataValue?.transit_location_storage_unit?.room_code ||
                dataValue?.transit_location_storage_system?.room_code,
            },
            storageSystem: {
              value: dataValue?.transit_location_storage_unit?.storage_system,
              label:
                dataValue?.transit_location_storage_unit?.storage_system_name,
              code: dataValue?.transit_location_storage_unit
                ?.storgae_system_code,
            },
          });
          getSingleCategory({ id: dataValue?.category })(
            (responseofCategory) => {
              if (response?.status) {
                if (responseofCategory?.data?.attribute?.length > 0) {
                  setCategoryDetails(responseofCategory?.data?.attribute);
                  let newAttribute = [];
                  if (dataValue?.descriptors?.length > 0) {
                    const updatedAttributes = dataValue?.descriptors?.map(
                      (attribute) => {
                        const matchingDescriptor =
                          responseofCategory?.data?.attribute.find(
                            (descriptor) =>
                              descriptor.id === attribute.category_attributes
                          );

                        if (matchingDescriptor) {
                          return {
                            ...attribute,
                            attribute_name: matchingDescriptor.attribute,
                            options: matchingDescriptor.options,
                          };
                        }
                        return attribute;
                      }
                    );

                    // const multipleDropdown = dataValue?.descriptors?.find(li => li?.attribute_type === "Multiple dropdown");
                    // if (multipleDropdown) {
                    //     const newDescription = JSON.parse(multipleDropdown?.description);
                    //     setSelectedAttribute(newDescription?.map((desc) => ({
                    //         value: desc,  // This should match the `value` in options
                    //         label: desc
                    //     })));
                    // }

                    newAttribute = updatedAttributes;
                  } else {
                    const descriptorOptions =
                      responseofCategory?.data?.attribute?.map(
                        (li) => li?.options
                      );
                    responseofCategory?.data?.attribute?.length > 0 &&
                      setDescriptorsdata(descriptorOptions);
                    const newCreateAttribute =
                      responseofCategory?.data?.attribute?.map((li) => {
                        return {
                          category_attributes: li?.id,
                          attribute_name: li?.attribute,
                          attribute_type: li?.type,
                          options: li?.options,
                        };
                      });
                    newAttribute = newCreateAttribute;
                  }

                  const material = dataValue?.material.map((li) => li.id);
                  const selectedMaterialValue = dataValue?.material?.map(
                    (li) => ({
                      value: li.id,
                      label: li.material_name,
                    })
                  );

                  const newSelectedObject =
                    dataValue?.related_museum_object?.map((obj) => ({
                      ...obj,
                      label: obj?.label ? obj?.label : obj?.accession_number,
                    }));

                  const mappedValues = {
                    ...formik.values,
                    object_pinned_id: dataValue?.object_pinned_id,
                    is_pinned: dataValue?.is_pinned,
                    old_accession_number: dataValue?.old_accession_number,
                    originalBuilding:
                      dataValue?.original_location_room?.building ||
                      dataValue?.original_location_storage_system?.building ||
                      dataValue?.original_location_storage_unit?.building,
                    originalFloor:
                      dataValue?.original_location_room?.floor ||
                      dataValue?.original_location_storage_system?.floor ||
                      dataValue?.original_location_storage_unit?.floor,
                    originalRoom:
                      dataValue?.original_location_room?.room ||
                      dataValue?.original_location_storage_system?.room ||
                      dataValue?.original_location_storage_unit?.room,
                    originalsystemtype:
                      dataValue?.original_location_room?.storage_system_id ||
                      dataValue?.original_location_storage_system
                        ?.storage_system_id ||
                      dataValue?.original_location_storage_unit
                        ?.storage_system_id,
                    originalunitType:
                      dataValue?.original_location_room?.storage_unit_id ||
                      dataValue?.original_location_storage_system
                        ?.storage_unit_id ||
                      dataValue?.original_location_storage_unit
                        ?.storage_unit_id,
                    transitlBuilding:
                      dataValue?.transit_location_room?.building ||
                      dataValue?.transit_location_storage_system?.building ||
                      dataValue?.transit_location_storage_unit?.building,
                    transitlFloor:
                      dataValue?.transit_location_room?.floor ||
                      dataValue?.transit_location_storage_system?.floor ||
                      dataValue?.transit_location_storage_unit?.floor,
                    transitlRoom:
                      dataValue?.transit_location_room?.room ||
                      dataValue?.transit_location_storage_system?.room ||
                      dataValue?.transit_location_storage_unit?.room,
                    transitlsystemtype:
                      dataValue?.transit_location_room?.storage_system_id ||
                      dataValue?.transit_location_storage_system
                        ?.storage_system_id ||
                      dataValue?.transit_location_storage_unit
                        ?.storage_system_id,
                    transitlunitType:
                      dataValue?.transit_location_room?.storage_unit_id ||
                      dataValue?.transit_location_storage_system
                        ?.storage_unit_id ||
                      dataValue?.transit_location_storage_unit?.storage_unit_id,
                    attribute: newAttribute,
                    period: dataValue?.period ? dataValue?.period : "CE",
                    period_end_date: dataValue?.period_end_date
                      ? dataValue?.period_end_date
                      : "",
                    period_start_date: dataValue?.period_start_date
                      ? dataValue?.period_start_date
                      : "",
                    object_name: dataValue?.object_name
                      ? dataValue?.object_name
                      : "",
                    material: dataValue?.material ? material : "",
                    selectedMaterial: dataValue?.material
                      ? selectedMaterialValue
                      : [],
                    category: dataValue?.prime_category
                      ? dataValue?.prime_category
                      : "",
                    selectedCategory: dataValue?.prime_category
                      ? [
                          {
                            value: dataValue?.prime_category,
                            label: dataValue?.prime_category_name,
                          },
                        ]
                      : "",
                    sub_category: dataValue?.category
                      ? dataValue?.category
                      : "",
                    selectedSubcategory: dataValue?.category
                      ? [
                          {
                            value: dataValue?.category,
                            label: dataValue?.category_name,
                          },
                        ]
                      : "",
                    object_label: dataValue?.object_label,
                    iconic_object: dataValue?.iconic_object
                      ? dataValue?.iconic_object
                      : false,
                    height: dataValue?.height ? dataValue?.height : "",
                    width: dataValue?.width ? dataValue?.width : "",
                    depth: dataValue?.depth ? dataValue?.depth : "",
                    inscription_or_markers: dataValue?.inscription_or_markers
                      ? dataValue?.inscription_or_markers
                      : "",
                    preliminary_condition_assessment:
                      dataValue?.preliminary_condition_assessment
                        ? dataValue?.preliminary_condition_assessment
                        : "",
                    provenance: dataValue?.provenance
                      ? dataValue?.provenance
                      : "",
                    dateable_time_period: dataValue?.dateable_time_period
                      ? dataValue?.dateable_time_period
                      : "",
                    acquisition_method: dataValue?.acquisition_method,
                    selectedAcquistion: dataValue?.acquisition_method
                      ? [
                          {
                            value: dataValue?.acquisition_method,
                            label: dataValue?.acquisition_method,
                          },
                        ]
                      : "",
                    transit_location:
                      dataValue?.transit_location_room?.id ||
                      dataValue?.transit_location_storage_system?.id ||
                      dataValue?.transit_location_storage_unit?.id,
                    selectedTransit: {
                      value:
                        dataValue?.transit_location_room?.id ||
                        dataValue?.transit_location_storage_system?.id ||
                        dataValue?.transit_location_storage_unit?.id,
                      label:
                        dataValue?.transit_location_room?.room_number ||
                        dataValue?.transit_location_storage_unit
                          ?.storage_unit ||
                        dataValue.transit_location_storage_system
                          ?.storage_system,
                      code:
                        dataValue?.transit_location_room?.code ||
                        dataValue?.transit_location_storage_system?.code ||
                        dataValue?.transit_location_storage_unit?.code,
                    },
                    selectedOriginalLocation: {
                      value:
                        dataValue?.original_location_room?.id ||
                        dataValue?.original_location_storage_system?.id ||
                        dataValue?.original_location_storage_unit?.id,
                      label:
                        dataValue?.original_location_room?.room_number ||
                        dataValue?.original_location_storage_unit
                          ?.storage_unit ||
                        dataValue.original_location_storage_system
                          ?.storage_system,
                      code:
                        dataValue?.original_location_room?.code ||
                        dataValue?.original_location_storage_system?.code ||
                        dataValue?.original_location_storage_unit?.code,
                    },

                    original_location:
                      dataValue?.original_location_room?.id ||
                      dataValue?.original_location_storage_system?.id ||
                      dataValue?.original_location_storage_unit?.id,
                    tags: dataValue?.tags ? dataValue?.tags : [],
                    function_or_usages: dataValue?.function_or_usages
                      ? dataValue?.function_or_usages
                      : [],
                    additional_notes: dataValue?.additional_notes
                      ? dataValue?.additional_notes
                      : "",
                    description: dataValue?.description
                      ? dataValue?.description
                      : "",
                    reference_image: dataValue?.reference_image
                      ? dataValue?.reference_image
                      : "",
                    preview_image: dataValue?.reference_image
                      ? dataValue?.reference_image
                      : "",
                    collection_is_draft: dataValue?.collection_is_draft
                      ? dataValue?.collection_is_draft
                      : "",
                    dimensions: dataValue?.other_dimensions
                      ? dataValue?.other_dimensions
                      : [],
                    conservation_grade: dataValue?.conservation_grade
                      ? dataValue?.conservation_grade
                      : "",
                    technique: dataValue?.technique ? dataValue?.technique : "",
                    cultural_significance: dataValue?.cultural_significance
                      ? dataValue?.cultural_significance
                      : "",
                    references: dataValue?.references
                      ? dataValue?.references
                      : "",
                    historical_description: dataValue?.historical_description
                      ? dataValue?.historical_description
                      : "",
                    related_museum_object:
                      dataValue?.related_museum_object?.map((li) => li?.value),
                    selctedObject: newSelectedObject,
                    accession_number: dataValue?.accession_number,
                    number_of_missing_pieces:
                      dataValue?.number_of_missing_pieces,
                    number_of_parts: dataValue?.number_of_parts,
                    ledger_number: dataValue?.ledger_number,
                    page_number: dataValue?.page_number,
                    ledger_description: dataValue?.ledger_description,
                    ledger_translation: dataValue?.ledger_translation,
                    ledger_notes: dataValue?.ledger_notes,
                    ledger_image: dataValue?.ledger_image,
                    page_image: dataValue?.page_image,
                    is_location_same: dataValue?.is_location_same,
                    ledger_entry_images: dataValue?.ledger_entry_images,
                    selectedLedgerNumber: {
                      value: dataValue?.ledger_number,
                      label: dataValue?.ledger_number,
                    },
                  };

                  formik?.setValues(mappedValues);
                  setSavedFormikData(structuredClone(mappedValues));
                  setLoading(false);
                } else {
                  console.log(
                    dataValue?.original_location_storage_unit
                      ?.storage_system_id,
                    "storage_system_id"
                  );

                  const material = dataValue?.material.map((li) => li.id);
                  const selectedMaterialValue = dataValue?.material?.map(
                    (li) => ({
                      value: li.id,
                      label: li.material_name,
                    })
                  );

                  const newSelectedObject =
                    dataValue?.related_museum_object?.map((obj) => ({
                      ...obj,
                      label: obj?.label ? obj?.label : obj?.accession_number,
                    }));

                  const mappedValues = {
                    ...formik.values,
                    is_location_same: dataValue?.is_location_same,
                    object_pinned_id: dataValue?.object_pinned_id,
                    is_pinned: dataValue?.is_pinned,
                    old_accession_number: dataValue?.old_accession_number,
                    originalBuilding:
                      dataValue?.original_location_room?.building ||
                      dataValue?.original_location_storage_system?.building ||
                      dataValue?.original_location_storage_unit?.building,
                    originalFloor:
                      dataValue?.original_location_room?.floor ||
                      dataValue?.original_location_storage_system?.floor ||
                      dataValue?.original_location_storage_unit?.floor,
                    originalRoom:
                      dataValue?.original_location_room?.room ||
                      dataValue?.original_location_storage_system?.room ||
                      dataValue?.original_location_storage_unit?.room,
                    originalsystemtype:
                      dataValue?.original_location_room?.storage_system_id ||
                      dataValue?.original_location_storage_system
                        ?.storage_system_id ||
                      dataValue?.original_location_storage_unit
                        ?.storage_system_id,
                    originalunitType:
                      dataValue?.original_location_room?.storage_unit_id ||
                      dataValue?.original_location_storage_system
                        ?.storage_unit_id ||
                      dataValue?.original_location_storage_unit
                        ?.storage_unit_id,
                    transitlBuilding:
                      dataValue?.transit_location_room?.building ||
                      dataValue?.transit_location_storage_system?.building ||
                      dataValue?.transit_location_storage_unit?.building,
                    transitlFloor:
                      dataValue?.transit_location_room?.floor ||
                      dataValue?.transit_location_storage_system?.floor ||
                      dataValue?.transit_location_storage_unit?.floor,
                    transitlRoom:
                      dataValue?.transit_location_room?.room ||
                      dataValue?.transit_location_storage_system?.room ||
                      dataValue?.transit_location_storage_unit?.room,
                    transitlsystemtype:
                      dataValue?.transit_location_room?.storage_system_id ||
                      dataValue?.transit_location_storage_system
                        ?.storage_system_id ||
                      dataValue?.transit_location_storage_unit
                        ?.storage_system_id,
                    transitlunitType:
                      dataValue?.transit_location_room?.storage_unit_id ||
                      dataValue?.transit_location_storage_system
                        ?.storage_unit_id ||
                      dataValue?.transit_location_storage_unit?.storage_unit_id,
                    attribute: newAttribute,
                    period: dataValue?.period ? dataValue?.period : "CE",
                    period_end_date: dataValue?.period_end_date
                      ? dataValue?.period_end_date
                      : "",
                    period_start_date: dataValue?.period_start_date
                      ? dataValue?.period_start_date
                      : "",
                    object_name: dataValue?.object_name
                      ? dataValue?.object_name
                      : "",
                    material: dataValue?.material ? material : "",
                    selectedMaterial: dataValue?.material
                      ? selectedMaterialValue
                      : [],
                    category: dataValue?.prime_category
                      ? dataValue?.prime_category
                      : "",
                    selectedCategory: dataValue?.prime_category
                      ? [
                          {
                            value: dataValue?.prime_category,
                            label: dataValue?.prime_category_name,
                          },
                        ]
                      : "",
                    sub_category: dataValue?.category
                      ? dataValue?.category
                      : "",
                    selectedSubcategory: dataValue?.category
                      ? [
                          {
                            value: dataValue?.category,
                            label: dataValue?.category_name,
                          },
                        ]
                      : "",
                    object_label: dataValue?.object_label,
                    iconic_object: dataValue?.iconic_object
                      ? dataValue?.iconic_object
                      : false,
                    height: dataValue?.height ? dataValue?.height : "",
                    width: dataValue?.width ? dataValue?.width : "",
                    depth: dataValue?.depth ? dataValue?.depth : "",
                    inscription_or_markers: dataValue?.inscription_or_markers
                      ? dataValue?.inscription_or_markers
                      : "",
                    preliminary_condition_assessment:
                      dataValue?.preliminary_condition_assessment
                        ? dataValue?.preliminary_condition_assessment
                        : "",
                    provenance: dataValue?.provenance
                      ? dataValue?.provenance
                      : "",
                    dateable_time_period: dataValue?.dateable_time_period
                      ? dataValue?.dateable_time_period
                      : "",
                    acquisition_method: dataValue?.acquisition_method,
                    selectedAcquistion: dataValue?.acquisition_method
                      ? [
                          {
                            value: dataValue?.acquisition_method,
                            label: dataValue?.acquisition_method,
                          },
                        ]
                      : "",
                    transit_location:
                      dataValue?.transit_location_room?.id ||
                      dataValue?.transit_location_storage_system?.id ||
                      dataValue?.transit_location_storage_unit?.id,
                    selectedTransit: {
                      value:
                        dataValue?.transit_location_room?.id ||
                        dataValue?.transit_location_storage_system?.id ||
                        dataValue?.transit_location_storage_unit?.id,
                      label:
                        dataValue?.transit_location_room?.room_number ||
                        dataValue?.transit_location_storage_unit
                          ?.storage_unit ||
                        dataValue.transit_location_storage_system
                          ?.storage_system,
                      code:
                        dataValue?.transit_location_room?.code ||
                        dataValue?.transit_location_storage_system?.code ||
                        dataValue?.transit_location_storage_unit?.code,
                    },
                    selectedOriginalLocation: {
                      value:
                        dataValue?.original_location_room?.id ||
                        dataValue?.original_location_storage_system?.id ||
                        dataValue?.original_location_storage_unit?.id,
                      label:
                        dataValue?.original_location_room?.room_number ||
                        dataValue?.original_location_storage_unit
                          ?.storage_unit ||
                        dataValue.original_location_storage_system
                          ?.storage_system,
                      code:
                        dataValue?.original_location_room?.code ||
                        dataValue?.original_location_storage_system?.code ||
                        dataValue?.original_location_storage_unit?.code,
                    },
                    transitLocationTotaldata:
                      dataValue?.transit_location_room ||
                      dataValue?.transit_location_storage_system ||
                      dataValue?.transit_location_storage_unit,
                    originalLocationTotaldata:
                      dataValue?.original_location_room ||
                      dataValue?.original_location_storage_system ||
                      dataValue?.original_location_storage_unit,

                    original_location:
                      dataValue?.original_location_room?.id ||
                      dataValue?.original_location_storage_system?.id ||
                      dataValue?.original_location_storage_unit?.id,
                    tags: dataValue?.tags ? dataValue?.tags : [],
                    function_or_usages: dataValue?.function_or_usages
                      ? dataValue?.function_or_usages
                      : [],
                    additional_notes: dataValue?.additional_notes
                      ? dataValue?.additional_notes
                      : "",
                    description: dataValue?.description
                      ? dataValue?.description
                      : "",
                    reference_image: dataValue?.reference_image
                      ? dataValue?.reference_image
                      : "",
                    preview_image: dataValue?.reference_image
                      ? dataValue?.reference_image
                      : "",
                    collection_is_draft: dataValue?.collection_is_draft
                      ? dataValue?.collection_is_draft
                      : "",
                    dimensions: dataValue?.other_dimensions
                      ? dataValue?.other_dimensions
                      : [],
                    conservation_grade: dataValue?.conservation_grade
                      ? dataValue?.conservation_grade
                      : "",
                    technique: dataValue?.technique ? dataValue?.technique : "",
                    cultural_significance: dataValue?.cultural_significance
                      ? dataValue?.cultural_significance
                      : "",
                    references: dataValue?.references
                      ? dataValue?.references
                      : "",
                    historical_description: dataValue?.historical_description
                      ? dataValue?.historical_description
                      : "",
                    selectedConservation: {
                      value: dataValue?.conservation_grade,
                      label: dataValue?.conservation_grade,
                    },
                    ...(dataValue?.related_museum_object && {
                      related_museum_object: dataValue.related_museum_object,
                    }),
                    related_museum_object:
                      dataValue?.related_museum_object?.map((li) => li?.value),
                    selctedObject: newSelectedObject,
                    accession_number: dataValue?.accession_number,
                    number_of_missing_pieces:
                      dataValue?.number_of_missing_pieces,
                    number_of_parts: dataValue?.number_of_parts,
                    ledger_number: dataValue?.ledger_number,
                    page_number: dataValue?.page_number,
                    ledger_description: dataValue?.ledger_description,
                    ledger_translation: dataValue?.ledger_translation,
                    ledger_notes: dataValue?.ledger_notes,
                    ledger_image: dataValue?.ledger_image,
                    page_image: dataValue?.page_image,
                    ledger_entry_images: dataValue?.ledger_entry_images,
                    selectedLedgerNumber: {
                      value: dataValue?.ledger_number,
                      label: dataValue?.ledger_number,
                    },
                  };
                  console.log(mappedValues, "mappedValues");

                  formik.setValues(mappedValues);
                  setSavedFormikData(structuredClone(mappedValues));
                  setLoading(false);
                }
              }
            }
          );
        }
      });
      setRemovedLocation(removedLocation, formik.values.selectedTransit);
    }

    const fixedEl = titleRowRef.current;
    const containerEl = containerRef.current;

    const updateFixedHeader = () => {
      if (fixedEl && containerEl) {
        const { left, width } = containerEl.getBoundingClientRect();

        fixedEl.style.left = `${left}px`;
        fixedEl.style.width = `${width}px`;
      }
    };

    updateFixedHeader();
    window.addEventListener("resize", updateFixedHeader);

    return () => {
      window.removeEventListener("resize", updateFixedHeader);
    };
  }, [id, update]);

  console.log(formik?.values, "formikvalues");

  const handleMinusPreventHandler = (e) => {
    if (
      !/[0-9.]|Backspace|Delete|Tab|Escape|Enter/.test(e.key) ||
      (e.key === "." && formik.values.depth.includes("."))
    ) {
      e.preventDefault();
    }
    if (e.key === "-") {
      e.preventDefault();
    }
  };

  const locationTransitChangeHandler = (eValue, nameValueTranist) => {
    setIsAutoSave(true);
    setIsSameLocation(false);
    if (nameValueTranist === "building") {
      setLocationTransitId({
        ...locationTransitId,
        building: eValue?.value,
        floor: "",
        room: "",
        systemtype: "",
        unitType: "",
      });
      setLocationTransitValue({
        building: eValue,
        floor: null,
        room: null,
        systemtype: null,
        unitType: null,
      });
      formik.setValues({
        ...formik.values,
        transitlBuilding: eValue.value ? eValue.value : "",
        transit_location: eValue.value ? eValue.value : "",
        selectedTransit: eValue ? eValue : "",
      });
    } else if (nameValueTranist === "floor") {
      setLocationTransitId({
        ...locationTransitId,
        floor: eValue?.value,
        room: "",
        systemtype: "",
        unitType: "",
      });
      setLocationTransit({
        ...locationTransit,
        floor: locationTransit.defaultfloor,
      });
      setLocationTransitValue({
        ...locationTransitValue,
        floor: eValue,
        room: null,
        systemtype: null,
        unitType: null,
      });
      formik.setValues({
        ...formik.values,
        transitlFloor: eValue.value ? eValue.value : "",
        transit_location: eValue.value ? eValue.value : "",
        selectedTransit: eValue ? eValue : "",
      });
    } else if (nameValueTranist === "room") {
      setLocationTransitId({
        ...locationTransitId,
        room: eValue?.value,
        systemtype: "",
        unitType: "",
      });
      setLocationTransitValue({
        ...locationTransitValue,
        room: eValue,
        systemtype: null,
        unitType: null,
      });
      formik.setValues({
        ...formik.values,
        transitlRoom: eValue.value ? eValue.value : "",
        transit_location: eValue.value ? eValue.value : "",
        selectedTransit: eValue ? eValue : "",
      });
    } else if (nameValueTranist === "system") {
      setLocationTransitId({
        ...locationTransitId,
        systemtype: eValue?.value,
        unitType: "",
      });
      setLocationTransitValue({
        ...locationTransitValue,
        systemtype: eValue,
        unitType: null,
      });
      formik.setValues({
        ...formik.values,
        transitlsystemtype: eValue.value ? eValue.value : "",
        transit_location: eValue.value ? eValue.value : "",
        selectedTransit: eValue ? eValue : "",
      });
    } else if (nameValueTranist === "unit") {
      setLocationTransitId({
        ...locationTransitId,
        unitType: eValue?.value,
      });
      setLocationTransitValue({
        ...locationTransitValue,
        unitType: eValue,
      });
      formik.setValues({
        ...formik.values,
        transitlunitType: eValue.value ? eValue.value : "",
        transit_location: eValue.value ? eValue.value : "",
        selectedTransit: eValue ? eValue : "",
      });
    }
  };

  const onSelectsameLocationHandler = (value) => {
    setIsAutoSave(true);
    const checked = value?.target?.checked;
    setIsSameLocation(checked);
    if (checked) {
      setLocationTransitId({
        building: locationId?.building,
        floor: locationId?.floor,
        room: locationId?.room,
        systemtype: locationId?.systemtype,
        unitType: locationId?.unitType,
      });
      setLocationTransitValue({
        building: locationOriginalValue?.building,
        floor: locationOriginalValue?.floor,
        room: locationOriginalValue?.room,
        systemtype: locationOriginalValue?.systemtype,
        unitType: locationOriginalValue?.unitType,
      });

      formik.setValues({
        ...formik.values,
        is_location_same: true,
        transitlBuilding: formik?.values?.originalBuilding,
        transitlFloor: formik?.values?.originalFloor,
        transitlRoom: formik?.values?.originalRoom,
        transitlsystemtype: formik?.values?.originalsystemtype,
        transitlunitType: formik?.values?.originalunitType,
      });

      setShowStorageTransit({
        sytemType: showStorageOriginal?.sytemType,
        unitType: showStorageOriginal?.unitType,
      });
    } else {
      setLocationTransitId({
        building: "",
        floor: "",
        room: "",
        systemtype: "",
        unitType: "",
      });
      setLocationTransitValue({
        building: null,
        floor: null,
        room: null,
        systemtype: null,
        unitType: null,
      });

      formik.setValues({
        ...formik.values,
        is_location_same: false,
        transitlBuilding: "",
        transitlFloor: "",
        transitlRoom: "",
        transitlsystemtype: "",
        transitlunitType: "",
        original_location: "",
        selectedOriginalLocation: "",
      });

      setShowStorageTransit({
        sytemType: false,
        unitType: false,
      });
    }
  };

  const locationChangeHandler = (e, nameValue) => {
    setIsAutoSave(true);

    setIsSameLocation(false);
    if (nameValue === "building") {
      setLocationId((prev) => ({
        ...prev,
        building: e?.value,
        floor: "",
        room: "",
        systemtype: "",
        unitType: "",
      }));

      setLocationOriginalValue({
        building: e,
        floor: null,
        room: null,
        systemtype: null,
        unitType: null,
      });
      formik.setValues({
        ...formik.values,
        originalBuilding: e?.value ? e?.value : "",
        originalFloor: "",
        originalRoom: "",
        originalSystemtype: "",
        originalUnitType: "",
        original_location: e?.value ? e?.value : "",
        selectedOriginalLocation: e ? e : "",
        is_location_same: false,
      });
    } else if (nameValue === "floor") {
      setLocationId({
        ...locationId,
        floor: e?.value,
        room: "",
        systemtype: "",
        unitType: "",
      });

      setLocation({
        ...location,
        floor: location.defaultfloor,
      });
      setLocationOriginalValue({
        ...locationOriginalValue,
        floor: e,
        room: null,
        systemtype: null,
        unitType: null,
      });
      formik.setValues({
        ...formik.values,
        originalFloor: e?.value ? e?.value : "",
        originalRoom: "",
        originalSystemtype: "",
        originalUnitType: "",
        original_location: e?.value ? e?.value : "",
        selectedOriginalLocation: e ? e : "",
        is_location_same: false,
      });
    } else if (nameValue === "room") {
      setLocationId({
        ...locationId,
        room: e?.value,
        systemtype: "",
        unitType: "",
      });

      setLocationOriginalValue({
        ...locationOriginalValue,
        room: e,
        systemtype: null,
        unitType: null,
      });
      formik.setValues({
        ...formik.values,
        originalRoom: e?.value ? e?.value : "",
        originalSystemtype: "",
        originalUnitType: "",
        original_location: e?.value ? e?.value : "",
        selectedOriginalLocation: e ? e : "",
        is_location_same: false,
      });
    } else if (nameValue === "system") {
      setLocationId({
        ...locationId,
        systemtype: e?.value,
        unitType: "",
      });
      setLocationOriginalValue({
        ...locationOriginalValue,
        systemtype: e,
        unitType: null,
      });
      formik.setValues({
        ...formik.values,
        originalsystemtype: e?.value ? e?.value : "",
        originalUnitType: "",
        original_location: e?.value ? e?.value : "",
        selectedOriginalLocation: e ? e : "",
        is_location_same: false,
      });
    } else if (nameValue === "unit") {
      setLocationId({
        ...locationId,
        unitType: e?.value,
      });
      setLocationOriginalValue({
        ...locationOriginalValue,
        unitType: e,
      });
      formik.setValues({
        ...formik.values,
        originalunitType: e?.value ? e?.value : "",
        original_location: e?.value ? e?.value : "",
        selectedOriginalLocation: e ? e : "",
        is_location_same: false,
      });
    }
  };
  const removeStorageTransit = (removelabel) => {
    if (removelabel === "system") {
      setLocationTransitValue({
        ...locationTransitValue,
        systemtype: null,
        unitType: null,
      });

      setLocationTransitId({
        ...locationTransitId,
        systemtype: "",
        unitType: "",
      });
      setShowStorageTransit({
        sytemType: false,
        unitType: false,
      });
    }

    if (removelabel === "unit") {
      setLocationTransitValue({
        ...locationTransitValue,
        unitType: null,
      });

      setLocationTransitId({
        ...locationTransitId,
        unitType: "",
      });
      setShowStorageTransit({
        ...showStorageTransit,
        unitType: false,
      });
    }
  };

  const removeStorageOriginal = (removelabel) => {
    if (removelabel === "system") {
      setLocationOriginalValue({
        ...locationOriginalValue,
        systemtype: null,
        unitType: null,
      });

      setLocationId({
        ...locationId,
        systemtype: "",
        unitType: "",
      });
      setShowStorageOriginal({
        sytemType: false,
        unitType: false,
      });
      // formik.setValues({
      //   ...formik.values,
      //   originalsystemtype: "",
      //   originalunitType: "",
      //   original_location: formik.values.originalRoom || "",
      //   selectedOriginalLocation: locationOriginalValue?.room || null,
      // });
    }

    if (removelabel === "unit") {
      setLocationOriginalValue({
        ...locationOriginalValue,
        unitType: null,
      });

      setLocationId({
        ...locationId,
        unitType: "",
      });
      setShowStorageOriginal({
        ...showStorageOriginal,
        unitType: false,
      });
      // formik.setValues({
      //   ...formik.values,
      //   originalunitType: "",
      //   original_location: formik.values.originalsystemtype || "",
      //   selectedOriginalLocation: locationOriginalValue?.systemtype || null,
      // });
    }
  };

  const locationShowhandlerTransit = (valueOfLabel) => {
    if (valueOfLabel === "building") {
      const newtransitLocation = {
        ...formik?.values?.transitLocationTotaldata,
        buildingShow: true,
      };
      formik?.setValues({
        ...formik.values,
        transitLocationTotaldata: newtransitLocation,
      });
    } else if (valueOfLabel === "floor") {
      const newtransitLocation = {
        ...formik?.values?.transitLocationTotaldata,
        floorShow: true,
      };
      formik?.setValues({
        ...formik.values,
        transitLocationTotaldata: newtransitLocation,
      });
    } else if (valueOfLabel === "room") {
      setShowStorageTransit({
        ...showStorageTransit,
        sytemType: true,
      });
      const newtransitLocation = {
        ...formik?.values?.transitLocationTotaldata,
        roomShow: true,
      };
      formik?.setValues({
        ...formik.values,
        transitLocationTotaldata: newtransitLocation,
      });
    } else if (valueOfLabel === "system") {
      setShowStorageTransit({
        ...showStorageTransit,
        unitType: true,
      });
      const newtransitLocation = {
        ...formik?.values?.transitLocationTotaldata,
        systemShow: true,
      };
      formik?.setValues({
        ...formik.values,
        transitLocationTotaldata: newtransitLocation,
      });
    } else if (valueOfLabel === "unit") {
      const newtransitLocation = {
        ...formik?.values?.transitLocationTotaldata,
        unitShow: true,
      };
      formik?.setValues({
        ...formik.values,
        transitLocationTotaldata: newtransitLocation,
      });
    }
  };

  const locationShowhandlerOriginal = (valueOfLabel) => {
    if (valueOfLabel === "building") {
      const newOriginalLocation = {
        ...formik?.values?.originalLocationTotaldata,
        buildingShow: true,
      };
      formik?.setValues({
        ...formik.values,
        originalLocationTotaldata: newOriginalLocation,
      });
    } else if (valueOfLabel === "floor") {
      const newOriginalLocation = {
        ...formik?.values?.originalLocationTotaldata,
        floorShow: true,
      };
      formik?.setValues({
        ...formik.values,
        originalLocationTotaldata: newOriginalLocation,
      });
    } else if (valueOfLabel === "room") {
      setShowStorageOriginal({
        ...showStorageOriginal,
        sytemType: true,
      });
      const newOriginalLocation = {
        ...formik?.values?.originalLocationTotaldata,
        roomShow: true,
      };
      formik?.setValues({
        ...formik.values,
        originalLocationTotaldata: newOriginalLocation,
      });
    } else if (valueOfLabel === "system") {
      setShowStorageOriginal({
        ...showStorageOriginal,
        unitType: true,
      });
      const newOriginalLocation = {
        ...formik?.values?.originalLocationTotaldata,
        systemShow: true,
      };
      formik?.setValues({
        ...formik.values,
        originalLocationTotaldata: newOriginalLocation,
      });
    } else if (valueOfLabel === "unit") {
      const newOriginalLocation = {
        ...formik?.values?.originalLocationTotaldata,
        unitShow: true,
      };
      formik?.setValues({
        ...formik.values,
        originalLocationTotaldata: newOriginalLocation,
      });
    }
  };
  const attributeOptionAddhandler = (value, indexOfAttribute, datas) => {
    setIsAutoSave(true);

    const attributeList = [...formik?.values?.attribute];

    if (datas?.attribute_type === "Multiple dropdown") {
      setSelectedAttribute(value);
      const newArray = value?.map((li) => li?.label);

      const newArrayvalue = JSON.stringify(newArray);

      attributeList[indexOfAttribute].description = newArrayvalue;
      attributeList[indexOfAttribute].attribute_name = datas.attribute_name;
      attributeList[indexOfAttribute].category_attributes =
        datas.category_attributes;
    } else {
      attributeList[indexOfAttribute].description = value;
      attributeList[indexOfAttribute].attribute_name = datas.attribute_name;
      attributeList[indexOfAttribute].category_attributes =
        datas.category_attributes;
    }

    formik?.setValues({
      ...formik?.values,
      attribute: attributeList,
    });
  };

  const overRideConfirmHandler = () => {
    setLoading(true);
    iSubmittedRef.current = true;
    setIsOverRideLoad(true);
    setIsOverRide(false);
    const updateOverRideValue = { ...savedDataOverRide };

    updateOverRideValue.is_override = true;
    createObject(updateOverRideValue)((response) => {
      if (response?.status) {
        setLoading(false);
        setSavedDataOverRide();
        setIsOverRideLoad(false);
        setButtonloader(false);
        setDraftLoad(false);
        if (!oveRideFromNext && !oveRideFromPrevious) {
          toast.success(
            id ? "Object updated successfully!" : "Object created successfully!"
          );
        }
        if (fromList) {
          onCloseObject();
        } else if (oveRideFromNext) {
          navigate(
            `/${
              userData.museum_name
                ? userData?.museum_name?.split(" ").join("_")
                : "Nefos"
            }/${EDIT_OBJECT}/${nextId}`,
            {
              state: objectListFormikstate,
            }
          );
          setOverRideFromNext(false);
        } else if (oveRideFromPrevious) {
          navigate(
            `/${
              userData.museum_name
                ? userData?.museum_name?.split(" ").join("_")
                : "Nefos"
            }/${EDIT_OBJECT}/${previousId}`,
            {
              state: objectListFormikstate,
            }
          );
          setOverRideFromPrevious(false);
        } else if (fromNotification) {
          navigate(
            `/${
              userData.museum_name
                ? userData?.museum_name?.split(" ").join("_")
                : "Nefos"
            }/${lIST_NOTIFICATION}`
          );
        } else if (fromGlobal) {
          navigate(
            `/${
              userData.museum_name
                ? userData?.museum_name?.split(" ").join("_")
                : "Nefos"
            }/${GLOBAL_SEARCH}`
          );
        } else if (fromPin) {
          navigate(
            `/${
              userData.museum_name
                ? userData?.museum_name?.split(" ").join("_")
                : "Nefos"
            }/${OBJECT_PIN}`
          );
        } else {
          navigate(
            `/${
              userData.museum_name
                ? userData?.museum_name?.split(" ").join("_")
                : "Nefos"
            }/${LIST_OBJECT}`
          );
        }

        const assignValue = formik?.values?.assignValue;

        if (assignValue) {
          const newAssignValue = assignValue.id
            ? assignValue
            : { ...assignValue, id: response?.data?.id };

          assignUser(newAssignValue)((response) => {
            if (response?.status) {
            }
          });
        }
      } else {
        setLoading(false);
        setSavedDataOverRide();
        setIsOverRideLoad(false);
        setButtonloader(false);
        iSubmittedRef.current = false;
        setButtonloader(false);
        setDraftLoad(false);
      }
    });
  };

  const overRideCancel = (isClosed) => {
    setOverRideFromNext(false);
    setOverRideFromPrevious(false);
    setSavedDataOverRide();
    setIsOverRide(false);

    cancelSession({ id: sessionIdRef.current })((cancelResponse) => {
      if (cancelResponse?.status) {
        if (isClosed) {
          navigate(
            `/${
              userData.museum_name
                ? userData?.museum_name?.split(" ").join("_")
                : "Nefos"
            }/${LIST_OBJECT}`
          );
        } else {
          setUpdate(!update);
        }
      }
    });
  };

  // const attributeOptionAddhandler = (value, indexOfAttribute, datas) => {

  //     const attributeList = [...formik?.values?.attribute]

  //     if (datas?.attribute_type === "Multiple dropdown") {
  //         const newArray = value?.map((li) => li?.option)

  //         const newArrayvalue = JSON.stringify(newArray)

  //         attributeList[indexOfAttribute].description = newArrayvalue
  //         attributeList[indexOfAttribute].attribute_name = datas.attribute_name
  //         attributeList[indexOfAttribute].category_attributes = datas.category_attributes
  //         attributeList[indexOfAttribute].selected_desc = value

  //     } else {
  //         attributeList[indexOfAttribute].description = value
  //         attributeList[indexOfAttribute].attribute_name = datas.attribute_name
  //         attributeList[indexOfAttribute].category_attributes = datas.category_attributes
  //     }

  //     formik?.setValues({
  //         ...formik?.values,
  //         attribute: attributeList
  //     })
  // }
  let typingTimerUser;
  const userLoadOptionHandler = (inputValue) => {
    return new Promise((resolve, reject) => {
      clearTimeout(typingTimerUser);
      typingTimerUser = setTimeout(() => {
        if (inputValue.length >= 1) {
          listUserDropdown({
            page: 1,
            museum_id: userData.museum,
            search: inputValue,
          })((response) => {
            if (response?.status) {
              setUser(response?.data);
              resolve(response?.data);
            }
          });
        } else {
          resolve([]);
        }
      }, 300);
    });
  };

  ////Transit location loadoptions////////

  const partsNumberHandler = (e) => {
    setIsAutoSave(true);
    const value = e.target.value;

    // Check if value contains any letters
    if (/[a-zA-Z]/.test(value)) {
      sethasletter({
        ...hasLetter,
        numberOfParts: true,
      });
    } else {
      sethasletter({
        ...hasLetter,
        numberOfParts: false,
      });
      formik?.setValues({
        ...formik?.values,
        number_of_parts: value,
      });
    }
  };

  const missingNumberHandler = (e) => {
    setIsAutoSave(true);
    const value = e.target.value;

    // Check if value contains any letters
    if (/[a-zA-Z]/.test(value)) {
      sethasletter({
        ...hasLetter,
        numberOfMissing: true,
      });
    } else {
      sethasletter({
        ...hasLetter,
        numberOfMissing: false,
      });
      formik?.setValues({
        ...formik?.values,
        number_of_missing_pieces: value,
      });
    }
  };

  let typingTimerTransit;

  const unitTypetypeLoadOptionHandlerTransit = (inputValue) => {
    return new Promise((resolve, reject) => {
      clearTimeout(typingTimerTransit);
      typingTimerTransit = setTimeout(() => {
        if (inputValue.length >= 1) {
          storageUnitDropdown({
            page: 1,
            storage_system_id: locationTransitId?.systemtype,
            search: inputValue,
            sort_by: "storage_unit",
          })((response) => {
            if (response?.status) {
              setLocation({
                ...location,
                unitType: response?.data,
              });
              resolve(response?.data);
            }
          });
        } else {
          resolve([]);
        }
      }, 300);
    });
  };

  const systemtypeLoadOptionHandlerTransit = (inputValue) => {
    return new Promise((resolve, reject) => {
      clearTimeout(typingTimerTransit);
      typingTimerTransit = setTimeout(() => {
        if (inputValue.length >= 1) {
          listshelfDropdown({
            page: 1,
            room_id: locationTransitId?.room,
            search: inputValue,
            sort_by: "storage_system",
          })((response) => {
            if (response?.status) {
              setLocation({
                ...location,
                systemtype: response?.data,
              });
              resolve(response?.data);
            }
          });
        } else {
          resolve([]);
        }
      }, 300);
    });
  };

  const roomLoadOptionHandlerTransit = (inputValue) => {
    return new Promise((resolve, reject) => {
      clearTimeout(typingTimerTransit);
      typingTimerTransit = setTimeout(() => {
        if (inputValue.length >= 1) {
          listRoomDropdown({
            page: 1,
            floor_id: locationTransitId?.floor,
            search: inputValue,
            sort_by: "room_number",
          })((response) => {
            if (response?.status) {
              setLocation({
                ...location,
                room: response?.data,
              });
              resolve(response?.data);
            }
          });
        } else {
          resolve([]);
        }
      }, 300);
    });
  };

  const floorLoadOptionHandlerTransit = (inputValue) => {
    return new Promise((resolve, reject) => {
      clearTimeout(typingTimerTransit);
      typingTimerTransit = setTimeout(() => {
        if (inputValue.length >= 1) {
          listFloorDropdown({
            page: 1,
            building_id: locationTransitId?.building,
            search: inputValue,
            sort_by: "floor_name",
          })((response) => {
            if (response?.status) {
              setLocation({
                ...location,
                floor: response?.data,
              });
              resolve(response?.data);
            }
          });
        } else {
          resolve([]);
        }
      }, 300);
    });
  };

  const buildingLoadOptionHandlerTransit = (inputValue) => {
    return new Promise((resolve, reject) => {
      clearTimeout(typingTimerTransit);
      typingTimerTransit = setTimeout(() => {
        if (inputValue.length >= 1) {
          listBuildingDropdown({
            page: 1,
            museum_id: userData.museum,
            search: inputValue,
            sort_by: "building_name",
          })((response) => {
            if (response?.status) {
              setLocation({
                ...location,
                building: response?.data,
              });
              resolve(response?.data);
            }
          });
        } else {
          resolve([]);
        }
      }, 300);
    });
  };
  ////Transit location loadoptions////////

  //////Original location loadoptions////////

  let typingTimerOrginal;

  const unitTypetypeLoadOptionHandler = (inputValue) => {
    return new Promise((resolve, reject) => {
      clearTimeout(typingTimerOrginal);
      typingTimerOrginal = setTimeout(() => {
        if (inputValue.length >= 1) {
          storageUnitDropdown({
            page: 1,
            storage_system_id: locationId?.systemtype,
            search: inputValue,
            sort_by: "storage_unit",
          })((response) => {
            if (response?.status) {
              setLocation({
                ...location,
                unitType: response?.data,
              });
              resolve(response?.data);
            }
          });
        } else {
          resolve([]);
        }
      }, 300);
    });
  };

  const systemtypeLoadOptionHandler = (inputValue) => {
    return new Promise((resolve, reject) => {
      clearTimeout(typingTimerOrginal);
      typingTimerOrginal = setTimeout(() => {
        if (inputValue.length >= 1) {
          listshelfDropdown({
            page: 1,
            room_id: locationId?.room,
            search: inputValue,
            sort_by: "storage_system",
          })((response) => {
            if (response?.status) {
              setLocation({
                ...location,
                systemtype: response?.data,
              });
              resolve(response?.data);
            }
          });
        } else {
          resolve([]);
        }
      }, 300);
    });
  };

  const roomLoadOptionHandler = (inputValue) => {
    return new Promise((resolve, reject) => {
      clearTimeout(typingTimerOrginal);
      typingTimerOrginal = setTimeout(() => {
        if (inputValue.length >= 1) {
          listRoomDropdown({
            page: 1,
            floor_id: locationId?.floor,
            search: inputValue,
            sort_by: "room_number",
          })((response) => {
            if (response?.status) {
              setLocation({
                ...location,
                room: response?.data,
              });
              resolve(response?.data);
            }
          });
        } else {
          resolve([]);
        }
      }, 300);
    });
  };

  const floorLoadOptionHandler = (inputValue) => {
    return new Promise((resolve, reject) => {
      clearTimeout(typingTimerOrginal);
      typingTimerOrginal = setTimeout(() => {
        if (inputValue.length >= 1) {
          listFloorDropdown({
            page: 1,
            building_id: locationId?.building,
            search: inputValue,
            sort_by: "floor_name",
          })((response) => {
            if (response?.status) {
              setLocation({
                ...location,
                floor: response?.data,
              });
              resolve(response?.data);
            }
          });
        } else {
          resolve([]);
        }
      }, 300);
    });
  };

  const buildingLoadOptionHandler = (inputValue) => {
    return new Promise((resolve, reject) => {
      clearTimeout(typingTimerOrginal);
      typingTimerOrginal = setTimeout(() => {
        if (inputValue.length >= 1) {
          listBuildingDropdown({
            page: 1,
            museum_id: userData.museum,
            search: inputValue,
            sort_by: "building_name",
          })((response) => {
            if (response?.status) {
              setLocation({
                ...location,
                building: response?.data,
              });
              resolve(response?.data);
            }
          });
        } else {
          resolve([]);
        }
      }, 300);
    });
  };
  //////Original location loadoptions////////

  /////////Original location dropdowns/////////////////////////
  useEffect(() => {
    if (locationId?.systemtype) {
      storageUnitDropdown({
        page: 1,
        storage_system_id: locationId?.systemtype,
        sort_by: "storage_unit",
      })((response) => {
        if (response?.status) {
          setProgressCount(4);
          setTransitLoc("Storage system");
          setLocationLabel("Storage unit");
          setLocation((prevState) => ({
            ...prevState,
            unitType: response?.data,
          }));
        }
      });
    }
  }, [locationId?.systemtype]);

  console.log(locationId, "locationIdOriginal");

  useEffect(() => {
    if (locationId?.room) {
      listshelfDropdown({
        page: 1,
        room_id: locationId?.room,
        sort_by: "storage_system",
      })((response) => {
        if (response?.status) {
          setProgressCount(3);
          setTransitLoc("Room");
          setLocationLabel("Storage system");
          setLocation((prevState) => ({
            ...prevState,
            systemtype: response?.data,
          }));
        }
      });
    }
  }, [locationId?.room]);

  useEffect(() => {
    if (locationId?.floor) {
      listRoomDropdown({
        page: 1,
        floor_id: locationId?.floor,
        sort_by: "room_number",
      })((response) => {
        if (response?.status) {
          setProgressCount(2);
          setTransitLoc("Floor");
          setLocationLabel("Room");
          setLocation((prevState) => ({
            ...prevState,
            room: response?.data,
          }));
        }
      });
    }
  }, [locationId?.floor]);
  useEffect(() => {
    if (locationId?.building) {
      listFloorDropdown({
        page: 1,
        building_id: locationId?.building,
        sort_by: "floor_name",
      })((response) => {
        if (response?.status) {
          setProgressCount(1);
          setTransitLoc("Building");
          setLocationLabel("Floor");
          setLocation((prevState) => ({
            ...prevState,
            floor: response?.data,
            defaultfloor: response?.data,
          }));
        }
      });
    }
  }, [locationId?.building]);

  /////////Transit location dropdowns/////////////////////////
  useEffect(() => {
    if (locationTransitId?.systemtype) {
      storageUnitDropdown({
        page: 1,
        storage_system_id: locationTransitId?.systemtype,
        sort_by: "storage_unit",
      })((response) => {
        if (response?.status) {
          setProgressCount(4);
          setTransitLoc("Storage system");
          setLocationLabel("Storage unit");
          setLocationTransit((prevState) => ({
            ...prevState,
            unitType: response?.data,
          }));
        }
      });
    }
  }, [locationTransitId?.systemtype]);

  useEffect(() => {
    if (locationTransitId?.room) {
      listshelfDropdown({
        page: 1,
        room_id: locationTransitId?.room,
        sort_by: "storage_system",
      })((response) => {
        if (response?.status) {
          setProgressCount(3);
          setTransitLoc("Room");
          setLocationLabel("Storage system");
          setLocationTransit((prevState) => ({
            ...prevState,
            systemtype: response?.data,
          }));
        }
      });
    }
  }, [locationTransitId?.room]);

  useEffect(() => {
    if (locationTransitId?.floor) {
      listRoomDropdown({
        page: 1,
        floor_id: locationTransitId?.floor,
        sort_by: "room_number",
      })((response) => {
        if (response?.status) {
          setProgressCount(2);
          setTransitLoc("Floor");
          setLocationLabel("Room");
          setLocationTransit((prevState) => ({
            ...prevState,
            room: response?.data,
          }));
        }
      });
    }
  }, [locationTransitId?.floor]);
  useEffect(() => {
    if (locationTransitId?.building) {
      listFloorDropdown({
        page: 1,
        building_id: locationTransitId?.building,
        sort_by: "floor_name",
      })((response) => {
        if (response?.status) {
          setProgressCount(1);
          setTransitLoc("Building");
          setLocationLabel("Floor");
          setLocationTransit((prevState) => ({
            ...prevState,
            floor: response?.data,
            defaultfloor: response?.data,
          }));
        }
      });
    }
  }, [locationTransitId?.building]);

  useEffect(() => {
    listBuildingDropdown({
      page: 1,
      museum_id: userData.museum,
      sort_by: "building_name",
    })((response) => {
      if (response?.status) {
        setOrginlabel("building");
        setLocationTransit((prevState) => ({
          ...prevState,
          building: response?.data,
        }));
      }
    });
  }, []);

  useEffect(() => {
    listUserDropdown({ page: 1, museum_id: userData.museum })((response) => {
      if (response?.status) {
        setUser(response?.data);
        setDefaultUser(response?.data);
      }
    });
  }, []);

  useEffect(() => {
    if (fromNotification) {
      setIsOpen(true);
      navigate(locationState.pathname, { replace: true, state: null });
    }
  }, [fromNotification]);

  const customRelatedComponent = {
    Option: (props) => (
      <div
        {...props.innerRef}
        {...props.innerProps}
        style={{
          backgroundColor: props.isFocused ? "#eee" : "transparent",
          padding: 10,
          cursor: "pointer",
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <div style={{ display: "flex", gap: "10px" }}>
          <div
            style={{
              height: "50px",
              width: "50px",
              border: "1px solid lightgray ",
              borderRadius: "5px",
              padding: "3px",
            }}
          >
            <img
              style={{ height: "100%", width: "100%", objectFit: "contain" }}
              src={
                props.data.image_thumbnail
                  ? props.data.image_thumbnail
                  : notFound
              }
            />
          </div>
          <div style={{ width: "180px", wordBreak: "break-word" }}>
            <p>{props.data.label}</p>
          </div>
        </div>
        <div>
          <p style={{ color: "gray" }}>{props.data.accession_number}</p>
        </div>
      </div>
    ),
  };

  // useEffect(() => {
  //     const fixedEl = titleRowRef.current;
  //     const containerEl = containerRef.current;

  //     const updateFixedHeader = () => {
  //         if (fixedEl && containerEl) {

  //             const { left, width } = containerEl.getBoundingClientRect();
  //             console.log(width, "width");

  //                 fixedEl.style.left = `${left}px`;
  //                 fixedEl.style.width = `${width}px`;

  //         }
  //     };

  //     updateFixedHeader()
  //     window.addEventListener('resize', updateFixedHeader);

  //     return () => {
  //         window.removeEventListener('resize', updateFixedHeader);
  //     };
  // }, [location,id,user,locationTransit,loading]);

  useEffect(() => {
    console.log("component reopnened");
  }, [fromList]);

  useEffect(() => {
    if (isAutosave) {
      const savedFormik = formik?.values;
      if (id) savedFormik.id = id;
      autoSaveToIndexedDB("collection", savedFormik);
    }
  }, [formik]);

  useEffect(() => {
    if (newValue === "") {
      setCatgory(defaultcategory);
      setMaterial(defaultMaterial);
      setUser(defaultUser);
    }
  }, [newValue, category, material, user]);

  const Notificationpop = ({
    isVisible,
    toggleDrawer,
    toggleDrawerhistory,
  }) => {
    return createPortal(
      <div
        className="notification"
        style={{
          zIndex: "999",
          top: fromList ? "45vh" : "40vh",
          display: isVisible ? "block" : "none",
          opacity: isVisible ? 1 : 0,
          visibility: isVisible ? "visible" : "hidden",
        }}
      >
        <Tooltip title="Discussions" placement="left">
          <div className="cmt-icon-query" onClick={toggleDrawer}>
            <TbMessageCircleCheck size={21} />
          </div>
        </Tooltip>
        <Tooltip title="History" placement="left">
          <div className="cmt-icon-history" onClick={toggleDrawerhistory}>
            <RiHistoryLine size={20} />
          </div>
        </Tooltip>
      </div>,
      document.body
    );
  };

  // useEffect(() => {
  //   // Scroll to the top when the component mounts
  //   window.scrollTo({ top: 0, behavior: "smooth" });
  // }, [fromGlobal]);

  useEffect(() => {
    setNextId(null);
    setPreviousId(null);
    if (id) {
      const objectListdata = {
        ...objectListFormik,
        current_object: id,
        screen: fromPin ? "pinned_objects" : "collection",
        is_global_search: fromGlobal ? true : false,
      };

      if (fromUsedObject || fromLocation) {
        delete objectListdata.screen;
        delete objectListdata.is_global_search;
      }

      nextAndPreviousHandler(objectListdata)((response) => {
        if (response?.status) {
          if (response?.data?.next_object) {
            setNextId(response?.data?.next_object);
          }
          if (response?.data?.previous_object) {
            setPreviousId(response?.data?.previous_object);
          }
        }
      });
    }
  }, [id]);
  useEffect(() => {
    // Scroll to the top when the component mounts
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  useEffect(() => {
    if (id) {
      if (isDetaillRef.current && isAutosave) {
        const hasChangedDetail = !deepEqual(formik?.values, savedFormikData);
        if (hasChangedDetail) {
          isChangedRef.current = true;
          localStorage.setItem("objectChanges", true);
        } else {
          isChangedRef.current = false;
        }
      }
    }
  }, [formik.values]);

  // useEffect(() => {
  //   const formikValues = formik?.values;
  //   const sessionOpenValues = {
  //     museum: userData?.museum,
  //     museum_object: id,
  //     screen: "collection",
  //     status: formikValues?.sessionStatus,
  //     is_changes_made: formikValues?.is_changes_made,
  //   };
  //   if (!sessionRef.current) {
  //     createSession(sessionOpenValues)((response) => {
  //       if (response?.status_code === 200) {
  //         formik?.setValues({
  //           ...formik?.values,
  //           sessionId: response?.data?.id,
  //         });
  //         sessionIdRef.current = response?.data?.id;
  //         sessionRef.current = true;
  //       }
  //     });
  //   }
  // }, [formik?.values?.sessionId,sessionRef.current]);

  // ✅ Trigger on tab close / external navigation
  useEffect(() => {
    const markRefresh = () => {
      if (!iSubmittedRef.current) {
        sessionStorage.setItem("justRefreshed", "true");
      }
    };
    window.addEventListener("beforeunload", markRefresh);
    return () => {
      window.removeEventListener("beforeunload", markRefresh);
    };
  }, []);
  useEffect(() => {
    const handleBeforeUnload = () => {
      if (!iSubmittedRef.current && !isAutosave && id) {
        sendSessionClose("isClosing");
      }
    };
    window.addEventListener("unload", handleBeforeUnload);
    return () => window.removeEventListener("unload", handleBeforeUnload);
  }, []);

  useEffect(() => {
    isAutosaveRef.current = isAutosave;
  }, [isAutosave]);

  useEffect(() => {
    return () => {
      if (!iSubmittedRef.current && !isAutosaveRef.current && id) {
        sendSessionClose("isClosing");
      }
    };
  }, [location.pathname]);
  useEffect(() => {
    if (!fromList) {
      const values = {
        museum: userData?.museum,
        screen: "Collection",
      };
      if (userUsedLastScreen !== "Collection") {
        usedLastScreen(values)((response) => {
          localStorage.setItem(
            "user_info",
            JSON.stringify({ ...userData, last_used_screen: "Collection" })
          );
        });
      }
    }
  }, []);

  useEffect(() => {
    if (isOpen || isOpenhistory) {
      document.body.style.overflow = "hidden"; // disable background scroll
    } else {
      document.body.style.overflow = "auto"; // restore scroll
    }

    return () => {
      document.body.style.overflow = "auto"; // cleanup
    };
  }, [isOpen, isOpenhistory]);

  useEffect(() => {
    const handleScroll = () => {
      const width = window.innerWidth;
      if (width < 768) {
        setShowLocationLabel(false);
      } else {
        setShowLocationLabel(true);
      }
    };

    handleScroll(); // set initial state on page load
    window.addEventListener("resize", handleScroll);

    return () => window.removeEventListener("resize", handleScroll);
  }, []);
  console.log(showLocationLabel, "showLocationLabel");
  return (
    <>
      {loading || nextAndPreviousLoad.next || nextAndPreviousLoad.previous ? (
        <Loader />
      ) : (
        <section
          style={{ paddingTop: "60px" }}
          className="dashboard asset-management light-wrapper dark-wrapper"
        >
          {buttonloader && <div className="overlay-cover" />}
          {showImageEnlarge?.show && (
            <ImageEnlarge
              imageData={showImageEnlarge}
              setShowReference={setShowEnlargeImage}
            />
          )}
          <div
            style={{ position: "relative" }}
            className="add-building-container"
          >
            {/* <div
                        className="hover-button"
                       >
                        <div className='btn-main-div' >
                            <div className='btn-sub-div' >
                                <div className='cmt-btn-div' >
                                    <button
                                        onClick={toggleDrawer}
                                        className="cmt-btn" >
                                        <h3 style={{ fontWeight: 'normal', fontSize: '12px', height: "100%", width: '100%' }} >Queries</h3>
                                    </button>
                                </div>
                                <div className='cmt-btn-div'  >
                                    <button className='cmt-btn' onClick={comingSoonHandler} >
                                        <h3 style={{ fontWeight: 'normal', fontSize: '12px', height: "100%", width: '100%' }} >History</h3>
                                    </button>
                                </div>
                            </div> */}
            {id &&
              (fromList ? (
                <Notificationpop
                  isVisible={isVisible}
                  toggleDrawer={toggleDrawer}
                  toggleDrawerhistory={toggleDrawerhistory}
                />
              ) : (
                <div
                  className="notification"
                  style={{
                    top: fromList ? "45vh" : "40vh",
                    display: isVisible ? "block" : "none",
                    opacity: isVisible ? 1 : 0,
                    visibility: isVisible ? "visible" : "hidden",
                  }}
                >
                  <Tooltip
                    title="Discussions"
                    placement="left"
                    sx={{
                      backgroundColor: "#E2F1FF ",
                    }}
                  >
                    <div className="cmt-icon-query" onClick={toggleDrawer}>
                      <TbMessageCircleCheck size={21} />
                    </div>
                  </Tooltip>
                  <Tooltip title="History" placement="left">
                    <div
                      className="cmt-icon-history"
                      onClick={toggleDrawerhistory}
                    >
                      <RiHistoryLine size={20} />
                    </div>
                  </Tooltip>
                </div>
              ))}
            {/* </div> */}

            {/* </div> */}
            <Container ref={containerRef}>
              <Form
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                  }
                }}
                onSubmit={formik.handleSubmit}
              >
                <div
                  onClick={closehandler}
                  ref={titleRowRef}
                  className="add-category-title-row"
                  style={{
                    flexDirection: "column",
                    position: "sticky",
                    zIndex: "2",
                    backgroundColor: "white",
                    top: fromList ? "0px" : "61px",
                    paddingTop: "20px",
                    boxShadow: "rgba(0, 0, 0, 0.45) 0px 25px 20px -34px",
                  }}
                >
                  <div
                    style={{
                      justifyContent: "space-between",
                      flexWrap: "wrap",
                    }}
                    className=" title-row-content"
                  >
                    <div style={{ display: "flex", gap: "9px" }}>
                      <div className="title-icon " onClick={handleBack}>
                        <GoArrowLeft />
                      </div>
                      <div className=" titles">
                        <p>Back to object list</p>
                        <h4>{id ? "Update object" : "Add new object"}</h4>
                      </div>
                    </div>
                    <div
                      style={{ paddingTop: "0px", paddingBottom: "0px" }}
                      className="submit-btn-row"
                    >
                      {id && !fromList && (
                        <Tooltip
                          title={previousId ? "" : "No previous object"}
                          placement="top-start"
                        >
                          <Button
                            onClick={previousObjectHandler}
                            className={
                              nextAndPreviousLoad?.previous
                                ? "submit-btn"
                                : "discard-btn"
                            }
                            type="button"
                            style={{
                              cursor: previousId ? "pointer" : "not-allowed",
                              pointerEvents: "auto",
                              paddingBottom: "6px",
                              paddingTop: "6px",
                            }}
                            disabled={!previousId}
                          >
                            {nextAndPreviousLoad?.previous ? (
                              <SimpleBackdrop />
                            ) : (
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "7px",
                                }}
                              >
                                <GrLinkPrevious style={{ fontSize: "18px" }} />
                                <p> Previous object</p>
                              </div>
                            )}
                          </Button>
                        </Tooltip>
                      )}
                      {id && !fromList && (
                        <Tooltip
                          title={nextId ? "" : "No next objects"}
                          placement="top-end"
                        >
                          <Button
                            onClick={nextObjectHandler}
                            className={
                              nextAndPreviousLoad?.next
                                ? "submit-btn"
                                : "discard-btn"
                            }
                            type="button"
                            disabled={!nextId}
                            style={{
                              cursor: nextId ? "pointer" : "not-allowed",
                              pointerEvents: "auto",
                              paddingBottom: "6px",
                              paddingTop: "6px",
                            }}
                          >
                            {nextAndPreviousLoad?.next ? (
                              <SimpleBackdrop />
                            ) : (
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "7px",
                                }}
                              >
                                <p> Next object</p>
                                <GrLinkNext style={{ fontSize: "18px" }} />
                              </div>
                            )}
                          </Button>
                        </Tooltip>
                      )}
                    </div>
                  </div>
                  <div className="object-information-titltle">
                    <h5 style={{ fontWeight: "600" }}>Object information</h5>
                  </div>

                  <Row className="object-assign-container">
                    <Col className="left-input-assign" lg={5}>
                      <Form.Group className="left-input-field">
                        <Form.Label className="leftinput-label">
                          Object name
                          <span className="required">
                            <sup>*</sup>
                          </span>
                        </Form.Label>
                        <Form.Control
                          value={formik.values.object_name}
                          onChange={(e) => {
                            formik.handleChange(e);
                            setIsAutoSave(true);
                            setObjectEditData((prev) => ({
                              ...prev,
                              objectId: id,
                              objectName: e?.target?.value,
                            }));
                          }}
                          name="object_name"
                          type="text"
                          placeholder="Object name"
                          isInvalid={
                            formik.touched?.object_name &&
                            !!formik?.errors?.object_name
                          }
                        />
                        <Form.Control.Feedback type="invalid">
                          {formik?.errors?.object_name}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col className="right-input-assign" lg={4}>
                      <Form.Group className="right-input-field">
                        <Form.Label className="rightinput-label">
                          Assign user
                        </Form.Label>
                        <AsyncSelect
                          loadOptions={userLoadOptionHandler}
                          defaultOptions={user}
                          value={selectedUser}
                          type="text"
                          placeholder="Select"
                          styles={{
                            control: (provided, state) => ({
                              ...provided,
                              width: "100%",
                              backgroundColor: state.isDisabled
                                ? "white"
                                : "white",
                            }),
                            placeholder: (provided, state) => ({
                              ...provided,
                              color: state.isDisabled && provided.color,
                            }),
                          }}
                          className="assign-user-async"
                          onChange={userChangeHandler}
                          onInputChange={(newValue, { action }) => {
                            setNewValue(newValue);
                            if (action === "input-change" && newValue === "") {
                              setUser(defaultUser); // Reset to default options
                            }
                          }}
                        />
                      </Form.Group>
                      <div className="object-pin-container">
                        <Tooltip
                          title={
                            formik?.values?.is_pinned
                              ? "Unpin object"
                              : "Pin object"
                          }
                        >
                          <div
                            className={
                              formik?.values?.is_pinned
                                ? "objectpin-container"
                                : "object-unpin-container"
                            }
                            onClick={pinChangeHandler}
                          >
                            <LuPin />
                          </div>
                        </Tooltip>
                      </div>
                    </Col>
                  </Row>
                </div>
                <div
                  onClick={closehandler}
                  style={{ paddingTop: "50px" }}
                  className="add-object-field-box"
                >
                  <Row className="primary-field-row">
                    <Col lg={4}>
                      <div className="add-object-left">
                        <Form.Group className="left-input-field">
                          <Form.Label>
                            Materials
                            <span className="required">
                              <sup>*</sup>
                            </span>
                          </Form.Label>
                          <AsyncSelect
                            isMulti
                            loadOptions={materialLoadOptionHandler}
                            defaultOptions={material}
                            value={formik.values.selectedMaterial}
                            name="material"
                            type="text"
                            placeholder="Select"
                            onChange={materialChangeHandler}
                            onInputChange={(newValue, { action }) => {
                              setNewValue(newValue);
                              if (
                                action === "input-change" &&
                                newValue === ""
                              ) {
                                setMaterial(defaultMaterial); // Reset to default options
                              }
                            }}
                            styles={{
                              control: (styles) => ({
                                ...styles,
                                border:
                                  formik?.errors?.material &&
                                  formik?.touched?.material
                                    ? "1px solid red"
                                    : "",
                                backgroundColor: !checkPermission(
                                  "collection_change_object"
                                )
                                  ? "white"
                                  : "white",
                              }),
                              placeholder: (styles) => ({
                                ...styles,
                                color:
                                  !checkPermission(
                                    "collection_change_object"
                                  ) && styles.color,
                              }),
                            }}
                          />
                          {formik.errors.material &&
                            formik?.touched?.material && (
                              <span className="text-danger">
                                {formik?.errors?.material}
                              </span>
                            )}
                        </Form.Group>
                        <Form.Group className="left-input-field">
                          <Form.Label>Primary category</Form.Label>
                          <AsyncSelect
                            value={formik.values.selectedCategory}
                            loadOptions={categoryLoadOptionHandler}
                            defaultOptions={category}
                            components={customComponents}
                            name="category"
                            type="text"
                            placeholder="Select"
                            styles={{
                              control: (styles) => ({
                                ...styles,
                                width: "100%",
                                backgroundColor: "white",
                              }),
                              placeholder: (styles) => ({
                                ...styles,
                                color:
                                  !checkPermission(
                                    "collection_change_object"
                                  ) && styles.color,
                              }),
                            }}
                            onChange={categoryChangeHandler}
                            onInputChange={(newValue, { action }) => {
                              setNewValue(newValue);
                              if (newValue === "") {
                                setCatgory(defaultcategory); // Reset to default options
                              }
                            }}
                          />
                        </Form.Group>

                        <Form.Group className="left-input-field">
                          <Form.Label>Subcategory</Form.Label>
                          <AsyncSelect
                            value={formik.values.selectedSubcategory}
                            loadOptions={(inputValue) =>
                              subcategoryLoadOptionHandler(
                                inputValue,
                                formik,
                                setSubcategory,
                                true
                              )
                            }
                            defaultOptions={subCategory}
                            components={customComponents}
                            name="category"
                            type="text"
                            placeholder="Select"
                            onChange={subcategoryChangeHandler}
                            onInputChange={(newValue, { action }) => {
                              setNewValue(newValue);
                              if (newValue === "") {
                                setSubcategory(defaultSubcategory); // Reset to default options
                              }
                            }}
                            styles={{
                              control: (styles) => ({
                                ...styles,
                                border:
                                  formik?.errors?.sub_category &&
                                  formik?.touched?.sub_category
                                    ? "1px solid red"
                                    : "",
                                backgroundColor: !checkPermission(
                                  "collection_change_object"
                                )
                                  ? "white"
                                  : "white",
                              }),
                              placeholder: (styles) => ({
                                ...styles,
                                color:
                                  !checkPermission(
                                    "collection_change_object"
                                  ) && styles.color,
                              }),
                            }}
                          />
                          {formik.errors.sub_category &&
                            formik?.touched?.sub_category && (
                              <span className="text-danger">
                                {formik?.errors?.sub_category}
                              </span>
                            )}
                        </Form.Group>

                        <Form.Group>
                          <Form.Label>Object label</Form.Label>
                          <Form.Control
                            type={"text"}
                            placeholder="Object label"
                            value={formik?.values?.object_label}
                            name="object_label"
                            onChange={(e) => {
                              formik.handleChange(e);
                              setIsAutoSave(true);
                            }}
                          />
                        </Form.Group>
                      </div>
                    </Col>
                    <Col className="reference-image-container" lg={8}>
                      <div className="input-field-right">
                        <Form.Group>
                          <Form.Label>
                            <p>Reference image</p>
                            <span className="required">
                              <sup>*</sup>
                            </span>
                          </Form.Label>
                          <div className="customize-refer-image">
                            <div
                              className="btn-upload"
                              onClick={
                                formik?.values?.reference_image
                                  ? () => setShowReference(true)
                                  : () => handleClick()
                              }
                              style={{
                                border:
                                  formik?.errors?.preview_image &&
                                  formik?.touched?.preview_image
                                    ? "1px solid red"
                                    : "",
                              }}
                            >
                              {formik.values.preview_image ? (
                                <>
                                  <div className="preview-img-box">
                                    <img
                                      height={"150px"}
                                      width={"150px"}
                                      onError={(e) =>
                                        (e.currentTarget.src = notFound)
                                      }
                                      src={formik.values.preview_image}
                                      alt="refer-img"
                                    />
                                    <div className="preview-hover-icons">
                                      {/* <div className='preview-delete'>
                                                                            <img src={replace} alt='replace-img' /> */}
                                      {/* <img src={deleteIcon} alt='delete-img' onClick={handleDeleteReferImage}/> */}

                                      {/* </div> */}
                                    </div>
                                  </div>
                                  <div className="reference-overlay"></div>
                                </>
                              ) : (
                                <div className="upload-image">
                                  <img src={upload} alt="upload-image" />
                                  <p>Click to upload</p>
                                </div>
                              )}
                            </div>

                            <Form.Control
                              type="file"
                              className="reference-image"
                              name={`reference_image`}
                              onChange={handleImageChangeHandler}
                              accept=".jpeg,.jpg,.png"
                            />
                          </div>
                          {formik?.errors?.preview_image &&
                            formik?.touched?.preview_image && (
                              <p
                                style={{ color: "#dc3545", fontSize: "0.9rem" }}
                              >
                                {formik.errors.preview_image}
                              </p>
                            )}

                          <span style={{ marginLeft: "123px", color: "gray" }}>
                            {formik?.values?.accession_number}
                          </span>
                        </Form.Group>
                      </div>
                      {showReference && (
                        <Modal
                          onHide={() => setShowReference(false)}
                          show={showReference}
                          centered
                          className="image-enlarge-modal"
                        >
                          <Modal.Header
                            className="detail-view-header "
                            closeButton
                          >
                            <Modal.Title>
                              <h4>Reference image</h4>
                            </Modal.Title>

                            <Tooltip title="Replace image">
                              <div
                                onClick={handleClick}
                                style={{
                                  position: "absolute",
                                  right: "80px",
                                  cursor: "pointer",
                                }}
                              >
                                <img src={replace} alt="replace-img" />
                              </div>
                            </Tooltip>
                          </Modal.Header>
                          <Modal.Body>
                            <div className="preview-img-box">
                              <ReactImageMagnify
                                imageClassName="react-magnify-small"
                                enlargedImageClassName="react-magnify-large"
                                enlargedImageContainerClassName="react-magnify-large-container"
                                enlargedImagePosition="beside"
                                {...{
                                  smallImage: {
                                    alt: "Wristwatch by Ted Baker London",
                                    isFluidWidth: true,
                                    src: formik.values.preview_image || "",
                                    onError: (e) =>
                                      (e.currentTarget.src = notFound),
                                  },
                                  largeImage: {
                                    src: formik.values.preview_image || "",
                                    width: 2500,
                                    height: 1500,
                                  },
                                }}
                              />
                              <div className="preview-hover-icons">
                                <div className="preview-delete">
                                  {/* <img src={deleteIcon} alt='delete-img' onClick={handleDeleteReferImage}/> */}
                                </div>
                              </div>
                            </div>
                            <div className="reference-overlay"></div>
                          </Modal.Body>
                        </Modal>
                      )}
                      <Form.Group
                        className="check-field"
                        style={{ paddingTop: "0px" }}
                      >
                        <Form.Check
                          onChange={handleIconicHandler}
                          checked={formik?.values?.iconic_object}
                        />

                        <Form.Label>
                          Iconic object{" "}
                          <div className="crown-field">
                            <RiVipCrownFill style={{ color: "gold" }} />
                          </div>
                        </Form.Label>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row style={{ marginTop: "20px" }}>
                    <Col lg={4}>
                      <Form.Group className="location-field">
                        <Form.Label>Number of parts</Form.Label>
                        <Form.Control
                          value={formik.values.number_of_parts}
                          onChange={partsNumberHandler}
                          name={`number_of_parts	`}
                          type="text"
                          placeholder="Number of parts"
                          isInvalid={hasLetter.numberOfParts}
                        />

                        {hasLetter.numberOfParts && (
                          <Form.Control.Feedback type="invalid">
                            Only numbers are allowed
                          </Form.Control.Feedback>
                        )}
                      </Form.Group>
                    </Col>
                    <Col className="number-of-parts-container" lg={4}>
                      <Form.Group className="location-field">
                        <Form.Label>Number of missing pieces</Form.Label>
                        <Form.Control
                          value={formik.values.number_of_missing_pieces}
                          onChange={missingNumberHandler}
                          name={`number_of_missing_pieces`}
                          type="text"
                          placeholder="Number of missing pieces "
                          isInvalid={hasLetter.numberOfMissing}
                        />
                        {hasLetter.numberOfMissing && (
                          <Form.Control.Feedback type="invalid">
                            Only numbers are allowed
                          </Form.Control.Feedback>
                        )}
                      </Form.Group>
                    </Col>
                  </Row>
                  <p style={{ paddingBottom: "20px", marginTop: "30px" }}>
                    Dimensions(cm)
                  </p>
                  {/* <Row style={{ backgroundColor: "#F0F8FF", paddingTop: "20px", maxHeight: "246px", overflow: "auto", scrollbarWidth: "thin" }}> */}
                  <div className="dimension-container">
                    <div className="dimension-box">
                      <div className="height-container">
                        <Form.Group className="dimension-field">
                          <Form.Label>
                            Height
                            <span className="required">
                              <sup>*</sup>
                            </span>
                          </Form.Label>
                          <Form.Control
                            value={formik.values.height}
                            name="height"
                            onChange={(e) => {
                              formik.handleChange(e);
                              setIsAutoSave(true);
                            }}
                            onKeyDown={(e) => {
                              if (
                                !/[0-9.]|Backspace|Delete|Tab|Escape|Enter/.test(
                                  e.key
                                ) ||
                                (e.key === "." &&
                                  formik.values.height.includes("."))
                              ) {
                                e.preventDefault();
                              }
                            }}
                            type="text"
                            placeholder="Enter height"
                            isInvalid={
                              formik.touched?.height && !!formik?.errors?.height
                            }
                          />

                          <Form.Control.Feedback type="invalid">
                            {formik?.errors?.height}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </div>
                      <div className="width-container">
                        <Form.Group className="dimension-field">
                          <Form.Label>
                            Width
                            <span className="required">
                              <sup>*</sup>
                            </span>
                          </Form.Label>
                          <Form.Control
                            name="width"
                            onChange={(e) => {
                              formik.handleChange(e);
                              setIsAutoSave(true);
                            }}
                            onKeyDown={(e) => {
                              if (
                                !/[0-9.]|Backspace|Delete|Tab|Escape|Enter/.test(
                                  e.key
                                ) ||
                                (e.key === "." &&
                                  formik.values.width.includes("."))
                              ) {
                                e.preventDefault();
                              }
                            }}
                            type="text"
                            value={formik.values.width}
                            placeholder="Enter width"
                            isInvalid={
                              formik.touched?.width && !!formik?.errors?.width
                            }
                          />
                          <Form.Control.Feedback type="invalid">
                            {formik?.errors?.width}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </div>
                      <div className="depth-container">
                        <div className="add-dimension">
                          <Form.Group className="dimension-field">
                            <Form.Label>
                              Depth
                              <span className="required">
                                <sup>*</sup>
                              </span>
                            </Form.Label>
                            <Form.Control
                              value={formik.values.depth}
                              name="depth"
                              onChange={(e) => {
                                formik.handleChange(e);
                                setIsAutoSave(true);
                              }}
                              onKeyDown={(e) => {
                                if (
                                  !/[0-9.]|Backspace|Delete|Tab|Escape|Enter/.test(
                                    e.key
                                  ) ||
                                  (e.key === "." &&
                                    formik.values.depth.includes("."))
                                ) {
                                  e.preventDefault();
                                }
                              }}
                              type="text"
                              placeholder="Enter depth"
                              isInvalid={
                                formik.touched?.depth && !!formik?.errors?.depth
                              }
                            />
                            <Form.Control.Feedback type="invalid">
                              {formik?.errors?.depth}
                            </Form.Control.Feedback>
                          </Form.Group>
                        </div>

                        <div className="add-icon-object">
                          <svg
                            onClick={() => addDimensions()}
                            xmlns="http://www.w3.org/2000/svg"
                            width="22"
                            height="22"
                            viewBox="0 0 22 22"
                            fill="none"
                          >
                            <path
                              d="M18.0293 10.3418H11.5245V3.83691H10.3418V10.3418H3.83691V11.5245H10.3418V18.0293H11.5245V11.5245H18.0293V10.3418Z"
                              fill="#20409A"
                            ></path>
                            <circle
                              cx="10.9333"
                              cy="10.9333"
                              r="10.25"
                              stroke="#20409A"
                              stroke-width="1.36667"
                            ></circle>
                          </svg>
                        </div>
                      </div>
                    </div>
                    {formik.values?.dimensions?.map((li, dimensionIndex) => {
                      return (
                        !li?.id && (
                          <div className="dimension-box" key={dimensionIndex}>
                            {" "}
                            {/* Add key here */}
                            <div className="dimension-name-container">
                              <Form.Group>
                                <Form.Control
                                  placeholder="Dimension name"
                                  onChange={(e) =>
                                    onAddDimensionNameChangeHandler(
                                      dimensionIndex,
                                      e.target.value
                                    )
                                  }
                                  value={li.dimension_name || ""} // Ensure value is not undefined
                                />
                              </Form.Group>
                            </div>
                            <div className="dimension-value-container">
                              <Form.Group>
                                <Form.Control
                                  placeholder="Dimension value"
                                  onChange={(e) =>
                                    addDimensionValueChangeHandler(
                                      dimensionIndex,
                                      e.target.value
                                    )
                                  }
                                  value={li.dimension_value || ""} // Ensure value is not undefined
                                  onKeyDown={(e) => {
                                    if (
                                      !/[0-9.]|Backspace|Delete|Tab|Escape|Enter/.test(
                                        e.key
                                      ) ||
                                      (e.key === "." &&
                                        formik.values.depth?.includes("."))
                                    ) {
                                      e.preventDefault();
                                    }
                                  }}
                                />
                              </Form.Group>
                            </div>
                            <div
                              style={{ display: "flex", alignItems: "center" }}
                            >
                              <CiCircleMinus
                                style={{
                                  fontSize: "28px",
                                  color: "#20409A",
                                  cursor: "pointer",
                                }}
                                onClick={() => removeDimension(dimensionIndex)}
                              />
                            </div>
                          </div>
                        )
                      );
                    })}
                    <div className="dimension-box">
                      {formik.values.dimensions.map((li, dimensionIndex) => {
                        return (
                          <>
                            {li.id && (
                              <div style={{ marginTop: "20px" }}>
                                <Form.Group className="dimension-field">
                                  <Form.Label>
                                    {li.dimension_name
                                      ?.charAt(0)
                                      .toUpperCase() +
                                      li.dimension_name?.slice(1)}
                                  </Form.Label>
                                  <div
                                    className="added-dimension"
                                    style={{
                                      backgroundColor: "white",
                                      border: "1px solid #EEEE ",
                                      borderRadius: "7px",
                                      padding: "1px",
                                      display: "flex",
                                      alignItems: "center",
                                      fontSize: "28px",
                                      color: "#20409A",
                                      cursor: "pointer",
                                      gap: "5px",
                                    }}
                                  >
                                    <Form.Control
                                      className="update-dimension-input"
                                      style={{
                                        border: "none",
                                        outline: "none",
                                        boxShadow: "none",
                                      }}
                                      name="width"
                                      onChange={(e) =>
                                        addDimensionValueChangeHandler(
                                          dimensionIndex,
                                          e.target.value
                                        )
                                      }
                                      type="text"
                                      value={li.dimension_value}
                                      placeholder="Enter dimension value"
                                    />
                                    <CiCircleMinus
                                      style={{ fontSize: "31px" }}
                                      onClick={(e) =>
                                        removeDimension(dimensionIndex)
                                      }
                                    />
                                  </div>
                                </Form.Group>
                              </div>
                            )}
                          </>
                        );
                      })}
                    </div>
                  </div>
                  {/* </Row> */}
                  {/* <div className='location-field-box'>
                                        <div className='location-field-row'>
                                            <div className='location-original-container' > */}
                  <Row>
                    <Col lg={8}>
                      <Form.Group className="function-field-box">
                        <div style={{ display: "flex", marginBottom: "-6px" }}>
                          <Form.Label>Tags</Form.Label>

                          <Tooltip
                            placement="top"
                            title="Add tags and press 'Enter' to save"
                          >
                            <div>
                              <RiInformation2Fill
                                style={{
                                  color: "#20409A",
                                  marginLeft: "5px",
                                }}
                              />
                            </div>
                          </Tooltip>
                        </div>
                        <div className="function-box">
                          <Form.Control
                            maxLength={100}
                            as="textarea"
                            placeholder="Add tags"
                            value={enteredValue}
                            onChange={handleTagchangeHandler}
                            rows={3}
                            onKeyDown={(e) => {
                              if (enteredValue.trim() !== "") {
                                handleKeydown(e);
                              } else if (e.key === "Enter") {
                                e.preventDefault(); // Prevents empty entry on Enter key press
                              }
                            }}
                          />
                          {formik.values?.tags.map((li, tagIndex) => (
                            <Chip
                              variant="outlined"
                              className="custom-chip"
                              label={li.tag_name}
                              onDelete={() => handelete(tagIndex)}
                              deleteIcon={<IoMdClose />}
                            />
                          ))}
                        </div>
                      </Form.Group>
                    </Col>
                  </Row>

                  {/*//////////////////////////// Original location ////////////////////////////// */}

                  <div style={{ marginBottom: "10px", marginTop: "30px" }}>
                    <p>
                      Original location
                      <span className="required">
                        <sup>*</sup>
                      </span>
                    </p>
                  </div>
                  <Row style={{ marginTop: "20px" }}>
                    {showLocationLabel && (
                      <Col lg={3} md={3} sm={3} xs={4}>
                        <div
                          className="location-add-container"
                          style={{
                            padding: "7px",
                            display: "flex",
                            alignItems: "center",
                            border: "1px solid #EEEEEE",
                            borderRadius: "7px",
                            justifyContent: "space-between",
                          }}
                        >
                          <p>Building</p>
                        </div>
                      </Col>
                    )}
                    <Col lg={3} md={5} sm={9} xs={9}>
                      <AsyncSelect
                        placeholder="Select building"
                        styles={{
                          control: (styles) => ({
                            ...styles,
                            border:
                              formik?.errors?.originalBuilding &&
                              !!formik?.touched?.originalBuilding
                                ? "1px solid #dc3545"
                                : "",
                            backgroundColor: !checkPermission(
                              "collection_change_object"
                            )
                              ? "white"
                              : "white",
                          }),
                          placeholder: (styles) => ({
                            ...styles,
                            color:
                              !checkPermission("collection_change_object") &&
                              styles.color,
                          }),
                        }}
                        value={
                          locationOriginalValue?.building
                            ? locationOriginalValue?.building
                            : null
                        }
                        defaultOptions={locationTransit?.building}
                        onChange={(e) => locationChangeHandler(e, "building")}
                        loadOptions={buildingLoadOptionHandler}
                      />
                      {formik?.errors?.originalBuilding &&
                        formik?.touched?.originalBuilding && (
                          <p style={{ color: "#dc3545" }}>
                            {formik?.errors?.originalBuilding}
                          </p>
                        )}
                    </Col>
                  </Row>
                  <Row style={{ marginTop: "4px" }}>
                    {showLocationLabel && (
                      <Col lg={3} md={3} sm={3} xs={4}>
                        <div
                          className="location-add-container"
                          style={{
                            padding: "7px",
                            display: "flex",
                            alignItems: "center",
                            border: "1px solid #EEEEEE",
                            borderRadius: "7px",
                            justifyContent: "space-between",
                          }}
                        >
                          <p>Floor</p>
                        </div>
                      </Col>
                    )}
                    <Col lg={3} md={5} sm={9} xs={9}>
                      <AsyncSelect
                        placeholder="Select floor"
                        styles={{
                          control: (styles) => ({
                            ...styles,
                            border:
                              formik?.errors?.originalFloor &&
                              !!formik?.touched?.originalFloor
                                ? "1px solid #dc3545"
                                : "",
                            backgroundColor: !checkPermission(
                              "collection_change_object"
                            )
                              ? "white"
                              : "white",
                          }),
                          placeholder: (styles) => ({
                            ...styles,
                            color:
                              !checkPermission("collection_change_object") &&
                              styles.color,
                          }),
                        }}
                        value={locationOriginalValue?.floor}
                        onInputChange={(newValue, { action }) => {
                          if (action === "input-change" && newValue === "") {
                            setLocation({
                              ...location,
                              floor: location.defaultfloor,
                            }); // Reset to default options
                          }
                        }}
                        defaultOptions={location?.floor}
                        onChange={(e) => locationChangeHandler(e, "floor")}
                        loadOptions={floorLoadOptionHandler}
                      />
                      {formik?.errors?.originalFloor &&
                        formik?.touched?.originalFloor && (
                          <p style={{ color: "#dc3545" }}>
                            {formik?.errors?.originalFloor}
                          </p>
                        )}
                    </Col>
                  </Row>
                  {/* } */}
                  {/* {formik?.values?.originalLocationTotaldata?.floorShow && */}
                  <Row style={{ marginTop: "4px" }}>
                    {showLocationLabel && (
                      <Col lg={3} md={3} sm={3} xs={4}>
                        <div
                          className="location-add-container"
                          style={{
                            padding: "7px",
                            display: "flex",
                            alignItems: "center",
                            border: "1px solid #EEEEEE",
                            borderRadius: "7px",
                            justifyContent: "space-between",
                          }}
                        >
                          <p>Room</p>
                        </div>
                      </Col>
                    )}
                    <Col lg={3} md={5} sm={9} xs={9}>
                      <AsyncSelect
                        placeholder="Select room"
                        styles={{
                          control: (styles) => ({
                            ...styles,
                            border:
                              formik?.errors?.originalRoom &&
                              !!formik?.touched?.originalRoom
                                ? "1px solid #dc3545"
                                : "",
                            backgroundColor: !checkPermission(
                              "collection_change_object"
                            )
                              ? "white"
                              : "white",
                          }),
                          placeholder: (styles) => ({
                            ...styles,
                            color:
                              !checkPermission("collection_change_object") &&
                              styles.color,
                          }),
                        }}
                        value={locationOriginalValue?.room}
                        defaultOptions={location?.room}
                        onChange={(e) => locationChangeHandler(e, "room")}
                        loadOptions={roomLoadOptionHandler}
                      />
                      {formik?.errors?.originalRoom &&
                        formik?.touched?.originalRoom && (
                          <p style={{ color: "#dc3545" }}>
                            {formik?.errors?.originalRoom}
                          </p>
                        )}
                    </Col>

                    {!showStorageOriginal?.sytemType && (
                      <Col
                        lg={3}
                        md={4}
                        sm={3}
                        xs={3}
                        onClick={() => locationShowhandlerOriginal("room")}
                        style={{
                          // marginRight: "5px",
                          paddingLeft: "0px",
                          display: "flex",
                          alignItems: "center",
                        }}
                        className="add-location-icon"
                      >
                        <svg
                          style={{
                            cursor: "pointer",
                          }}
                          xmlns="http://www.w3.org/2000/svg"
                          width="22"
                          height="22"
                          viewBox="0 0 22 22"
                          fill="none"
                        >
                          <path
                            d="M18.0293 10.3418H11.5245V3.83691H10.3418V10.3418H3.83691V11.5245H10.3418V18.0293H11.5245V11.5245H18.0293V10.3418Z"
                            fill="#20409A"
                          ></path>
                          <circle
                            cx="10.9333"
                            cy="10.9333"
                            r="10.25"
                            stroke="#20409A"
                            stroke-width="1.36667"
                          ></circle>
                        </svg>
                        {showLocationLabel && (
                          <p style={{ marginLeft: "7px" }}>
                            Add storage system
                          </p>
                        )}
                      </Col>
                    )}
                  </Row>
                  {/* } */}
                  {showStorageOriginal?.sytemType && (
                    <Row style={{ marginTop: "4px" }}>
                      {showLocationLabel && (
                        <Col lg={3} md={3} sm={3} xs={4}>
                          <div
                            className="location-add-container"
                            style={{
                              padding: "7px",
                              display: "flex",
                              alignItems: "center",
                              border: "1px solid #EEEEEE",
                              borderRadius: "7px",
                              justifyContent: "space-between",
                            }}
                          >
                            <p>Storage sytem</p>
                          </div>
                        </Col>
                      )}
                      <Col lg={3} md={5} sm={9} xs={9}>
                        <AsyncSelect
                          placeholder="Select storage system type"
                          styles={{
                            control: (styles) => ({
                              ...styles,
                              border:
                                formik?.errors?.originalsystemtype &&
                                !!formik?.touched?.originalsystemtype
                                  ? "1px solid #dc3545"
                                  : "",
                            }),
                          }}
                          value={locationOriginalValue?.systemtype}
                          defaultOptions={location?.systemtype}
                          onChange={(e) => locationChangeHandler(e, "system")}
                          loadOptions={systemtypeLoadOptionHandler}
                        />
                        {formik?.errors?.originalsystemtype &&
                          formik?.touched?.originalsystemtype && (
                            <p style={{ color: "#dc3545" }}>
                              {formik?.errors?.originalsystemtype}
                            </p>
                          )}
                      </Col>

                      <Col
                        lg={3}
                        md={4}
                        sm={3}
                        xs={3}
                        style={{
                          // marginRight: "5px",
                          cursor: "pointer",
                          paddingLeft: "0px",
                          display: "flex",
                          alignItems: "center",
                          gap: "10px",
                        }}
                        className="add-location-icon"
                      >
                        <FaTrashAlt
                          onClick={() => removeStorageOriginal("system")}
                          style={{ color: "gray", cursor: "pointer" }}
                        />
                        {!showStorageOriginal?.unitType && (
                          <>
                            <svg
                              onClick={() =>
                                locationShowhandlerOriginal("system")
                              }
                              xmlns="http://www.w3.org/2000/svg"
                              width="22"
                              height="22"
                              viewBox="0 0 22 22"
                              fill="none"
                            >
                              <path
                                d="M18.0293 10.3418H11.5245V3.83691H10.3418V10.3418H3.83691V11.5245H10.3418V18.0293H11.5245V11.5245H18.0293V10.3418Z"
                                fill="#20409A"
                              ></path>
                              <circle
                                cx="10.9333"
                                cy="10.9333"
                                r="10.25"
                                stroke="#20409A"
                                stroke-width="1.36667"
                              ></circle>
                            </svg>
                            {showLocationLabel && (
                              <p style={{ marginLeft: "7px" }}>
                                Add storage unit
                              </p>
                            )}
                          </>
                        )}
                      </Col>
                    </Row>
                  )}
                  {showStorageOriginal?.unitType && (
                    <Row style={{ marginTop: "4px" }}>
                      {showLocationLabel && (
                        <Col lg={3} md={3} sm={3} xs={4}>
                          <div
                            className="location-add-container"
                            style={{
                              padding: "7px",
                              display: "flex",
                              alignItems: "center",
                              border: "1px solid #EEEEEE",
                              borderRadius: "7px",
                              justifyContent: "space-between",
                            }}
                          >
                            <p>Storage unit </p>
                          </div>
                        </Col>
                      )}
                      <Col lg={3} md={5} sm={9} xs={9}>
                        <AsyncSelect
                          placeholder="Select storage unit type"
                          styles={{
                            control: (styles) => ({
                              ...styles,
                              border:
                                formik?.errors?.originalunitType &&
                                !!formik?.touched?.originalunitType
                                  ? "1px solid #dc3545"
                                  : "",
                            }),
                          }}
                          value={locationOriginalValue?.unitType}
                          defaultOptions={location?.unitType}
                          onChange={(e) => locationChangeHandler(e, "unit")}
                          loadOptions={unitTypetypeLoadOptionHandler}
                        />
                        {formik?.errors?.originalunitType &&
                          formik?.touched?.originalunitType && (
                            <p style={{ color: "#dc3545" }}>
                              {formik?.errors?.originalunitType}
                            </p>
                          )}
                      </Col>

                      <Col
                        style={{
                          display: "flex",
                          alignItems: "center",
                          marginLeft: "-12px",
                        }}
                        lg={3}
                        md={4}
                        sm={3}
                        xs={3}
                      >
                        <FaTrashAlt
                          onClick={() => removeStorageOriginal("unit")}
                          style={{ color: "gray", cursor: "pointer" }}
                        />
                      </Col>
                    </Row>
                  )}
                  <div
                    style={{ display: "flex", gap: "5px", marginTop: "10px" }}
                  >
                    <Form.Check
                      checked={isSameLocation}
                      onChange={onSelectsameLocationHandler}
                      type="checkbox"
                    />

                    <p>Set transit location same as original location</p>
                  </div>

                  <div style={{ marginBottom: "10px", marginTop: "30px" }}>
                    <p>Transit location</p>
                  </div>
                  <Row style={{ marginTop: "20px" }}>
                    {showLocationLabel && (
                      <Col lg={3} md={3} sm={3} xs={4}>
                        <div
                          className="location-add-container"
                          style={{
                            padding: "7px",
                            display: "flex",
                            alignItems: "center",
                            border: "1px solid #EEEEEE",
                            borderRadius: "7px",
                            justifyContent: "space-between",
                          }}
                        >
                          <p>Building</p>
                        </div>
                      </Col>
                    )}
                    {/* {formik?.values?.originalLocationTotaldata?.buildingShow && */}
                    <Col lg={3} md={5} sm={9} xs={9}>
                      <AsyncSelect
                        placeholder="Select building"
                        value={locationTransitValue?.building}
                        styles={{
                          control: (styles) => ({
                            ...styles,
                            border:
                              formik?.errors?.transitlBuilding &&
                              !!formik?.touched?.transitlBuilding
                                ? "1px solid #dc3545"
                                : "",
                            backgroundColor: !checkPermission(
                              "collection_change_object"
                            )
                              ? "white"
                              : "white",
                          }),
                          placeholder: (styles) => ({
                            ...styles,
                            color:
                              !checkPermission("collection_change_object") &&
                              styles.color,
                          }),
                        }}
                        defaultOptions={locationTransit?.building}
                        onChange={(e) =>
                          locationTransitChangeHandler(e, "building")
                        }
                        loadOptions={buildingLoadOptionHandlerTransit}
                      />
                      {formik?.errors?.transitlBuilding &&
                        formik?.touched?.transitlBuilding && (
                          <p style={{ color: "#dc3545" }}>
                            {formik?.errors?.transitlBuilding}
                          </p>
                        )}
                    </Col>
                  </Row>
                  <Row style={{ marginTop: "4px" }}>
                    {showLocationLabel && (
                      <Col lg={3} md={3} sm={3} xs={4}>
                        <div
                          className="location-add-container"
                          style={{
                            padding: "7px",
                            display: "flex",
                            alignItems: "center",
                            border: "1px solid #EEEEEE",
                            borderRadius: "7px",
                            justifyContent: "space-between",
                          }}
                        >
                          <p>Floor</p>
                        </div>
                      </Col>
                    )}
                    <Col lg={3} md={5} sm={9} xs={9}>
                      <AsyncSelect
                        placeholder="Select floor"
                        styles={{
                          control: (styles) => ({
                            ...styles,
                            border:
                              formik?.errors?.transitlFloor &&
                              !!formik?.touched?.transitlFloor
                                ? "1px solid #dc3545"
                                : "",
                            backgroundColor: !checkPermission(
                              "collection_change_object"
                            )
                              ? "white"
                              : "white",
                          }),
                          placeholder: (styles) => ({
                            ...styles,
                            color:
                              !checkPermission("collection_change_object") &&
                              styles.color,
                          }),
                        }}
                        value={locationTransitValue?.floor}
                        onInputChange={(newValue, { action }) => {
                          if (action === "input-change" && newValue === "") {
                            setLocationTransit({
                              ...locationTransit,
                              floor: locationTransit?.defaultfloor,
                            }); // Reset to default options
                          }
                        }}
                        defaultOptions={locationTransit?.floor}
                        onChange={(e) =>
                          locationTransitChangeHandler(e, "floor")
                        }
                        loadOptions={floorLoadOptionHandlerTransit}
                      />
                      {formik?.errors?.transitlFloor &&
                        formik?.touched?.transitlFloor && (
                          <p style={{ color: "#dc3545" }}>
                            {formik?.errors?.transitlFloor}
                          </p>
                        )}
                    </Col>
                  </Row>
                  {/* } */}
                  {/* {formik?.values?.originalLocationTotaldata?.floorShow && */}
                  <Row style={{ marginTop: "4px" }}>
                    {showLocationLabel && (
                      <Col lg={3} md={3} sm={3} xs={4}>
                        <div
                          className="location-add-container"
                          style={{
                            padding: "7px",
                            display: "flex",
                            alignItems: "center",
                            border: "1px solid #EEEEEE",
                            borderRadius: "7px",
                            justifyContent: "space-between",
                          }}
                        >
                          <p>Room</p>
                        </div>
                      </Col>
                    )}
                    <Col lg={3} md={5} sm={9} xs={9}>
                      <AsyncSelect
                        placeholder="Select room"
                        styles={{
                          control: (styles) => ({
                            ...styles,
                            border:
                              formik?.errors?.transitlRoom &&
                              !!formik?.touched?.transitlRoom
                                ? "1px solid #dc3545"
                                : "",
                            backgroundColor: !checkPermission(
                              "collection_change_object"
                            )
                              ? "white"
                              : "white",
                          }),
                          placeholder: (styles) => ({
                            ...styles,
                            color:
                              !checkPermission("collection_change_object") &&
                              styles.color,
                          }),
                        }}
                        value={locationTransitValue?.room}
                        defaultOptions={locationTransit?.room}
                        onChange={(e) =>
                          locationTransitChangeHandler(e, "room")
                        }
                        loadOptions={roomLoadOptionHandlerTransit}
                      />
                      {formik?.errors?.transitlRoom &&
                        formik?.touched?.transitlRoom && (
                          <p style={{ color: "#dc3545" }}>
                            {formik?.errors?.transitlRoom}
                          </p>
                        )}
                    </Col>
                    {!showStorageTransit?.sytemType && (
                      <Col
                        lg={3}
                        md={4}
                        sm={3}
                        xs={3}
                        onClick={() => locationShowhandlerTransit("room")}
                        style={{
                          // marginRight: "5px",
                          cursor: "pointer",
                          paddingLeft: "0px",
                          display: "flex",
                          alignItems: "center",
                        }}
                        className="add-location-icon"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="22"
                          height="22"
                          viewBox="0 0 22 22"
                          fill="none"
                        >
                          <path
                            d="M18.0293 10.3418H11.5245V3.83691H10.3418V10.3418H3.83691V11.5245H10.3418V18.0293H11.5245V11.5245H18.0293V10.3418Z"
                            fill="#20409A"
                          ></path>
                          <circle
                            cx="10.9333"
                            cy="10.9333"
                            r="10.25"
                            stroke="#20409A"
                            stroke-width="1.36667"
                          ></circle>
                        </svg>
                        {showLocationLabel && (
                          <p style={{ marginLeft: "7px" }}>
                            Add storage system
                          </p>
                        )}
                      </Col>
                    )}
                  </Row>
                  {/* } */}
                  {showStorageTransit?.sytemType && (
                    <Row style={{ marginTop: "4px" }}>
                      {showLocationLabel && (
                        <Col lg={3} md={3} sm={3} xs={4}>
                          <div
                            className="location-add-container"
                            style={{
                              padding: "7px",
                              display: "flex",
                              alignItems: "center",
                              border: "1px solid #EEEEEE",
                              borderRadius: "7px",
                              justifyContent: "space-between",
                            }}
                          >
                            <p>Storage sytem</p>
                          </div>
                        </Col>
                      )}
                      <Col lg={3} md={5} sm={9} xs={9}>
                        <AsyncSelect
                          placeholder="Select storage system type"
                          styles={{
                            control: (styles) => ({
                              ...styles,
                              border:
                                formik?.errors?.transitlsystemtype &&
                                !!formik?.touched?.transitlsystemtype
                                  ? "1px solid #dc3545"
                                  : "",
                              backgroundColor: !checkPermission(
                                "collection_change_object"
                              )
                                ? "white"
                                : "white",
                            }),
                            placeholder: (styles) => ({
                              ...styles,
                              color:
                                !checkPermission("collection_change_object") &&
                                styles.color,
                            }),
                          }}
                          value={locationTransitValue?.systemtype}
                          defaultOptions={locationTransit?.systemtype}
                          onChange={(e) =>
                            locationTransitChangeHandler(e, "system")
                          }
                          loadOptions={systemtypeLoadOptionHandlerTransit}
                        />
                        {formik?.errors?.transitlsystemtype &&
                          formik?.touched?.transitlsystemtype && (
                            <p style={{ color: "#dc3545" }}>
                              {formik?.errors?.transitlsystemtype}
                            </p>
                          )}
                      </Col>
                      <Col
                        style={{
                          cursor: "pointer",
                          paddingLeft: "0px",
                          display: "flex",
                          alignItems: "center",
                          gap: "10px",
                        }}
                        lg={3}
                        md={4}
                        sm={3}
                        xs={3}
                      >
                        <FaTrashAlt
                          onClick={() => removeStorageTransit("system")}
                          style={{ color: "gray", cursor: "pointer" }}
                        />
                        {!showStorageTransit?.unitType && (
                          <div
                            onClick={() => locationShowhandlerTransit("system")}
                            style={{
                              cursor: "pointer",
                              paddingLeft: "0px",
                              display: "flex",
                              alignItems: "center",
                            }}
                            className="add-location-icon"
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="22"
                              height="22"
                              viewBox="0 0 22 22"
                              fill="none"
                            >
                              <path
                                d="M18.0293 10.3418H11.5245V3.83691H10.3418V10.3418H3.83691V11.5245H10.3418V18.0293H11.5245V11.5245H18.0293V10.3418Z"
                                fill="#20409A"
                              ></path>
                              <circle
                                cx="10.9333"
                                cy="10.9333"
                                r="10.25"
                                stroke="#20409A"
                                stroke-width="1.36667"
                              ></circle>
                            </svg>
                            {showLocationLabel && (
                              <p style={{ marginLeft: "7px" }}>
                                Add storage unit
                              </p>
                            )}
                          </div>
                        )}
                      </Col>
                    </Row>
                  )}
                  {showStorageTransit?.unitType && (
                    <Row style={{ marginTop: "4px" }}>
                      {showLocationLabel && (
                        <Col lg={3} md={3} sm={3} xs={4}>
                          <div
                            className="location-add-container"
                            style={{
                              padding: "7px",
                              display: "flex",
                              alignItems: "center",
                              border: "1px solid #EEEEEE",
                              borderRadius: "7px",
                              justifyContent: "space-between",
                            }}
                          >
                            <p>Storage unit</p>
                          </div>
                        </Col>
                      )}
                      <Col lg={3} md={5} sm={9} xs={9}>
                        <AsyncSelect
                          placeholder="Select storage unit type"
                          styles={{
                            control: (styles) => ({
                              ...styles,
                              border:
                                formik?.errors?.transitlunitType &&
                                !!formik?.touched?.transitlunitType
                                  ? "1px solid #dc3545"
                                  : "",
                              backgroundColor: !checkPermission(
                                "collection_change_object"
                              )
                                ? "white"
                                : "white",
                            }),
                            placeholder: (styles) => ({
                              ...styles,
                              color:
                                !checkPermission("collection_change_object") &&
                                styles.color,
                            }),
                          }}
                          value={locationTransitValue?.unitType}
                          defaultOptions={locationTransit?.unitType}
                          onChange={(e) =>
                            locationTransitChangeHandler(e, "unit")
                          }
                          loadOptions={unitTypetypeLoadOptionHandlerTransit}
                        />
                        {formik?.errors?.transitlunitType &&
                          formik?.touched?.transitlunitType && (
                            <p style={{ color: "#dc3545" }}>
                              {formik?.errors?.transitlunitType}
                            </p>
                          )}
                      </Col>
                      <Col
                        style={{
                          display: "flex",
                          alignItems: "center",
                          marginLeft: "-12px",
                        }}
                        lg={3}
                        md={4}
                        sm={3}
                        xs={3}
                      >
                        <FaTrashAlt
                          onClick={() => removeStorageTransit("unit")}
                          style={{ color: "gray", cursor: "pointer" }}
                        />
                      </Col>
                    </Row>
                  )}

                  {categoryDetails?.length > 0 && (
                    <Accordion>
                      <Accordion.Item>
                        <Accordion.Header
                          style={{ borderBottom: "1px solid lightgray" }}
                        >
                          <h6 style={{ fontWeight: "600" }}>
                            Category descriptors
                          </h6>
                        </Accordion.Header>
                        <Accordion.Body className="collection-accordion-body">
                          <Row
                            style={{ marginTop: "20px", marginBottom: "20px" }}
                          >
                            {formik?.values?.attribute?.map(
                              (li, indexOfAttribute) => {
                                let attributeValue;
                                let matchDescr;
                                if (
                                  li?.attribute_type === "Multiple dropdown" &&
                                  li?.description
                                ) {
                                  try {
                                    matchDescr = li?.description
                                      ? JSON.parse(li?.description)
                                      : [];
                                  } catch (e) {
                                    console.error(
                                      "Failed to parse JSON for description:",
                                      li.description
                                    );
                                    matchDescr = [li?.description];
                                  }

                                  const matchingOption = li?.options;
                                  const selectedElements =
                                    matchingOption?.filter((optionObj) =>
                                      matchDescr?.includes(optionObj.option)
                                    );
                                  const selectedElementAsValue =
                                    selectedElements?.map((same) => ({
                                      value: same?.option,
                                      label: same?.option,
                                    }));

                                  attributeValue = selectedElementAsValue;
                                }

                                return (
                                  <Col lg={4}>
                                    <div style={{ marginTop: "8px" }}>
                                      {li?.attribute_type === "Text" && (
                                        <Form.Group>
                                          <Form.Label>
                                            {li?.attribute_name}
                                          </Form.Label>
                                          <Form.Control
                                            value={li?.description}
                                            onChange={(e) =>
                                              attributeOptionAddhandler(
                                                e.target?.value,
                                                indexOfAttribute,
                                                li
                                              )
                                            }
                                          />
                                        </Form.Group>
                                      )}
                                      {li?.attribute_type === "Dropdown" && (
                                        <Form.Group>
                                          <Form.Label>
                                            {li?.attribute_name}
                                          </Form.Label>
                                          <Select
                                            value={{
                                              value: li?.description,
                                              label: li?.description,
                                            }}
                                            options={li?.options?.map((li) => ({
                                              value: li?.id,
                                              label: li?.option,
                                            }))}
                                            onChange={(e) =>
                                              attributeOptionAddhandler(
                                                e.label,
                                                indexOfAttribute,
                                                li
                                              )
                                            }
                                          />
                                        </Form.Group>
                                      )}
                                      {li?.attribute_type ===
                                        "Multiple dropdown" && (
                                        <Form.Group>
                                          <Form.Label>
                                            {li?.attribute_name}
                                          </Form.Label>
                                          <Select
                                            isMulti
                                            styles={{
                                              control: (styles) => ({
                                                ...styles,
                                                backgroundColor:
                                                  !checkPermission(
                                                    "collection_change_object"
                                                  )
                                                    ? "white"
                                                    : "white",
                                              }),
                                              placeholder: (styles) => ({
                                                ...styles,
                                                color:
                                                  !checkPermission(
                                                    "collection_change_object"
                                                  ) && styles.color,
                                              }),
                                            }}
                                            value={attributeValue}
                                            options={li?.options
                                              ?.map((option) => ({
                                                value: option?.option, // keep label & value consistent!
                                                label: option?.option,
                                              }))
                                              .filter(
                                                (option) =>
                                                  !attributeValue?.some(
                                                    (selected) =>
                                                      selected.value ===
                                                      option.value
                                                  )
                                              )}
                                            onChange={(e) =>
                                              attributeOptionAddhandler(
                                                e,
                                                indexOfAttribute,
                                                li
                                              )
                                            }
                                          />
                                        </Form.Group>
                                      )}
                                    </div>
                                  </Col>
                                );
                              }
                            )}
                          </Row>
                        </Accordion.Body>
                      </Accordion.Item>
                    </Accordion>
                  )}
                  <Accordion>
                    <Accordion.Item>
                      <Accordion.Header
                        eventKey="0"
                        style={{
                          borderBottom: "1px solid lightgray",
                          zIndex: 0,
                          position: "relative",
                        }}
                        bsPrefix="object-accordion-header"
                      >
                        <h6 style={{ paddingBottom: "0px", fontWeight: "600" }}>
                          Related objects
                        </h6>
                      </Accordion.Header>
                      <Accordion.Body className="collection-accordion-body">
                        <div className="dimension-field-box">
                          <Row>
                            <Col lg={4}>
                              <Form.Group>
                                <Form.Label>Related objects</Form.Label>
                                <AsyncPaginate
                                  isMulti
                                  styles={{
                                    control: (styles) => ({
                                      ...styles,
                                      backgroundColor: !checkPermission(
                                        "collection_change_object"
                                      )
                                        ? "white"
                                        : "white",
                                    }),
                                  }}
                                  components={customRelatedComponent}
                                  placeholder="Select"
                                  defaultOptions={object ? object : []}
                                  onChange={relatedObjectHandler}
                                  value={formik.values.selctedObject}
                                  additional={{
                                    page: 1,
                                  }}
                                  loadOptions={objectLoadOptionHandler}
                                  debounceTimeout={300}
                                  onInputChange={(newVal, { action }) => {
                                    if (action === "input-change") {
                                      setInputValueObject(newVal);
                                      setPage(1);
                                      setHasMore(true);
                                    }
                                    return newVal;
                                  }}
                                />
                              </Form.Group>
                            </Col>
                          </Row>

                          <Row>
                            <Col lg={7}>
                              <Form.Group>
                                <Form.Label>Inscriptions or markers</Form.Label>
                                <Form.Control
                                  maxLength={2000}
                                  value={formik.values.inscription_or_markers}
                                  name="inscription_or_markers"
                                  onChange={(e) => {
                                    formik.handleChange(e);
                                    setIsAutoSave(true);
                                  }}
                                  as="textarea"
                                  rows={4}
                                />
                                <p
                                  className="maximum-line"
                                  style={{ justifyContent: "flex-end" }}
                                >
                                  {`Maximum character ${
                                    formik.values?.inscription_or_markers
                                      ?.length
                                      ? formik?.values?.inscription_or_markers
                                          ?.length
                                      : 0
                                  }/${
                                    maxlengthInscript ? maxlengthInscript : 0
                                  }`}{" "}
                                </p>
                              </Form.Group>
                            </Col>
                            <Col lg={5}>
                              <Form.Group>
                                <Form.Label>Preliminary assessment </Form.Label>
                                <Form.Control
                                  maxLength={2000}
                                  placeholder="Preliminary assessment"
                                  value={
                                    formik.values
                                      .preliminary_condition_assessment
                                  }
                                  name="preliminary_condition_assessment"
                                  onChange={(e) => {
                                    formik.handleChange(e);
                                    setIsAutoSave(true);
                                  }}
                                  as="textarea"
                                  rows={4}
                                  isInvalid={
                                    formik.touched
                                      ?.preliminary_condition_assessment &&
                                    !!formik?.errors
                                      ?.preliminary_condition_assessment
                                  }
                                />
                                <Form.Control.Feedback type="invalid">
                                  {
                                    formik?.errors
                                      ?.preliminary_condition_assessment
                                  }
                                </Form.Control.Feedback>
                                <p
                                  className="maximum-line"
                                  style={{ justifyContent: "flex-end" }}
                                >
                                  {`Maximum character ${
                                    formik.values
                                      ?.preliminary_condition_assessment?.length
                                      ? formik?.values
                                          ?.preliminary_condition_assessment
                                          ?.length
                                      : 0
                                  }/${
                                    maxlengthInscript ? maxlengthInscript : 0
                                  }`}{" "}
                                </p>
                              </Form.Group>
                            </Col>
                          </Row>
                        </div>
                      </Accordion.Body>
                    </Accordion.Item>
                  </Accordion>

                  <Accordion>
                    <Accordion.Item>
                      <Accordion.Header
                        style={{
                          borderBottom: "1px solid lightgray",
                          zIndex: 0,
                          position: "relative",
                        }}
                      >
                        <h6 style={{ paddingBottom: "0px", fontWeight: "600" }}>
                          Provenance
                        </h6>
                      </Accordion.Header>
                      <Accordion.Body className="collection-accordion-body">
                        <div className="location-field-box">
                          <Row className="location-field-row">
                            <Col lg={4}>
                              <Form.Group className="location-field">
                                <Form.Label>Provenance</Form.Label>
                                <Form.Control
                                  value={formik.values.provenance}
                                  name="provenance"
                                  onChange={(e) => {
                                    formik.handleChange(e);
                                    setIsAutoSave(true);
                                  }}
                                  type="text"
                                  placeholder="State"
                                />
                              </Form.Group>
                            </Col>
                            <Col
                              lg={4}
                              md={12}
                              sm={12}
                              xs={12}
                              className="time-period-container"
                            >
                              <Form.Group className="location-field">
                                <Form.Label>Dateable time period</Form.Label>
                                <div className="dateble-container">
                                  <Select
                                    value={era}
                                    onChange={(e) => eraHandler(e)}
                                    className="dateble-select"
                                    options={[
                                      { value: "CE", label: "CE" },
                                      { value: "BCE", label: "BCE" },
                                    ]}
                                    styles={{
                                      control: (provided) => ({
                                        ...provided,
                                        border: "1px solid #EEEEEE",
                                        boxShadow: "none",
                                        minWidth: "83px",
                                      }),
                                      placeholder: (styles) => ({
                                        ...styles,
                                        color:
                                          !checkPermission(
                                            "collection_change_object"
                                          ) && styles.color,
                                      }),
                                    }}
                                  />
                                  <div className="start-end-date-container">
                                    <Form.Control
                                      value={formik?.values?.period_start_date}
                                      name="dateable_time_period"
                                      type="text" // Change to text type to better handle input
                                      onKeyDown={(e) =>
                                        handleMinusPreventHandler(e)
                                      }
                                      onChange={(e) => startDateHandler(e)}
                                      placeholder="Starting year"
                                      maxLength={4} // Ensure the max length is 4 digits
                                      onWheel={(e) => e.target.blur()}
                                      inputMode="numeric" // Suggest numeric input on mobile devices
                                      pattern="\d{0,4}" // Ensure only 4 digits are allowed
                                    />

                                    <Form.Control
                                      value={formik?.values?.period_end_date}
                                      name="dateable_time_period"
                                      type="text"
                                      onKeyDown={(e) =>
                                        handleMinusPreventHandler(e)
                                      }
                                      onChange={(e) => endDateHandler(e)}
                                      placeholder="Ending year"
                                      maxLength={4}
                                      onWheel={(e) => e.target.blur()}
                                      inputMode="numeric"
                                      pattern="\d{0,4}"
                                    />
                                  </div>
                                </div>
                              </Form.Group>
                            </Col>
                            <Col lg={4}>
                              <Form.Group className="location-field">
                                <Form.Label>Acquisition method</Form.Label>
                                <AsyncSelect
                                  value={formik.values.selectedAcquistion}
                                  defaultOptions={[
                                    { value: "Donation", label: "Donation" },
                                    { value: "Borrowed", label: "Borrowed" },
                                    { value: "Loan", label: "Loan" },
                                  ]}
                                  type="text"
                                  placeholder="Select"
                                  onChange={acquistionHandler}
                                  styles={{
                                    control: (styles) => ({
                                      ...styles,
                                      border:
                                        formik?.errors?.acquisition_method &&
                                        !!formik?.touched?.acquisition_method
                                          ? "1px solid red"
                                          : "",
                                      backgroundColor: !checkPermission(
                                        "collection_change_object"
                                      )
                                        ? "white"
                                        : "white",
                                      placeholder: (styles) => ({
                                        ...styles,
                                        color:
                                          !checkPermission(
                                            "collection_change_object"
                                          ) && styles.color,
                                      }),
                                    }),
                                  }}
                                />
                                {formik?.touched?.acquisition_method &&
                                  formik?.errors?.acquisition_method && (
                                    <span className="text-danger">
                                      {formik?.errors?.acquisition_method}
                                    </span>
                                  )}
                              </Form.Group>
                            </Col>
                          </Row>
                        </div>
                      </Accordion.Body>
                    </Accordion.Item>
                  </Accordion>
                  <Accordion>
                    <Accordion.Item>
                      <Accordion.Header
                        style={{
                          borderBottom: "1px solid lightgray",
                          zIndex: 0,
                          position: "relative",
                        }}
                      >
                        <h6 style={{ paddingBottom: "0px", fontWeight: "600" }}>
                          Function or usage
                        </h6>
                      </Accordion.Header>
                      <Accordion.Body className="collection-accordion-body">
                        <div className="function-field-box">
                          <Row>
                            <Col lg={4}>
                              <div>
                                <div style={{ display: "flex" }}>
                                  <p>Function or usage</p>

                                  <Tooltip
                                    placement="top"
                                    title="Add function or usage and press 'Enter' to save"
                                  >
                                    <div>
                                      <RiInformation2Fill
                                        style={{
                                          color: "#20409A",
                                          marginLeft: "5px",
                                        }}
                                      />
                                    </div>
                                  </Tooltip>
                                </div>
                                <div className="function-box">
                                  <Form.Control
                                    as="textarea"
                                    maxLength={100}
                                    value={enteredFunction}
                                    placeholder="Enter function or usage"
                                    rows={4}
                                    onChange={handleFunctionChange}
                                    onKeyDown={(e) => {
                                      if (enteredFunction.trim() !== "") {
                                        handleFunctionKeyDownHandler(e);
                                      } else if (e.key === "Enter") {
                                        e.preventDefault(); // Prevents empty entry on Enter key press
                                      }
                                    }}
                                  />
                                  {formik.values?.function_or_usages.map(
                                    (fun, indexFun) => (
                                      <Chip
                                        variant="outlined"
                                        className="custom-chip"
                                        label={fun.function_or_usage}
                                        onDelete={() =>
                                          functionDeleteHandler(indexFun)
                                        }
                                        deleteIcon={<IoMdClose />}
                                      />
                                    )
                                  )}
                                </div>
                              </div>
                            </Col>
                            <Col className="common-margin-fields" lg={6}>
                              <Form.Group className="location-field">
                                <Form.Label>Additional notes</Form.Label>
                                <Form.Control
                                  maxLength={2000}
                                  value={formik.values.additional_notes}
                                  className="detailed-description"
                                  name="additional_notes"
                                  onChange={(e) => {
                                    formik.handleChange(e);
                                    setIsAutoSave(true);
                                  }}
                                  as="textarea"
                                  placeholder="Additional notes"
                                  cols={5}
                                  rows={5}
                                  style={{ height: "121px" }}
                                />

                                <p
                                  className="maximum-line"
                                  style={{ justifyContent: "flex-end" }}
                                >
                                  {`Maximum character ${
                                    formik.values?.additional_notes?.length
                                      ? formik?.values?.additional_notes?.length
                                      : 0
                                  }/${maxLength ? maxLength : 0}`}{" "}
                                </p>
                              </Form.Group>
                            </Col>
                          </Row>
                          <Row>
                            <Col lg={6}>
                              <Form.Group className="location-field">
                                <Form.Label>Historical description</Form.Label>
                                <Form.Control
                                  as="textarea"
                                  value={formik.values.historical_description}
                                  onChange={(e) => {
                                    formik.handleChange(e);
                                    setIsAutoSave(true);
                                  }}
                                  name={`historical_description`}
                                  type="text"
                                  placeholder="Historical description"
                                  isInvalid={
                                    formik.touched?.historical_description &&
                                    !!formik?.errors?.historical_description
                                  }
                                />
                                <Form.Control.Feedback type="invalid">
                                  {formik?.errors?.historical_description}
                                </Form.Control.Feedback>
                              </Form.Group>
                            </Col>
                            <Col className="common-margin-fields" lg={6}>
                              <Form.Group className="location-field">
                                <Form.Label>Technique</Form.Label>
                                <Form.Control
                                  as="textarea"
                                  value={formik.values.technique}
                                  onChange={(e) => {
                                    formik.handleChange(e);
                                    setIsAutoSave(true);
                                  }}
                                  name={`technique`}
                                  type="text"
                                  placeholder="Technique"
                                  isInvalid={
                                    formik.touched?.technique &&
                                    !!formik?.errors?.technique
                                  }
                                />
                                <Form.Control.Feedback type="invalid">
                                  {formik?.errors?.technique}
                                </Form.Control.Feedback>
                              </Form.Group>
                            </Col>
                            <Col lg={6} style={{ marginTop: "20px" }}>
                              <Form.Group className="location-field">
                                <Form.Label>Cultural significance</Form.Label>
                                <Form.Control
                                  as="textarea"
                                  value={formik.values.cultural_significance}
                                  onChange={(e) => {
                                    formik.handleChange(e);
                                    setIsAutoSave(true);
                                  }}
                                  name={`cultural_significance`}
                                  type="text"
                                  placeholder="Cultural significance"
                                  isInvalid={
                                    formik.touched?.cultural_significance &&
                                    !!formik?.errors?.cultural_significance
                                  }
                                />
                                <Form.Control.Feedback type="invalid">
                                  {formik?.errors?.cultural_significance}
                                </Form.Control.Feedback>
                              </Form.Group>
                            </Col>
                            <Col lg={6} style={{ marginTop: "20px" }}>
                              <Form.Group className="location-field">
                                <Form.Label>References/Bibliography</Form.Label>
                                <Form.Control
                                  as="textarea"
                                  value={formik.values.references}
                                  onChange={(e) => {
                                    formik.handleChange(e);
                                    setIsAutoSave(true);
                                  }}
                                  name={`references`}
                                  type="text"
                                  placeholder="References/Bibliography"
                                  isInvalid={
                                    formik.touched?.references &&
                                    !!formik?.errors?.references
                                  }
                                />
                                <Form.Control.Feedback type="invalid">
                                  {formik?.errors?.references}
                                </Form.Control.Feedback>
                              </Form.Group>
                            </Col>
                          </Row>
                        </div>
                      </Accordion.Body>
                    </Accordion.Item>
                  </Accordion>
                  <Accordion style={{ paddingBottom: "70px" }}>
                    <Accordion.Item>
                      <Accordion.Header
                        style={{
                          borderBottom: "1px solid lightgray",
                          zIndex: 0,
                          position: "relative",
                        }}
                      >
                        <h6 style={{ paddingBottom: "0px", fontWeight: "600" }}>
                          Ledger
                        </h6>
                      </Accordion.Header>
                      <Accordion.Body className="collection-accordion-body">
                        <Row style={{ marginTop: "20px" }}>
                          <Col lg={6}>
                            <Row>
                              <Col lg={4}>
                                <Form.Group>
                                  <Form.Label>Ledger number</Form.Label>
                                  <Select
                                    options={[
                                      {
                                        value: "1",
                                        label: "1",
                                      },
                                      {
                                        value: "2",
                                        label: "2",
                                      },
                                      {
                                        value: "3",
                                        label: "3",
                                      },
                                      {
                                        value: "4",
                                        label: "4",
                                      },
                                      {
                                        value: "5",
                                        label: "5",
                                      },
                                      {
                                        value: "6",
                                        label: "6",
                                      },
                                      {
                                        value: "7",
                                        label: "7",
                                      },
                                    ]}
                                    value={formik?.values?.selectedLedgerNumber}
                                    onChange={(e) => {
                                      setIsAutoSave(true);
                                      formik?.setValues({
                                        ...formik?.values,
                                        ledger_number: e?.value,
                                        selectedLedgerNumber: e,
                                      });
                                    }}
                                  />
                                </Form.Group>
                              </Col>
                              <Col lg={5} className="common-margin-fields">
                                <Form.Group>
                                  <Form.Label>Ledger image</Form.Label>

                                  <div
                                    style={{ display: "flex" }}
                                    className="customize-refer-image"
                                  >
                                    <div className={`btn-upload `}>
                                      {formik?.values?.ledger_image ? (
                                        <img
                                          onClick={() => {
                                            setShowEnlargeImage({
                                              show: true,
                                              isEdit: true,
                                              title: "Ledger image",
                                              imageIdTitle: "ledger-image",
                                              image:
                                                formik?.values?.ledger_image,
                                            });
                                          }}
                                          src={formik?.values?.ledger_image}
                                          style={{
                                            height: "150px",
                                            width: "150px",
                                            objectFit: "contain",
                                            borderRadius: "12px",
                                          }}
                                          alt="Ledger-image"
                                        />
                                      ) : (
                                        <div
                                          className={`upload-image `}
                                          style={{
                                            height: "150px",
                                            width: "150px",
                                          }}
                                          onClick={() =>
                                            document
                                              .querySelector(".ledger-image")
                                              .click()
                                          }
                                        >
                                          <img
                                            src={upload}
                                            alt="upload-image"
                                          />
                                          <p
                                            style={{
                                              textAlign: "center",
                                              fontSize: "13px",
                                            }}
                                          >
                                            Click to upload
                                          </p>
                                        </div>
                                      )}
                                    </div>
                                    <Form.Control
                                      style={{ display: "none" }}
                                      type="file"
                                      className="ledger-image"
                                      name={`ledger_image`}
                                      onChange={(e) =>
                                        ledgerImageHandler(e, "ledger")
                                      }
                                      accept=".jpeg,.jpg,.png"
                                    />
                                  </div>
                                </Form.Group>
                              </Col>
                            </Row>
                          </Col>
                          <Col lg={6}>
                            <Row>
                              <Col lg={4}>
                                <Form.Group>
                                  <Form.Label>Page number</Form.Label>
                                  <Form.Control
                                    placeholder="Page number"
                                    type="text"
                                    value={formik?.values?.page_number}
                                    name={`page_number`}
                                    isInvalid={hasLetter.pageNumber}
                                    onChange={(e) => {
                                      const value = e.target.value;

                                      // Allow empty or numeric values only
                                      if (/^\d*$/.test(value)) {
                                        formik.handleChange(e);
                                        sethasletter({
                                          ...hasLetter,
                                          pageNumber: false,
                                        });
                                      } else {
                                        sethasletter({
                                          ...hasLetter,
                                          pageNumber: true,
                                        });
                                      }

                                      setIsAutoSave(true);
                                    }}
                                  />
                                  {hasLetter.pageNumber && (
                                    <Form.Control.Feedback type="invalid">
                                      Only numbers are allowed
                                    </Form.Control.Feedback>
                                  )}
                                </Form.Group>
                                <Form.Group style={{ marginTop: "20px" }}>
                                  <Form.Label>Old accession number</Form.Label>
                                  <Form.Control
                                    placeholder="Old accession number"
                                    type="text"
                                    value={formik?.values?.old_accession_number}
                                    name={`old_accession_number`}
                                    onChange={(e) => {
                                      formik.handleChange(e);
                                      setIsAutoSave(true);
                                    }}
                                  />
                                </Form.Group>
                              </Col>
                              <Col lg={5} className="common-margin-fields">
                                <Form.Group>
                                  <Form.Label>Page image</Form.Label>

                                  <div
                                    style={{ display: "flex" }}
                                    className="customize-refer-image"
                                  >
                                    <div className={`btn-upload }`}>
                                      {formik?.values?.page_image ? (
                                        <img
                                          onClick={() => {
                                            setShowEnlargeImage({
                                              show: true,
                                              isEdit: true,
                                              title: "Page image",
                                              imageIdTitle: "page-image",
                                              image: formik?.values?.page_image,
                                            });
                                          }}
                                          src={formik?.values?.page_image}
                                          style={{
                                            height: "150px",
                                            width: "150px",
                                            borderRadius: "12px",
                                            objectFit: "contain",
                                          }}
                                          alt="Page-image"
                                        />
                                      ) : (
                                        <div
                                          className={`upload-image `}
                                          style={{
                                            height: "150px",
                                            width: "150px",
                                          }}
                                          onClick={() =>
                                            document
                                              .querySelector(".page-image")
                                              .click()
                                          }
                                        >
                                          <img
                                            src={upload}
                                            alt="upload-image"
                                          />
                                          <p
                                            style={{
                                              textAlign: "center",
                                              fontSize: "13px",
                                            }}
                                          >
                                            Click to upload
                                          </p>
                                        </div>
                                      )}
                                    </div>
                                    <Form.Control
                                      style={{ display: "none" }}
                                      type="file"
                                      className="page-image"
                                      name={`page_image`}
                                      onChange={(e) =>
                                        ledgerImageHandler(e, "page")
                                      }
                                      accept=".jpeg,.jpg,.png"
                                    />
                                  </div>
                                </Form.Group>
                              </Col>
                            </Row>
                          </Col>
                        </Row>

                        <Row style={{ marginTop: "20px" }}>
                          <Col lg={4}>
                            <Form.Group>
                              <Form.Label>Ledger entry description</Form.Label>
                              <Form.Control
                                rows={4}
                                placeholder="Ledger entry description"
                                as="textarea"
                                value={formik?.values?.ledger_description}
                                name={`ledger_description`}
                                onChange={(e) => {
                                  formik.handleChange(e);
                                  setIsAutoSave(true);
                                }}
                              />
                            </Form.Group>
                          </Col>
                          <Col lg={4} className="common-margin-fields">
                            <Form.Group>
                              <Form.Label>Ledger entry translation</Form.Label>
                              <Form.Control
                                rows={4}
                                placeholder="Ledger entry translation"
                                as="textarea"
                                value={formik?.values?.ledger_translation}
                                name={`ledger_translation`}
                                onChange={(e) => {
                                  formik.handleChange(e);
                                  setIsAutoSave(true);
                                }}
                              />
                            </Form.Group>
                          </Col>
                          <Col lg={4} className="common-margin-fields">
                            <Form.Group>
                              <Form.Label>Ledger notes</Form.Label>
                              <Form.Control
                                rows={4}
                                placeholder="Ledger notes"
                                as="textarea"
                                value={formik?.values?.ledger_notes}
                                name={`ledger_notes`}
                                onChange={(e) => {
                                  formik.handleChange(e);
                                  setIsAutoSave(true);
                                }}
                              />
                            </Form.Group>
                          </Col>
                        </Row>
                        <Row
                          className="ledger-entry-container"
                          style={{ marginTop: "20px" }}
                        >
                          <Form.Label>Ledger entry images</Form.Label>

                          <div
                            style={{
                              display: "flex",
                              gap: "10px",
                              flexWrap: "wrap",
                              alignItems: "center",
                            }}
                            className="leger-photo-container"
                          >
                            <div
                              className="img-adding-div conservat-img-div ledger-img-div "
                              onClick={addEntryImageHandler}
                            >
                              <HiOutlinePlus size={40} color="#092159e4" />
                            </div>

                            {formik?.values?.ledger_entry_images?.map(
                              (liEntry, index) =>
                                liEntry?.entry_image ? (
                                  <div
                                    style={{
                                      position: "relative",
                                      border: "1px solid #EEEEEE",
                                      borderRadius: "12px",
                                      padding: "5px",
                                    }}
                                    className="ledger-img-upload"
                                  >
                                    <img
                                      onClick={() => {
                                        setShowEnlargeImage({
                                          show: true,
                                          image: liEntry.entry_image,
                                          isEdit: true,
                                          imageIndex: index,
                                          imageIdTitle: "photo-entry",
                                          title: "Entry image",
                                        });
                                      }}
                                      className="ledger-img-upload-img"
                                      key={index}
                                      src={liEntry.entry_image}
                                      alt="entry"
                                    />

                                    <div
                                      className="delete_icon-cons"
                                      onClick={() =>
                                        removeEntryImageHandler(index)
                                      }
                                      style={{
                                        position: "absolute",
                                        backgroundColor: "rgb(32, 64, 154)",
                                        color: "#fff",
                                        cursor: "pointer",
                                        right: "0",
                                        top: "-7px",
                                        borderRadius: "50%",
                                        display: "flex",
                                      }}
                                    >
                                      <RiCloseFill
                                        // onClick={() => imageDeleteHandler(indexImage)}
                                        size={15}
                                        style={{
                                          strokeWidth: 2,
                                        }}
                                      />
                                    </div>

                                    <Form.Control
                                      type="file"
                                      accept="image/*"
                                      id={`photo-entry-${index}`}
                                      style={{ display: "none" }}
                                      onChange={(e) => {
                                        entryImageChangehandler(e, index);
                                      }}
                                    />
                                  </div>
                                ) : (
                                  <div
                                    style={{
                                      position: "relative",
                                    }}
                                  >
                                    <div
                                      key={index}
                                      onClick={() =>
                                        document
                                          .getElementById(
                                            `photo-entry-${index}`
                                          )
                                          .click()
                                      }
                                      className="img-upload ledger-img-upload ledger-no-img"
                                    >
                                      <div className="replace-logo-div">
                                        <img
                                          className="replace-logo"
                                          src={replace}
                                          alt="placeholder"
                                        />
                                      </div>
                                    </div>
                                    <Form.Control
                                      type="file"
                                      accept="image/*"
                                      id={`photo-entry-${index}`}
                                      style={{ display: "none" }}
                                      onChange={(e) => {
                                        entryImageChangehandler(e, index);
                                      }}
                                    />
                                    <div
                                      className="delete_icon-cons"
                                      onClick={() =>
                                        removeEntryImageHandler(index)
                                      }
                                      style={{
                                        position: "absolute",
                                        backgroundColor: "rgb(32, 64, 154)",
                                        color: "#fff",
                                        cursor: "pointer",
                                        right: "-5px",
                                        top: "-7px",
                                        borderRadius: "50%",
                                        display: "flex",
                                      }}
                                    >
                                      <RiCloseFill
                                        // onClick={() => imageDeleteHandler(indexImage)}
                                        size={15}
                                        style={{
                                          strokeWidth: 2,
                                        }}
                                      />
                                    </div>
                                  </div>
                                )
                            )}
                          </div>
                        </Row>
                      </Accordion.Body>
                    </Accordion.Item>
                  </Accordion>
                </div>

                <Row style={{ marginRight: "2px" }}>
                  <div className="submit-btn-row" style={{ flexWrap: "wrap" }}>
                    <div
                      style={{
                        display: "flex",
                        gap: "20px",
                        flexWrap: "wrap",
                        justifyContent: "end",
                      }}
                    >
                      <Button
                        style={{ height: "35px" }}
                        className="discard-btn"
                        onClick={() => handleBack("discard")}
                      >
                        Discard changes
                      </Button>
                      <Button
                        className="discard-btn"
                        type="button"
                        onClick={draftHandler}
                        disabled={buttonloader && draftLoad}
                        style={{ minWidth: "132px", height: "35px" }}
                      >
                        {" "}
                        {buttonloader && draftLoad ? (
                          <SimpleBackdrop />
                        ) : (
                          "Save as draft"
                        )}
                      </Button>
                    </div>
                    {id ? (
                      <Button
                        className="submit-btn"
                        type="submit"
                        disabled={buttonloader && submitLoader}
                      >
                        {buttonloader && submitLoader ? (
                          <SimpleBackdrop />
                        ) : (
                          "Update"
                        )}
                      </Button>
                    ) : (
                      <Button
                        className="submit-btn"
                        type="submit"
                        disabled={buttonloader && submitLoader}
                      >
                        {buttonloader && submitLoader ? (
                          <SimpleBackdrop />
                        ) : (
                          "Submit"
                        )}
                      </Button>
                    )}
                  </div>
                  <div
                    style={{
                      display: "flex",
                      gap: "10px",
                      justifyContent: "end",
                    }}
                  >
                    {Object.keys(formik?.errors).filter(
                      (key) => formik?.touched[key]
                    ).length > 0 && (
                      <p style={{ color: "red" }}>
                        One or more required fields are missing, Please complete
                        them before submitting.
                      </p>
                    )}
                  </div>
                </Row>
                {isOverRide && (
                  <OverRideAlert
                    setLoading={setLoading}
                    setIsOverRide={setIsOverRide}
                    isOverideLoad={isOverideLoad}
                    overRideCancel={overRideCancel}
                    overRideConfirmHandler={overRideConfirmHandler}
                  />
                )}

                <Commentdrawer
                  fromlist={fromList}
                  id={id}
                  isOpen={isOpen}
                  setIsOpen={setIsOpen}
                  toggleDrawer={toggleDrawer}
                />
                <Objecthistorydrawer
                  fromList={fromList}
                  id={id}
                  isOpenhistory={isOpenhistory}
                  setIsOpenhistory={setIsOpenhistory}
                  toggleDrawerhistory={toggleDrawerhistory}
                />
              </Form>
            </Container>
          </div>
        </section>
      )}
    </>
  );
};

export default ObjectAdd;
